import * as Apollo from "@apollo/client";
import { gql } from "@apollo/client";
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends " $fragmentName" | "__typename" ? T[P] : never };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string };
  String: { input: string; output: string };
  Boolean: { input: boolean; output: boolean };
  Int: { input: number; output: number };
  Float: { input: number; output: number };
  BigInt: { input: any; output: any };
  Date: { input: any; output: any };
  DateTime: { input: any; output: any };
  DateTimeRangeScalar: { input: any; output: any };
  Decimal: { input: any; output: any };
  GenericScalar: { input: any; output: any };
  JSONString: { input: any; output: any };
  NotEmptyID: { input: any; output: any };
  Time: { input: any; output: any };
  Upload: { input: any; output: any };
};

/** An enumeration. */
export enum AcademyCourseResultStatusChoices {
  /** Completed */
  COMPLETED = "COMPLETED",
  /** Failed */
  FAILED = "FAILED",
  /** In Progress */
  IN_PROGRESS = "IN_PROGRESS",
  /** Not Started */
  NOT_STARTED = "NOT_STARTED",
}

export type AcademyMutation = {
  __typename?: "AcademyMutation";
  startCourse?: Maybe<CourseResultCreateMutation>;
};

export type AcademyMutationStartCourseArgs = {
  input: UpdateCourseResultInput;
};

export type AcademyQuery = {
  __typename?: "AcademyQuery";
  courses?: Maybe<CourseNodeConnection>;
};

export type AcademyQueryCoursesArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>;
  before?: InputMaybe<Scalars["String"]["input"]>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  results_Status?: InputMaybe<AcademyCourseResultStatusChoices>;
};

export type AcceptJobSuggestionMutation = {
  __typename?: "AcceptJobSuggestionMutation";
  created?: Maybe<Scalars["Boolean"]["output"]>;
  jobPositionAssignment?: Maybe<JobPositionAssignmentNode>;
};

export type AccessType = {
  __typename?: "AccessType";
  id: Scalars["ID"]["output"];
  slug: Scalars["String"]["output"];
  title?: Maybe<Scalars["String"]["output"]>;
};

export type AccountMutation = {
  __typename?: "AccountMutation";
  admin?: Maybe<AdminMutation>;
  canadaVisa?: Maybe<CanadaVisaMutation>;
  certificateAndLicense?: Maybe<CertificateAndLicenseMutation>;
  education?: Maybe<EducationMutation>;
  employment?: Maybe<EmploymentMutation>;
  googleAuth?: Maybe<GoogleAuth>;
  languageCertificate?: Maybe<LanguageCertificateMutation>;
  linkedinAuth?: Maybe<LinkedInAuth>;
  organization?: Maybe<OrganizationMutation>;
  passwordReset?: Maybe<PasswordReset>;
  performOnboardingJobSuggestion?: Maybe<PerformOnboardingJobSuggestionMutation>;
  profile?: Maybe<ProfileMutation>;
  refreshToken?: Maybe<RefreshToken>;
  register?: Maybe<UserRegister>;
  resendActivationEmail?: Maybe<ResendActivationEmail>;
  revokeToken?: Maybe<RevokeTokenMutation>;
  sendPasswordResetEmail?: Maybe<SendPasswordResetEmail>;
  supportTicket?: Maybe<SupportTicketMutation>;
  tokenAuth?: Maybe<ObtainJsonWebToken>;
  verify?: Maybe<VerifyAccount>;
  workExperience?: Maybe<WorkExperienceMutation>;
};

export type AccountMutationGoogleAuthArgs = {
  accessToken: Scalars["String"]["input"];
  deviceId: Scalars["String"]["input"];
  jobReferralCode?: InputMaybe<Scalars["String"]["input"]>;
  referralCode?: InputMaybe<Scalars["String"]["input"]>;
};

export type AccountMutationLinkedinAuthArgs = {
  code: Scalars["String"]["input"];
  deviceId: Scalars["String"]["input"];
  jobReferralCode?: InputMaybe<Scalars["String"]["input"]>;
  redirectUri: Scalars["String"]["input"];
  referralCode?: InputMaybe<Scalars["String"]["input"]>;
};

export type AccountMutationPasswordResetArgs = {
  gRecaptchaToken: Scalars["String"]["input"];
  newPassword1: Scalars["String"]["input"];
  newPassword2: Scalars["String"]["input"];
  token: Scalars["String"]["input"];
};

export type AccountMutationPerformOnboardingJobSuggestionArgs = {
  industry: Scalars["ID"]["input"];
  interestedJobs: Array<InputMaybe<Scalars["ID"]["input"]>>;
};

export type AccountMutationRefreshTokenArgs = {
  refreshToken?: InputMaybe<Scalars["String"]["input"]>;
};

export type AccountMutationRegisterArgs = {
  email: Scalars["String"]["input"];
  emailCallbackUrl: Scalars["String"]["input"];
  firstName: Scalars["String"]["input"];
  gRecaptchaToken: Scalars["String"]["input"];
  jobReferralCode?: InputMaybe<Scalars["String"]["input"]>;
  lastName: Scalars["String"]["input"];
  referralCode?: InputMaybe<Scalars["String"]["input"]>;
  token?: InputMaybe<Scalars["String"]["input"]>;
};

export type AccountMutationResendActivationEmailArgs = {
  email: Scalars["String"]["input"];
  emailCallbackUrl: Scalars["String"]["input"];
  gRecaptchaToken: Scalars["String"]["input"];
};

export type AccountMutationRevokeTokenArgs = {
  refreshToken?: InputMaybe<Scalars["String"]["input"]>;
};

export type AccountMutationSendPasswordResetEmailArgs = {
  email: Scalars["String"]["input"];
  emailCallbackUrl: Scalars["String"]["input"];
  gRecaptchaToken: Scalars["String"]["input"];
};

export type AccountMutationTokenAuthArgs = {
  deviceId: Scalars["String"]["input"];
  email?: InputMaybe<Scalars["String"]["input"]>;
  gRecaptchaToken: Scalars["String"]["input"];
  password: Scalars["String"]["input"];
};

export type AccountMutationVerifyArgs = {
  token: Scalars["String"]["input"];
};

export type AdminAssessmentType = {
  __typename?: "AdminAssessmentType";
  description: Scalars["String"]["output"];
  id: Scalars["String"]["output"];
  remainingQuestions: Scalars["Int"]["output"];
  results?: Maybe<Array<Maybe<OrganizationAssessmentResultType>>>;
  skill?: Maybe<AssessmentSkillType>;
  status: Status;
  title: Scalars["String"]["output"];
  totalEstimatedTime: Scalars["Int"]["output"];
  totalQuestions: Scalars["Int"]["output"];
};

export type AdminCanadaVisaType = {
  __typename?: "AdminCanadaVisaType";
  citizenshipDocument?: Maybe<CitizenshipDocumentFileType>;
  id: Scalars["ID"]["output"];
  nationality?: Maybe<CountryNode>;
  status: AuthAccountCanadaVisaStatusChoices;
};

export type AdminCooperationType = {
  __typename?: "AdminCooperationType";
  createdAt: Scalars["DateTime"]["output"];
  endAt?: Maybe<Scalars["DateTime"]["output"]>;
  id: Scalars["ID"]["output"];
  jobPosition?: Maybe<AdminJobPositionNode>;
  platformMessages?: Maybe<OrganizationPlatformMessageNodeConnection>;
  startAt?: Maybe<Scalars["DateTime"]["output"]>;
  status: AuthAccountOrganizationEmployeeCooperationStatusChoices;
};

export type AdminCooperationTypePlatformMessagesArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>;
  before?: InputMaybe<Scalars["String"]["input"]>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
};

export type AdminJobPositionAssignmentNode = {
  __typename?: "AdminJobPositionAssignmentNode";
  createdAt: Scalars["DateTime"]["output"];
  id: Scalars["ID"]["output"];
  interviews?: Maybe<Array<Maybe<JobPositionInterviewType>>>;
  jobPosition?: Maybe<AdminJobPositionNode>;
  jobSeeker?: Maybe<JobSeekerType>;
  status: AuthAccountJobPositionAssignmentStatusChoices;
  statusHistories?: Maybe<Array<Maybe<JobPositionAssignmentStatusHistoryType>>>;
};

export type AdminJobPositionAssignmentNodeConnection = {
  __typename?: "AdminJobPositionAssignmentNodeConnection";
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<AdminJobPositionAssignmentNodeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars["Int"]["output"]>;
};

/** A Relay edge containing a `AdminJobPositionAssignmentNode` and its cursor. */
export type AdminJobPositionAssignmentNodeEdge = {
  __typename?: "AdminJobPositionAssignmentNodeEdge";
  /** A cursor for use in pagination */
  cursor: Scalars["String"]["output"];
  /** The item at the end of the edge */
  node?: Maybe<AdminJobPositionAssignmentNode>;
};

export type AdminJobPositionNode = {
  __typename?: "AdminJobPositionNode";
  ageRange?: Maybe<Array<Scalars["Int"]["output"]>>;
  assignments?: Maybe<AdminJobPositionAssignmentNodeConnection>;
  assignmentsStatusCounts?: Maybe<JobPositionAssignmentStatusCountsType>;
  benefits?: Maybe<Array<JobBenefitType>>;
  cities: CityNodeConnection;
  contractType?: Maybe<AuthAccountOrganizationJobPositionContractTypeChoices>;
  daysOff?: Maybe<Array<Maybe<AuthAccountOrganizationJobPositionDaysOffChoices>>>;
  degrees?: Maybe<Array<Maybe<AuthAccountOrganizationJobPositionDegreesChoices>>>;
  description?: Maybe<Scalars["String"]["output"]>;
  employerQuestions?: Maybe<Array<Scalars["String"]["output"]>>;
  fields?: Maybe<Array<FieldType>>;
  hiringInCanada?: Maybe<Scalars["Boolean"]["output"]>;
  id: Scalars["ID"]["output"];
  interviewSlots: Array<JobPositionInterviewSlotType>;
  isEditable?: Maybe<Scalars["Boolean"]["output"]>;
  jobRestrictions?: Maybe<Scalars["String"]["output"]>;
  languages?: Maybe<Array<Maybe<AuthAccountOrganizationJobPositionLanguagesChoices>>>;
  locationType?: Maybe<AuthAccountOrganizationJobPositionLocationTypeChoices>;
  nativeLanguages?: Maybe<Array<Maybe<AuthAccountOrganizationJobPositionNativeLanguagesChoices>>>;
  organization?: Maybe<OrganizationType>;
  otherBenefits?: Maybe<Array<Scalars["String"]["output"]>>;
  paymentTerm?: Maybe<AuthAccountOrganizationJobPositionPaymentTermChoices>;
  performanceExpectation?: Maybe<Scalars["String"]["output"]>;
  report?: Maybe<OrganizationJobPositionReportType>;
  requiredDocuments?: Maybe<Array<Scalars["String"]["output"]>>;
  salaryRange?: Maybe<Array<Scalars["Int"]["output"]>>;
  skills?: Maybe<Array<SkillType>>;
  startAt?: Maybe<Scalars["Date"]["output"]>;
  status: AuthAccountOrganizationJobPositionStatusChoices;
  title?: Maybe<Scalars["String"]["output"]>;
  vaccancy?: Maybe<Scalars["Int"]["output"]>;
  validityDate?: Maybe<Scalars["Date"]["output"]>;
  validityDays?: Maybe<Scalars["Int"]["output"]>;
  workExperienceYearsRange?: Maybe<Array<Scalars["Int"]["output"]>>;
  workingEndAt?: Maybe<Scalars["Time"]["output"]>;
  workingStartAt?: Maybe<Scalars["Time"]["output"]>;
};

export type AdminJobPositionNodeAssignmentsArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>;
  before?: InputMaybe<Scalars["String"]["input"]>;
  createdAt_Gte?: InputMaybe<Scalars["DateTime"]["input"]>;
  createdAt_Lte?: InputMaybe<Scalars["DateTime"]["input"]>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  id?: InputMaybe<Scalars["ID"]["input"]>;
  jobPosition_Status_In?: InputMaybe<Array<InputMaybe<AuthAccountOrganizationJobPositionStatusChoices>>>;
  jobSeekerFullName?: InputMaybe<Scalars["String"]["input"]>;
  jobSeeker_Id_In?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  jobSeeker_Profile_Score_Gte?: InputMaybe<Scalars["Int"]["input"]>;
  jobSeeker_Profile_Score_Lte?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<AuthAccountJobPositionAssignmentOrderByChoices>;
  status_In?: InputMaybe<Array<InputMaybe<AuthAccountJobPositionAssignmentStatusChoices>>>;
};

export type AdminJobPositionNodeCitiesArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>;
  before?: InputMaybe<Scalars["String"]["input"]>;
  country_Code2?: InputMaybe<Scalars["String"]["input"]>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  id?: InputMaybe<Scalars["ID"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  name_Icontains?: InputMaybe<Scalars["String"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  region?: InputMaybe<Scalars["ID"]["input"]>;
};

export type AdminJobPositionNodeConnection = {
  __typename?: "AdminJobPositionNodeConnection";
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<AdminJobPositionNodeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars["Int"]["output"]>;
};

/** A Relay edge containing a `AdminJobPositionNode` and its cursor. */
export type AdminJobPositionNodeEdge = {
  __typename?: "AdminJobPositionNodeEdge";
  /** A cursor for use in pagination */
  cursor: Scalars["String"]["output"];
  /** The item at the end of the edge */
  node?: Maybe<AdminJobPositionNode>;
};

export type AdminJobPositionStatusUpdateInput = {
  status: AuthAccountOrganizationJobPositionStatusChoices;
};

export type AdminJobPositionStatusUpdateMutation = {
  __typename?: "AdminJobPositionStatusUpdateMutation";
  organizationJobPosition?: Maybe<AdminJobPositionNode>;
};

export type AdminJobSeekerType = {
  __typename?: "AdminJobSeekerType";
  assessments?: Maybe<Array<Maybe<AdminAssessmentType>>>;
  canadaVisa?: Maybe<AdminCanadaVisaType>;
  certificateandlicenses?: Maybe<Array<JobSeekerCertificateAndLicenseType>>;
  cv?: Maybe<JobSeekerGeneratedCvType>;
  dateJoined: Scalars["DateTime"]["output"];
  educations?: Maybe<Array<JobSeekerEducationType>>;
  email: Scalars["String"]["output"];
  firstName: Scalars["String"]["output"];
  id: Scalars["ID"]["output"];
  languagecertificates?: Maybe<Array<JobSeekerLanguageCertificateType>>;
  lastName: Scalars["String"]["output"];
  profile?: Maybe<ProfileType>;
  resume?: Maybe<ResumeType>;
  workexperiences?: Maybe<Array<JobSeekerWorkExperienceType>>;
};

export type AdminJobSeekerTypeConnection = {
  __typename?: "AdminJobSeekerTypeConnection";
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<AdminJobSeekerTypeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars["Int"]["output"]>;
};

/** A Relay edge containing a `AdminJobSeekerType` and its cursor. */
export type AdminJobSeekerTypeEdge = {
  __typename?: "AdminJobSeekerTypeEdge";
  /** A cursor for use in pagination */
  cursor: Scalars["String"]["output"];
  /** The item at the end of the edge */
  node?: Maybe<AdminJobSeekerType>;
};

export type AdminMutation = {
  __typename?: "AdminMutation";
  acceptJobSuggestion?: Maybe<AcceptJobSuggestionMutation>;
  assignJob?: Maybe<AssignJobMutation>;
  hijack?: Maybe<HijackUserMutation>;
  setOrganizationContacts?: Maybe<AdminSetOrganizationContactsMutation>;
  triggerJobSuggestion?: Maybe<TriggerJobSuggestionMutation>;
  unassignJob?: Maybe<UnassignJobMutation>;
  updateJobPositionStatus?: Maybe<AdminJobPositionStatusUpdateMutation>;
  updateOrganization?: Maybe<AdminOrganizationUpdateMutation>;
  updateOrganizationStatus?: Maybe<AdminOrganizationStatusUpdateMutation>;
};

export type AdminMutationAcceptJobSuggestionArgs = {
  suggestionItemId: Scalars["ID"]["input"];
};

export type AdminMutationAssignJobArgs = {
  jobPositionId: Scalars["ID"]["input"];
  userId: Scalars["ID"]["input"];
};

export type AdminMutationHijackArgs = {
  userId: Scalars["ID"]["input"];
};

export type AdminMutationSetOrganizationContactsArgs = {
  input: Array<InputMaybe<AdminSetOrganizationContactableInput>>;
};

export type AdminMutationTriggerJobSuggestionArgs = {
  jobPositionId: Scalars["ID"]["input"];
};

export type AdminMutationUnassignJobArgs = {
  id: Scalars["ID"]["input"];
};

export type AdminMutationUpdateJobPositionStatusArgs = {
  id: Scalars["ID"]["input"];
  input: AdminJobPositionStatusUpdateInput;
};

export type AdminMutationUpdateOrganizationArgs = {
  id: Scalars["ID"]["input"];
  input: PatchOrganizationInput;
};

export type AdminMutationUpdateOrganizationStatusArgs = {
  id: Scalars["ID"]["input"];
  input: AdminOrganizationStatusUpdateInput;
};

export type AdminOrganizationEmployeeNode = {
  __typename?: "AdminOrganizationEmployeeNode";
  cooperation?: Maybe<AdminCooperationType>;
  employee?: Maybe<EmployeeType>;
  id: Scalars["ID"]["output"];
};

export type AdminOrganizationEmployeeNodeConnection = {
  __typename?: "AdminOrganizationEmployeeNodeConnection";
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<AdminOrganizationEmployeeNodeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars["Int"]["output"]>;
};

/** A Relay edge containing a `AdminOrganizationEmployeeNode` and its cursor. */
export type AdminOrganizationEmployeeNodeEdge = {
  __typename?: "AdminOrganizationEmployeeNodeEdge";
  /** A cursor for use in pagination */
  cursor: Scalars["String"]["output"];
  /** The item at the end of the edge */
  node?: Maybe<AdminOrganizationEmployeeNode>;
};

export type AdminOrganizationNode = {
  __typename?: "AdminOrganizationNode";
  about?: Maybe<Scalars["String"]["output"]>;
  assessments?: Maybe<Array<Maybe<AdminAssessmentType>>>;
  businessType?: Maybe<AuthAccountOrganizationBusinessTypeChoices>;
  city?: Maybe<CityNode>;
  communicateorganizationmethod?: Maybe<CommunicateOrganizationMethodType>;
  contacts?: Maybe<Array<Maybe<ContactType>>>;
  dnstxtrecordmethod?: Maybe<DnstxtRecordMethodType>;
  email?: Maybe<Scalars["String"]["output"]>;
  employeeCooperationStatusCounts?: Maybe<OrganizationEmployeeCooperationStatusCountsType>;
  establishedAt?: Maybe<Scalars["Date"]["output"]>;
  hasFinancialData?: Maybe<Scalars["Boolean"]["output"]>;
  id: Scalars["ID"]["output"];
  industry?: Maybe<IndustryNode>;
  jobPositionLocationTypeCounts?: Maybe<JobPositionLocationTypeCountsType>;
  jobPositions?: Maybe<AdminJobPositionNodeConnection>;
  jobPositionsStatusCounts?: Maybe<JobPositionStatusCountsType>;
  logo?: Maybe<OrganizationLogoFileType>;
  name: Scalars["String"]["output"];
  nationalNumber?: Maybe<Scalars["String"]["output"]>;
  organizationEmployees?: Maybe<AdminOrganizationEmployeeNodeConnection>;
  platformMessages?: Maybe<OrganizationPlatformMessageNodeConnection>;
  shortName?: Maybe<Scalars["String"]["output"]>;
  size?: Maybe<AuthAccountOrganizationSizeChoices>;
  status: AuthAccountOrganizationStatusChoices;
  type?: Maybe<AuthAccountOrganizationTypeChoices>;
  uploadcompanycertificatemethod?: Maybe<UploadCompanyCertificateMethodType>;
  uploadfiletowebsitemethod?: Maybe<UploadFileToWebsiteMethodType>;
  user?: Maybe<OrganizationMembershipUserType>;
};

export type AdminOrganizationNodeJobPositionsArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>;
  before?: InputMaybe<Scalars["String"]["input"]>;
  cities_DisplayName?: InputMaybe<Scalars["String"]["input"]>;
  cities_DisplayName_Icontains?: InputMaybe<Scalars["String"]["input"]>;
  cities_Id?: InputMaybe<Scalars["ID"]["input"]>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  id?: InputMaybe<Scalars["ID"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<AuthAccountOrganizationJobPositionOrderByChoices>;
  organization?: InputMaybe<Scalars["ID"]["input"]>;
  organization_Name_Icontains?: InputMaybe<Scalars["String"]["input"]>;
  startAt_Gte?: InputMaybe<Scalars["Date"]["input"]>;
  startAt_Lte?: InputMaybe<Scalars["Date"]["input"]>;
  status?: InputMaybe<AuthAccountOrganizationJobPositionStatusChoices>;
  title_Icontains?: InputMaybe<Scalars["String"]["input"]>;
};

export type AdminOrganizationNodeOrganizationEmployeesArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>;
  before?: InputMaybe<Scalars["String"]["input"]>;
  cooperations_JobPositionAssignment_JobPosition_Fields_Name_Icontains?: InputMaybe<Scalars["String"]["input"]>;
  cooperations_JobPositionAssignment_JobPosition_LocationType?: InputMaybe<AuthAccountOrganizationJobPositionLocationTypeChoices>;
  cooperations_Status?: InputMaybe<AuthAccountOrganizationEmployeeCooperationStatusChoices>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
};

export type AdminOrganizationNodePlatformMessagesArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>;
  before?: InputMaybe<Scalars["String"]["input"]>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
};

export type AdminOrganizationNodeConnection = {
  __typename?: "AdminOrganizationNodeConnection";
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<AdminOrganizationNodeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars["Int"]["output"]>;
};

/** A Relay edge containing a `AdminOrganizationNode` and its cursor. */
export type AdminOrganizationNodeEdge = {
  __typename?: "AdminOrganizationNodeEdge";
  /** A cursor for use in pagination */
  cursor: Scalars["String"]["output"];
  /** The item at the end of the edge */
  node?: Maybe<AdminOrganizationNode>;
};

export type AdminOrganizationStatisticsType = {
  __typename?: "AdminOrganizationStatisticsType";
  blockedCount?: Maybe<Scalars["Int"]["output"]>;
  completedCount?: Maybe<Scalars["Int"]["output"]>;
  draftedCount?: Maybe<Scalars["Int"]["output"]>;
  rejectedCount?: Maybe<Scalars["Int"]["output"]>;
  submittedCount?: Maybe<Scalars["Int"]["output"]>;
  totalCount?: Maybe<Scalars["Int"]["output"]>;
  verifiedCount?: Maybe<Scalars["Int"]["output"]>;
  withJobPositionsCount?: Maybe<Scalars["Int"]["output"]>;
};

export type AdminOrganizationStatusUpdateInput = {
  status?: InputMaybe<AuthAccountOrganizationStatusChoices>;
};

export type AdminOrganizationStatusUpdateMutation = {
  __typename?: "AdminOrganizationStatusUpdateMutation";
  organization?: Maybe<OrganizationType>;
};

export type AdminOrganizationUpdateMutation = {
  __typename?: "AdminOrganizationUpdateMutation";
  organization?: Maybe<AdminOrganizationNode>;
};

export type AdminQuery = {
  __typename?: "AdminQuery";
  certificateAndLicense?: Maybe<CertificateAndLicenseNode>;
  education?: Maybe<EducationNode>;
  jobPositionAssignments?: Maybe<AdminJobPositionAssignmentNodeConnection>;
  jobPositions?: Maybe<AdminJobPositionNodeConnection>;
  jobSeekers?: Maybe<AdminJobSeekerTypeConnection>;
  jobSuggestionResult?: Maybe<JobSuggestionResultNodeConnection>;
  languageCertificate?: Maybe<LanguageCertificateNode>;
  organizationStatistics?: Maybe<AdminOrganizationStatisticsType>;
  organizations?: Maybe<AdminOrganizationNodeConnection>;
  workExperience?: Maybe<WorkExperienceNode>;
};

export type AdminQueryCertificateAndLicenseArgs = {
  id: Scalars["NotEmptyID"]["input"];
};

export type AdminQueryEducationArgs = {
  id: Scalars["NotEmptyID"]["input"];
};

export type AdminQueryJobPositionAssignmentsArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>;
  before?: InputMaybe<Scalars["String"]["input"]>;
  createdAt_Gte?: InputMaybe<Scalars["DateTime"]["input"]>;
  createdAt_Lte?: InputMaybe<Scalars["DateTime"]["input"]>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  id?: InputMaybe<Scalars["ID"]["input"]>;
  jobPosition_Status_In?: InputMaybe<Array<InputMaybe<AuthAccountOrganizationJobPositionStatusChoices>>>;
  jobSeekerFullName?: InputMaybe<Scalars["String"]["input"]>;
  jobSeeker_Id_In?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  jobSeeker_Profile_Score_Gte?: InputMaybe<Scalars["Int"]["input"]>;
  jobSeeker_Profile_Score_Lte?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<AuthAccountJobPositionAssignmentOrderByChoices>;
  status_In?: InputMaybe<Array<InputMaybe<AuthAccountJobPositionAssignmentStatusChoices>>>;
};

export type AdminQueryJobPositionsArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>;
  before?: InputMaybe<Scalars["String"]["input"]>;
  cities_DisplayName?: InputMaybe<Scalars["String"]["input"]>;
  cities_DisplayName_Icontains?: InputMaybe<Scalars["String"]["input"]>;
  cities_Id?: InputMaybe<Scalars["ID"]["input"]>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  id?: InputMaybe<Scalars["ID"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<AuthAccountOrganizationJobPositionOrderByChoices>;
  organization?: InputMaybe<Scalars["ID"]["input"]>;
  organization_Name_Icontains?: InputMaybe<Scalars["String"]["input"]>;
  startAt_Gte?: InputMaybe<Scalars["Date"]["input"]>;
  startAt_Lte?: InputMaybe<Scalars["Date"]["input"]>;
  status?: InputMaybe<AuthAccountOrganizationJobPositionStatusChoices>;
  title_Icontains?: InputMaybe<Scalars["String"]["input"]>;
};

export type AdminQueryJobSeekersArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>;
  before?: InputMaybe<Scalars["String"]["input"]>;
  canadaVisa_Status_In?: InputMaybe<Array<InputMaybe<AuthAccountCanadaVisaStatusChoices>>>;
  educations_Degree_In?: InputMaybe<Array<InputMaybe<AuthAccountEducationDegreeChoices>>>;
  email_Icontains?: InputMaybe<Scalars["String"]["input"]>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  fluentLanguages?: InputMaybe<Array<InputMaybe<AuthAccountUserFluentLanguagesChoices>>>;
  fullName?: InputMaybe<Scalars["String"]["input"]>;
  id?: InputMaybe<Scalars["Decimal"]["input"]>;
  isAssessmentsDone?: InputMaybe<Scalars["Boolean"]["input"]>;
  jobCities?: InputMaybe<Array<InputMaybe<Scalars["ID"]["input"]>>>;
  jobType?: InputMaybe<Array<InputMaybe<AuthAccountUserJobTypeChoices>>>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<AuthAccountUserOrderByChoices>;
  profile_BirthDate_Gte?: InputMaybe<Scalars["Date"]["input"]>;
  profile_BirthDate_Lte?: InputMaybe<Scalars["Date"]["input"]>;
  profile_City_Country_Id_In?: InputMaybe<Array<InputMaybe<Scalars["ID"]["input"]>>>;
  profile_City_Id_In?: InputMaybe<Array<InputMaybe<Scalars["ID"]["input"]>>>;
  profile_Contactable_Contacts_Value_Icontains?: InputMaybe<Scalars["String"]["input"]>;
  profile_EmploymentStatus_In?: InputMaybe<Array<InputMaybe<AuthAccountProfileEmploymentStatusChoices>>>;
  profile_Gender_In?: InputMaybe<Array<InputMaybe<AuthAccountProfileGenderChoices>>>;
  profile_Industry_Id_In?: InputMaybe<Array<InputMaybe<Scalars["ID"]["input"]>>>;
  profile_InterestedJobs_Id_In?: InputMaybe<Array<InputMaybe<Scalars["ID"]["input"]>>>;
  profile_NativeLanguage_In?: InputMaybe<Array<InputMaybe<AuthAccountProfileNativeLanguageChoices>>>;
  profile_Skills_Id_In?: InputMaybe<Array<InputMaybe<Scalars["ID"]["input"]>>>;
  referredJobPositions_Id_In?: InputMaybe<Array<InputMaybe<Scalars["ID"]["input"]>>>;
  workexperiences_Grade_In?: InputMaybe<Array<InputMaybe<AuthAccountWorkExperienceGradeChoices>>>;
};

export type AdminQueryJobSuggestionResultArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>;
  before?: InputMaybe<Scalars["String"]["input"]>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  jobPosition_Id?: InputMaybe<Scalars["ID"]["input"]>;
  jobPosition_Organization_Id?: InputMaybe<Scalars["ID"]["input"]>;
  jobPosition_Status_In?: InputMaybe<Array<InputMaybe<AuthAccountOrganizationJobPositionStatusChoices>>>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<AuthAccountJobSuggestionResultOrderByChoices>;
};

export type AdminQueryLanguageCertificateArgs = {
  id: Scalars["NotEmptyID"]["input"];
};

export type AdminQueryOrganizationsArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>;
  before?: InputMaybe<Scalars["String"]["input"]>;
  businessType?: InputMaybe<AuthAccountOrganizationBusinessTypeChoices>;
  city?: InputMaybe<Scalars["ID"]["input"]>;
  establishedAt_Gte?: InputMaybe<Scalars["Date"]["input"]>;
  establishedAt_Lte?: InputMaybe<Scalars["Date"]["input"]>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  hasJobPositionFrom?: InputMaybe<Scalars["Date"]["input"]>;
  id?: InputMaybe<Scalars["ID"]["input"]>;
  industry?: InputMaybe<Scalars["ID"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  name_Icontains?: InputMaybe<Scalars["String"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<AuthAccountOrganizationOrderByChoices>;
  organizationEmployeeId?: InputMaybe<Scalars["String"]["input"]>;
  organizationJobPositionId?: InputMaybe<Scalars["String"]["input"]>;
  organizationPhone?: InputMaybe<Scalars["String"]["input"]>;
  shortName_Icontains?: InputMaybe<Scalars["String"]["input"]>;
  size_Gte?: InputMaybe<AuthAccountOrganizationSizeChoices>;
  size_Lte?: InputMaybe<AuthAccountOrganizationSizeChoices>;
  status?: InputMaybe<AuthAccountOrganizationStatusChoices>;
  type?: InputMaybe<AuthAccountOrganizationTypeChoices>;
  user_Email?: InputMaybe<Scalars["String"]["input"]>;
};

export type AdminQueryWorkExperienceArgs = {
  id: Scalars["NotEmptyID"]["input"];
};

export type AdminSetOrganizationContactableInput = {
  organizationId: Scalars["NotEmptyID"]["input"];
  type?: InputMaybe<AuthAccountContactTypeChoices>;
  value: Scalars["String"]["input"];
};

export type AdminSetOrganizationContactsMutation = {
  __typename?: "AdminSetOrganizationContactsMutation";
  contacts?: Maybe<Array<Maybe<ContactType>>>;
};

export type AssessmentFilter = {
  assessmentId?: InputMaybe<Scalars["String"]["input"]>;
};

export type AssessmentMutation = {
  __typename?: "AssessmentMutation";
  generateAssessmentToken?: Maybe<GenerateAssessmentTokenMutation>;
};

export type AssessmentMutationGenerateAssessmentTokenArgs = {
  assessmentId: Scalars["String"]["input"];
};

export type AssessmentResultQuestionType = {
  __typename?: "AssessmentResultQuestionType";
  status: QuestionStatus;
  text: Scalars["String"]["output"];
};

export type AssessmentSkillType = {
  __typename?: "AssessmentSkillType";
  description: Scalars["String"]["output"];
  id: Scalars["String"]["output"];
  title: Scalars["String"]["output"];
};

export type AssessmentType = {
  __typename?: "AssessmentType";
  description: Scalars["String"]["output"];
  id: Scalars["String"]["output"];
  remainingQuestions: Scalars["Int"]["output"];
  results?: Maybe<Array<Maybe<JobSeekerAssessmentResultType>>>;
  skill?: Maybe<AssessmentSkillType>;
  status: Status;
  title: Scalars["String"]["output"];
  totalEstimatedTime: Scalars["Int"]["output"];
  totalQuestions: Scalars["Int"]["output"];
};

export type AssignJobMutation = {
  __typename?: "AssignJobMutation";
  created?: Maybe<Scalars["Boolean"]["output"]>;
  jobPositionAssignment?: Maybe<JobPositionAssignmentNode>;
};

/** An enumeration. */
export enum AttachmentType {
  /** Platform Message Attachment Course */
  COURSE = "COURSE",
  /** Platform Message Attachment Course Result */
  COURSE_RESULT = "COURSE_RESULT",
  /** Platform Message Attachment File */
  FILE = "FILE",
}

/** An enumeration. */
export enum AuthAccountCanadaVisaStatusChoices {
  /** Citizenship */
  CITIZENSHIP = "CITIZENSHIP",
  /** Electronic Travel Authorization (eTA) */
  ELECTRONIC_TRAVEL_AUTHORIZATION = "ELECTRONIC_TRAVEL_AUTHORIZATION",
  /** International Experience Canada (IEC) */
  INTERNATIONAL_EXPERIENCE_CANADA = "INTERNATIONAL_EXPERIENCE_CANADA",
  /** No Visa */
  NO_VISA = "NO_VISA",
  /** Permanent Resident (PR) */
  PERMANENT_RESIDENT = "PERMANENT_RESIDENT",
  /** Refugee (Work Permit) */
  REFUGEE_WORK_PERMIT = "REFUGEE_WORK_PERMIT",
  /** Seasonal Agricultural Worker Program (SAWP) */
  SEASONAL_AGRICULTURAL_WORKER_PROGRAM = "SEASONAL_AGRICULTURAL_WORKER_PROGRAM",
  /** Temporary Resident (Close Work Permit) */
  TEMPORARY_RESIDENT_CLOSE_WORK_PERMIT = "TEMPORARY_RESIDENT_CLOSE_WORK_PERMIT",
  /** Temporary Resident (Open Work Permit) */
  TEMPORARY_RESIDENT_OPEN_WORK_PERMIT = "TEMPORARY_RESIDENT_OPEN_WORK_PERMIT",
  /** Temporary Resident (Study Permit) */
  TEMPORARY_RESIDENT_STUDY_PERMIT = "TEMPORARY_RESIDENT_STUDY_PERMIT",
  /** Visitor Visa */
  VISITOR_VISA = "VISITOR_VISA",
}

/** An enumeration. */
export enum AuthAccountCertificateAndLicenseStatusChoices {
  /** Drafted */
  DRAFTED = "DRAFTED",
  /** Rejected */
  REJECTED = "REJECTED",
  /** Self Verified */
  SELF_VERIFIED = "SELF_VERIFIED",
  /** Submitted */
  SUBMITTED = "SUBMITTED",
  /** Verified */
  VERIFIED = "VERIFIED",
}

/** An enumeration. */
export enum AuthAccountContactTypeChoices {
  /** Address */
  ADDRESS = "ADDRESS",
  /** LinkedIn */
  LINKEDIN = "LINKEDIN",
  /** Phone */
  PHONE = "PHONE",
  /** Website */
  WEBSITE = "WEBSITE",
  /** WhatsApp */
  WHATSAPP = "WHATSAPP",
}

/** An enumeration. */
export enum AuthAccountEducationDegreeChoices {
  /** Associate */
  ASSOCIATE = "ASSOCIATE",
  /** Bachelors */
  BACHELORS = "BACHELORS",
  /** Certificate */
  CERTIFICATE = "CERTIFICATE",
  /** Diploma */
  DIPLOMA = "DIPLOMA",
  /** Masters */
  MASTERS = "MASTERS",
  /** PhD */
  PHD = "PHD",
}

/** An enumeration. */
export enum AuthAccountEducationStatusChoices {
  /** Drafted */
  DRAFTED = "DRAFTED",
  /** Rejected */
  REJECTED = "REJECTED",
  /** Self Verified */
  SELF_VERIFIED = "SELF_VERIFIED",
  /** Submitted */
  SUBMITTED = "SUBMITTED",
  /** Verified */
  VERIFIED = "VERIFIED",
}

/** An enumeration. */
export enum AuthAccountJobPositionAssignmentOrderByChoices {
  /** Created at */
  CREATED_AT = "CREATED_AT",
  /** Created at (descending) */
  _CREATED_AT = "_CREATED_AT",
}

/** An enumeration. */
export enum AuthAccountJobPositionAssignmentStatusChoices {
  /** Accepted */
  ACCEPTED = "ACCEPTED",
  /** Awaiting Interview Date */
  AWAITING_INTERVIEW_DATE = "AWAITING_INTERVIEW_DATE",
  /** Awaiting Jobseeker Approval */
  AWAITING_JOBSEEKER_APPROVAL = "AWAITING_JOBSEEKER_APPROVAL",
  /** Interview Canceled */
  INTERVIEW_CANCELED = "INTERVIEW_CANCELED",
  /** Interview Done */
  INTERVIEW_DONE = "INTERVIEW_DONE",
  /** Interview Scheduled */
  INTERVIEW_SCHEDULED = "INTERVIEW_SCHEDULED",
  /** Not Reviewed */
  NOT_REVIEWED = "NOT_REVIEWED",
  /** Rejected */
  REJECTED = "REJECTED",
  /** Rejected By Jobseeker */
  REJECTED_BY_JOBSEEKER = "REJECTED_BY_JOBSEEKER",
}

/** An enumeration. */
export enum AuthAccountJobPositionAssignmentStatusHistoryStatusChoices {
  /** Accepted */
  ACCEPTED = "ACCEPTED",
  /** Awaiting Interview Date */
  AWAITING_INTERVIEW_DATE = "AWAITING_INTERVIEW_DATE",
  /** Awaiting Jobseeker Approval */
  AWAITING_JOBSEEKER_APPROVAL = "AWAITING_JOBSEEKER_APPROVAL",
  /** Interview Canceled */
  INTERVIEW_CANCELED = "INTERVIEW_CANCELED",
  /** Interview Done */
  INTERVIEW_DONE = "INTERVIEW_DONE",
  /** Interview Scheduled */
  INTERVIEW_SCHEDULED = "INTERVIEW_SCHEDULED",
  /** Not Reviewed */
  NOT_REVIEWED = "NOT_REVIEWED",
  /** Rejected */
  REJECTED = "REJECTED",
  /** Rejected By Jobseeker */
  REJECTED_BY_JOBSEEKER = "REJECTED_BY_JOBSEEKER",
}

/** An enumeration. */
export enum AuthAccountJobSuggestionResultOrderByChoices {
  /** Created at */
  CREATED_AT = "CREATED_AT",
  /** Created at (descending) */
  _CREATED_AT = "_CREATED_AT",
}

/** An enumeration. */
export enum AuthAccountLanguageCertificateLanguageChoices {
  /** Afrikaans */
  AF = "AF",
  /** Arabic */
  AR = "AR",
  /** Algerian Arabic */
  AR_DZ = "AR_DZ",
  /** Asturian */
  AST = "AST",
  /** Azerbaijani */
  AZ = "AZ",
  /** Belarusian */
  BE = "BE",
  /** Bulgarian */
  BG = "BG",
  /** Bengali */
  BN = "BN",
  /** Breton */
  BR = "BR",
  /** Bosnian */
  BS = "BS",
  /** Catalan */
  CA = "CA",
  /** Central Kurdish (Sorani) */
  CKB = "CKB",
  /** Czech */
  CS = "CS",
  /** Welsh */
  CY = "CY",
  /** Danish */
  DA = "DA",
  /** German */
  DE = "DE",
  /** Lower Sorbian */
  DSB = "DSB",
  /** Greek */
  EL = "EL",
  /** English */
  EN = "EN",
  /** Australian English */
  EN_AU = "EN_AU",
  /** British English */
  EN_GB = "EN_GB",
  /** Esperanto */
  EO = "EO",
  /** Spanish */
  ES = "ES",
  /** Argentinian Spanish */
  ES_AR = "ES_AR",
  /** Colombian Spanish */
  ES_CO = "ES_CO",
  /** Mexican Spanish */
  ES_MX = "ES_MX",
  /** Nicaraguan Spanish */
  ES_NI = "ES_NI",
  /** Venezuelan Spanish */
  ES_VE = "ES_VE",
  /** Estonian */
  ET = "ET",
  /** Basque */
  EU = "EU",
  /** Persian */
  FA = "FA",
  /** Finnish */
  FI = "FI",
  /** French */
  FR = "FR",
  /** Frisian */
  FY = "FY",
  /** Irish */
  GA = "GA",
  /** Scottish Gaelic */
  GD = "GD",
  /** Galician */
  GL = "GL",
  /** Hebrew */
  HE = "HE",
  /** Hindi */
  HI = "HI",
  /** Croatian */
  HR = "HR",
  /** Upper Sorbian */
  HSB = "HSB",
  /** Hungarian */
  HU = "HU",
  /** Armenian */
  HY = "HY",
  /** Interlingua */
  IA = "IA",
  /** Indonesian */
  ID = "ID",
  /** Igbo */
  IG = "IG",
  /** Ido */
  IO = "IO",
  /** Icelandic */
  IS = "IS",
  /** Italian */
  IT = "IT",
  /** Japanese */
  JA = "JA",
  /** Georgian */
  KA = "KA",
  /** Kabyle */
  KAB = "KAB",
  /** Kazakh */
  KK = "KK",
  /** Khmer */
  KM = "KM",
  /** Kannada */
  KN = "KN",
  /** Korean */
  KO = "KO",
  /** Kyrgyz */
  KY = "KY",
  /** Luxembourgish */
  LB = "LB",
  /** Lithuanian */
  LT = "LT",
  /** Latvian */
  LV = "LV",
  /** Macedonian */
  MK = "MK",
  /** Malayalam */
  ML = "ML",
  /** Mongolian */
  MN = "MN",
  /** Marathi */
  MR = "MR",
  /** Malay */
  MS = "MS",
  /** Burmese */
  MY = "MY",
  /** Norwegian Bokmål */
  NB = "NB",
  /** Nepali */
  NE = "NE",
  /** Dutch */
  NL = "NL",
  /** Norwegian Nynorsk */
  NN = "NN",
  /** Ossetic */
  OS = "OS",
  /** Punjabi */
  PA = "PA",
  /** Polish */
  PL = "PL",
  /** Portuguese */
  PT = "PT",
  /** Brazilian Portuguese */
  PT_BR = "PT_BR",
  /** Romanian */
  RO = "RO",
  /** Russian */
  RU = "RU",
  /** Slovak */
  SK = "SK",
  /** Slovenian */
  SL = "SL",
  /** Albanian */
  SQ = "SQ",
  /** Serbian */
  SR = "SR",
  /** Serbian Latin */
  SR_LATN = "SR_LATN",
  /** Swedish */
  SV = "SV",
  /** Swahili */
  SW = "SW",
  /** Tamil */
  TA = "TA",
  /** Telugu */
  TE = "TE",
  /** Tajik */
  TG = "TG",
  /** Thai */
  TH = "TH",
  /** Turkmen */
  TK = "TK",
  /** Turkish */
  TR = "TR",
  /** Tatar */
  TT = "TT",
  /** Udmurt */
  UDM = "UDM",
  /** Uyghur */
  UG = "UG",
  /** Ukrainian */
  UK = "UK",
  /** Urdu */
  UR = "UR",
  /** Uzbek */
  UZ = "UZ",
  /** Vietnamese */
  VI = "VI",
  /** Simplified Chinese */
  ZH_HANS = "ZH_HANS",
  /** Traditional Chinese */
  ZH_HANT = "ZH_HANT",
}

/** An enumeration. */
export enum AuthAccountLanguageCertificateStatusChoices {
  /** Drafted */
  DRAFTED = "DRAFTED",
  /** Rejected */
  REJECTED = "REJECTED",
  /** Self Verified */
  SELF_VERIFIED = "SELF_VERIFIED",
  /** Submitted */
  SUBMITTED = "SUBMITTED",
  /** Verified */
  VERIFIED = "VERIFIED",
}

/** An enumeration. */
export enum AuthAccountOrganizationBusinessTypeChoices {
  /** Product */
  PRODUCT = "PRODUCT",
  /** Service */
  SERVICE = "SERVICE",
  /** Software */
  SOFTWARE = "SOFTWARE",
}

/** An enumeration. */
export enum AuthAccountOrganizationEmployeeCooperationStatusChoices {
  /** Active */
  ACTIVE = "ACTIVE",
  /** Awaiting */
  AWAITING = "AWAITING",
  /** Finished */
  FINISHED = "FINISHED",
  /** Fired */
  FIRED = "FIRED",
  /** Resigned */
  RESIGNED = "RESIGNED",
  /** Suspended */
  SUSPENDED = "SUSPENDED",
}

/** An enumeration. */
export enum AuthAccountOrganizationEmployeePerformanceReportStatusChoices {
  /** Completed */
  COMPLETED = "COMPLETED",
  /** Completed By Job Seeker */
  COMPLETED_BY_JOB_SEEKER = "COMPLETED_BY_JOB_SEEKER",
  /** Completed By Organization */
  COMPLETED_BY_ORGANIZATION = "COMPLETED_BY_ORGANIZATION",
  /** Created */
  CREATED = "CREATED",
}

/** An enumeration. */
export enum AuthAccountOrganizationEmployeePerformanceReportStatusHistoryStatusChoices {
  /** Completed */
  COMPLETED = "COMPLETED",
  /** Completed By Job Seeker */
  COMPLETED_BY_JOB_SEEKER = "COMPLETED_BY_JOB_SEEKER",
  /** Completed By Organization */
  COMPLETED_BY_ORGANIZATION = "COMPLETED_BY_ORGANIZATION",
  /** Created */
  CREATED = "CREATED",
}

/** An enumeration. */
export enum AuthAccountOrganizationJobPositionContractTypeChoices {
  /** Apprenticeship */
  APPRENTICESHIP = "APPRENTICESHIP",
  /** Fix Term Contract */
  FIX_TERM_CONTRACT = "FIX_TERM_CONTRACT",
  /** Freelance */
  FREELANCE = "FREELANCE",
  /** Full Time */
  FULL_TIME = "FULL_TIME",
  /** Internship/Co-op */
  INTERNSHIP_CO_OP = "INTERNSHIP_CO_OP",
  /** Part Time */
  PART_TIME = "PART_TIME",
  /** Permanent */
  PERMANENT = "PERMANENT",
  /** Prince Edward Island */
  PRINCE_EDWARD_ISLAND = "PRINCE_EDWARD_ISLAND",
  /** Seasonal */
  SEASONAL = "SEASONAL",
}

/** An enumeration. */
export enum AuthAccountOrganizationJobPositionDaysOffChoices {
  /** Friday */
  FRIDAY = "FRIDAY",
  /** Monday */
  MONDAY = "MONDAY",
  /** Saturday */
  SATURDAY = "SATURDAY",
  /** Sunday */
  SUNDAY = "SUNDAY",
  /** Thursday */
  THURSDAY = "THURSDAY",
  /** Tuesday */
  TUESDAY = "TUESDAY",
  /** Wednesday */
  WEDNESDAY = "WEDNESDAY",
}

/** An enumeration. */
export enum AuthAccountOrganizationJobPositionDegreesChoices {
  /** Associate */
  ASSOCIATE = "ASSOCIATE",
  /** Bachelors */
  BACHELORS = "BACHELORS",
  /** Certificate */
  CERTIFICATE = "CERTIFICATE",
  /** Diploma */
  DIPLOMA = "DIPLOMA",
  /** Masters */
  MASTERS = "MASTERS",
  /** PhD */
  PHD = "PHD",
}

/** An enumeration. */
export enum AuthAccountOrganizationJobPositionLanguagesChoices {
  /** Afrikaans */
  AF = "AF",
  /** Arabic */
  AR = "AR",
  /** Algerian Arabic */
  AR_DZ = "AR_DZ",
  /** Asturian */
  AST = "AST",
  /** Azerbaijani */
  AZ = "AZ",
  /** Belarusian */
  BE = "BE",
  /** Bulgarian */
  BG = "BG",
  /** Bengali */
  BN = "BN",
  /** Breton */
  BR = "BR",
  /** Bosnian */
  BS = "BS",
  /** Catalan */
  CA = "CA",
  /** Central Kurdish (Sorani) */
  CKB = "CKB",
  /** Czech */
  CS = "CS",
  /** Welsh */
  CY = "CY",
  /** Danish */
  DA = "DA",
  /** German */
  DE = "DE",
  /** Lower Sorbian */
  DSB = "DSB",
  /** Greek */
  EL = "EL",
  /** English */
  EN = "EN",
  /** Australian English */
  EN_AU = "EN_AU",
  /** British English */
  EN_GB = "EN_GB",
  /** Esperanto */
  EO = "EO",
  /** Spanish */
  ES = "ES",
  /** Argentinian Spanish */
  ES_AR = "ES_AR",
  /** Colombian Spanish */
  ES_CO = "ES_CO",
  /** Mexican Spanish */
  ES_MX = "ES_MX",
  /** Nicaraguan Spanish */
  ES_NI = "ES_NI",
  /** Venezuelan Spanish */
  ES_VE = "ES_VE",
  /** Estonian */
  ET = "ET",
  /** Basque */
  EU = "EU",
  /** Persian */
  FA = "FA",
  /** Finnish */
  FI = "FI",
  /** French */
  FR = "FR",
  /** Frisian */
  FY = "FY",
  /** Irish */
  GA = "GA",
  /** Scottish Gaelic */
  GD = "GD",
  /** Galician */
  GL = "GL",
  /** Hebrew */
  HE = "HE",
  /** Hindi */
  HI = "HI",
  /** Croatian */
  HR = "HR",
  /** Upper Sorbian */
  HSB = "HSB",
  /** Hungarian */
  HU = "HU",
  /** Armenian */
  HY = "HY",
  /** Interlingua */
  IA = "IA",
  /** Indonesian */
  ID = "ID",
  /** Igbo */
  IG = "IG",
  /** Ido */
  IO = "IO",
  /** Icelandic */
  IS = "IS",
  /** Italian */
  IT = "IT",
  /** Japanese */
  JA = "JA",
  /** Georgian */
  KA = "KA",
  /** Kabyle */
  KAB = "KAB",
  /** Kazakh */
  KK = "KK",
  /** Khmer */
  KM = "KM",
  /** Kannada */
  KN = "KN",
  /** Korean */
  KO = "KO",
  /** Kyrgyz */
  KY = "KY",
  /** Luxembourgish */
  LB = "LB",
  /** Lithuanian */
  LT = "LT",
  /** Latvian */
  LV = "LV",
  /** Macedonian */
  MK = "MK",
  /** Malayalam */
  ML = "ML",
  /** Mongolian */
  MN = "MN",
  /** Marathi */
  MR = "MR",
  /** Malay */
  MS = "MS",
  /** Burmese */
  MY = "MY",
  /** Norwegian Bokmål */
  NB = "NB",
  /** Nepali */
  NE = "NE",
  /** Dutch */
  NL = "NL",
  /** Norwegian Nynorsk */
  NN = "NN",
  /** Ossetic */
  OS = "OS",
  /** Punjabi */
  PA = "PA",
  /** Polish */
  PL = "PL",
  /** Portuguese */
  PT = "PT",
  /** Brazilian Portuguese */
  PT_BR = "PT_BR",
  /** Romanian */
  RO = "RO",
  /** Russian */
  RU = "RU",
  /** Slovak */
  SK = "SK",
  /** Slovenian */
  SL = "SL",
  /** Albanian */
  SQ = "SQ",
  /** Serbian */
  SR = "SR",
  /** Serbian Latin */
  SR_LATN = "SR_LATN",
  /** Swedish */
  SV = "SV",
  /** Swahili */
  SW = "SW",
  /** Tamil */
  TA = "TA",
  /** Telugu */
  TE = "TE",
  /** Tajik */
  TG = "TG",
  /** Thai */
  TH = "TH",
  /** Turkmen */
  TK = "TK",
  /** Turkish */
  TR = "TR",
  /** Tatar */
  TT = "TT",
  /** Udmurt */
  UDM = "UDM",
  /** Uyghur */
  UG = "UG",
  /** Ukrainian */
  UK = "UK",
  /** Urdu */
  UR = "UR",
  /** Uzbek */
  UZ = "UZ",
  /** Vietnamese */
  VI = "VI",
  /** Simplified Chinese */
  ZH_HANS = "ZH_HANS",
  /** Traditional Chinese */
  ZH_HANT = "ZH_HANT",
}

/** An enumeration. */
export enum AuthAccountOrganizationJobPositionLocationTypeChoices {
  /** Global */
  GLOBAL = "GLOBAL",
  /** Hybrid */
  HYBRID = "HYBRID",
  /** On-site (Within a Limited Area) */
  LIMITED_AREA = "LIMITED_AREA",
  /** On the road */
  ON_THE_ROAD = "ON_THE_ROAD",
  /** On-site (Precise Location) */
  PRECISE_LOCATION = "PRECISE_LOCATION",
  /** Remote */
  REMOTE = "REMOTE",
}

/** An enumeration. */
export enum AuthAccountOrganizationJobPositionNativeLanguagesChoices {
  /** Afrikaans */
  AF = "AF",
  /** Arabic */
  AR = "AR",
  /** Algerian Arabic */
  AR_DZ = "AR_DZ",
  /** Asturian */
  AST = "AST",
  /** Azerbaijani */
  AZ = "AZ",
  /** Belarusian */
  BE = "BE",
  /** Bulgarian */
  BG = "BG",
  /** Bengali */
  BN = "BN",
  /** Breton */
  BR = "BR",
  /** Bosnian */
  BS = "BS",
  /** Catalan */
  CA = "CA",
  /** Central Kurdish (Sorani) */
  CKB = "CKB",
  /** Czech */
  CS = "CS",
  /** Welsh */
  CY = "CY",
  /** Danish */
  DA = "DA",
  /** German */
  DE = "DE",
  /** Lower Sorbian */
  DSB = "DSB",
  /** Greek */
  EL = "EL",
  /** English */
  EN = "EN",
  /** Australian English */
  EN_AU = "EN_AU",
  /** British English */
  EN_GB = "EN_GB",
  /** Esperanto */
  EO = "EO",
  /** Spanish */
  ES = "ES",
  /** Argentinian Spanish */
  ES_AR = "ES_AR",
  /** Colombian Spanish */
  ES_CO = "ES_CO",
  /** Mexican Spanish */
  ES_MX = "ES_MX",
  /** Nicaraguan Spanish */
  ES_NI = "ES_NI",
  /** Venezuelan Spanish */
  ES_VE = "ES_VE",
  /** Estonian */
  ET = "ET",
  /** Basque */
  EU = "EU",
  /** Persian */
  FA = "FA",
  /** Finnish */
  FI = "FI",
  /** French */
  FR = "FR",
  /** Frisian */
  FY = "FY",
  /** Irish */
  GA = "GA",
  /** Scottish Gaelic */
  GD = "GD",
  /** Galician */
  GL = "GL",
  /** Hebrew */
  HE = "HE",
  /** Hindi */
  HI = "HI",
  /** Croatian */
  HR = "HR",
  /** Upper Sorbian */
  HSB = "HSB",
  /** Hungarian */
  HU = "HU",
  /** Armenian */
  HY = "HY",
  /** Interlingua */
  IA = "IA",
  /** Indonesian */
  ID = "ID",
  /** Igbo */
  IG = "IG",
  /** Ido */
  IO = "IO",
  /** Icelandic */
  IS = "IS",
  /** Italian */
  IT = "IT",
  /** Japanese */
  JA = "JA",
  /** Georgian */
  KA = "KA",
  /** Kabyle */
  KAB = "KAB",
  /** Kazakh */
  KK = "KK",
  /** Khmer */
  KM = "KM",
  /** Kannada */
  KN = "KN",
  /** Korean */
  KO = "KO",
  /** Kyrgyz */
  KY = "KY",
  /** Luxembourgish */
  LB = "LB",
  /** Lithuanian */
  LT = "LT",
  /** Latvian */
  LV = "LV",
  /** Macedonian */
  MK = "MK",
  /** Malayalam */
  ML = "ML",
  /** Mongolian */
  MN = "MN",
  /** Marathi */
  MR = "MR",
  /** Malay */
  MS = "MS",
  /** Burmese */
  MY = "MY",
  /** Norwegian Bokmål */
  NB = "NB",
  /** Nepali */
  NE = "NE",
  /** Dutch */
  NL = "NL",
  /** Norwegian Nynorsk */
  NN = "NN",
  /** Ossetic */
  OS = "OS",
  /** Punjabi */
  PA = "PA",
  /** Polish */
  PL = "PL",
  /** Portuguese */
  PT = "PT",
  /** Brazilian Portuguese */
  PT_BR = "PT_BR",
  /** Romanian */
  RO = "RO",
  /** Russian */
  RU = "RU",
  /** Slovak */
  SK = "SK",
  /** Slovenian */
  SL = "SL",
  /** Albanian */
  SQ = "SQ",
  /** Serbian */
  SR = "SR",
  /** Serbian Latin */
  SR_LATN = "SR_LATN",
  /** Swedish */
  SV = "SV",
  /** Swahili */
  SW = "SW",
  /** Tamil */
  TA = "TA",
  /** Telugu */
  TE = "TE",
  /** Tajik */
  TG = "TG",
  /** Thai */
  TH = "TH",
  /** Turkmen */
  TK = "TK",
  /** Turkish */
  TR = "TR",
  /** Tatar */
  TT = "TT",
  /** Udmurt */
  UDM = "UDM",
  /** Uyghur */
  UG = "UG",
  /** Ukrainian */
  UK = "UK",
  /** Urdu */
  UR = "UR",
  /** Uzbek */
  UZ = "UZ",
  /** Vietnamese */
  VI = "VI",
  /** Simplified Chinese */
  ZH_HANS = "ZH_HANS",
  /** Traditional Chinese */
  ZH_HANT = "ZH_HANT",
}

/** An enumeration. */
export enum AuthAccountOrganizationJobPositionOrderByChoices {
  /** Created at */
  CREATED_AT = "CREATED_AT",
  /** Created at (descending) */
  _CREATED_AT = "_CREATED_AT",
}

/** An enumeration. */
export enum AuthAccountOrganizationJobPositionPaymentTermChoices {
  /** Bi-Weekly */
  BI_WEEKLY = "BI_WEEKLY",
  /** Daily */
  DAILY = "DAILY",
  /** Hourly */
  HOURLY = "HOURLY",
  /** Monthly */
  MONTHLY = "MONTHLY",
  /** Weekly */
  WEEKLY = "WEEKLY",
  /** Yearly */
  YEARLY = "YEARLY",
}

/** An enumeration. */
export enum AuthAccountOrganizationJobPositionStatusChoices {
  /** Capacity Filled */
  CAPACITY_FILLED = "CAPACITY_FILLED",
  /** Drafted */
  DRAFTED = "DRAFTED",
  /** Expired */
  EXPIRED = "EXPIRED",
  /** Published */
  PUBLISHED = "PUBLISHED",
  /** Rejected */
  REJECTED = "REJECTED",
  /** Submitted */
  SUBMITTED = "SUBMITTED",
  /** Suspended */
  SUSPENDED = "SUSPENDED",
}

/** An enumeration. */
export enum AuthAccountOrganizationOrderByChoices {
  /** Created at */
  CREATED_AT = "CREATED_AT",
  /** Created at (descending) */
  _CREATED_AT = "_CREATED_AT",
}

/** An enumeration. */
export enum AuthAccountOrganizationPlatformMessageAssigneeTypeChoices {
  /** Job Seeker */
  JOB_SEEKER = "JOB_SEEKER",
  /** Organization */
  ORGANIZATION = "ORGANIZATION",
}

/** An enumeration. */
export enum AuthAccountOrganizationPlatformMessageSourceChoices {
  /** AI */
  AI = "AI",
  /** Human */
  HUMAN = "HUMAN",
}

/** An enumeration. */
export enum AuthAccountOrganizationSizeChoices {
  /** Over 1000 */
  OVER_1000 = "OVER_1000",
  /** 1-10 */
  _1_10 = "_1_10",
  /** 10-50 */
  _10_50 = "_10_50",
  /** 50-100 */
  _50_100 = "_50_100",
  /** 100-500 */
  _100_500 = "_100_500",
  /** 500-1000 */
  _500_1000 = "_500_1000",
}

/** An enumeration. */
export enum AuthAccountOrganizationStatusChoices {
  /** Blocked */
  BLOCKED = "BLOCKED",
  /** Completed */
  COMPLETED = "COMPLETED",
  /** Drafted */
  DRAFTED = "DRAFTED",
  /** Rejected */
  REJECTED = "REJECTED",
  /** Submitted */
  SUBMITTED = "SUBMITTED",
  /** Verified */
  VERIFIED = "VERIFIED",
}

/** An enumeration. */
export enum AuthAccountOrganizationTypeChoices {
  /** Branch Office */
  BRANCH_OFFICE = "BRANCH_OFFICE",
  /** Cooperative */
  COOPERATIVE = "COOPERATIVE",
  /** General Partnership */
  GENERAL_PARTNERSHIP = "GENERAL_PARTNERSHIP",
  /** Limited Partnership */
  LIMITED_PARTNERSHIP = "LIMITED_PARTNERSHIP",
  /** Non-Profit Organization */
  NON_PROFIT_ORGANIZATION = "NON_PROFIT_ORGANIZATION",
  /** Private Corporation */
  PRIVATE_CORPORATION = "PRIVATE_CORPORATION",
  /** Public Corporation */
  PUBLIC_CORPORATION = "PUBLIC_CORPORATION",
  /** Sole Proprietorship */
  SOLE_PROPRIETORSHIP = "SOLE_PROPRIETORSHIP",
  /** Subsidiary */
  SUBSIDIARY = "SUBSIDIARY",
}

/** An enumeration. */
export enum AuthAccountProfileEmploymentStatusChoices {
  /** Employed */
  EMPLOYED = "EMPLOYED",
  /** Unemployed */
  UNEMPLOYED = "UNEMPLOYED",
}

/** An enumeration. */
export enum AuthAccountProfileEyeColorChoices {
  /** Green */
  _1CAC78 = "_1CAC78",
  /** Blue */
  _5DADEC = "_5DADEC",
  /** Brown */
  _6B4226 = "_6B4226",
  /** Hazel */
  _8E7618 = "_8E7618",
  /** Gray */
  _BEBEBE = "_BEBEBE",
  /** Amber */
  _FFBF00 = "_FFBF00",
}

/** An enumeration. */
export enum AuthAccountProfileFluentLanguagesChoices {
  /** Afrikaans */
  AF = "AF",
  /** Arabic */
  AR = "AR",
  /** Algerian Arabic */
  AR_DZ = "AR_DZ",
  /** Asturian */
  AST = "AST",
  /** Azerbaijani */
  AZ = "AZ",
  /** Belarusian */
  BE = "BE",
  /** Bulgarian */
  BG = "BG",
  /** Bengali */
  BN = "BN",
  /** Breton */
  BR = "BR",
  /** Bosnian */
  BS = "BS",
  /** Catalan */
  CA = "CA",
  /** Central Kurdish (Sorani) */
  CKB = "CKB",
  /** Czech */
  CS = "CS",
  /** Welsh */
  CY = "CY",
  /** Danish */
  DA = "DA",
  /** German */
  DE = "DE",
  /** Lower Sorbian */
  DSB = "DSB",
  /** Greek */
  EL = "EL",
  /** English */
  EN = "EN",
  /** Australian English */
  EN_AU = "EN_AU",
  /** British English */
  EN_GB = "EN_GB",
  /** Esperanto */
  EO = "EO",
  /** Spanish */
  ES = "ES",
  /** Argentinian Spanish */
  ES_AR = "ES_AR",
  /** Colombian Spanish */
  ES_CO = "ES_CO",
  /** Mexican Spanish */
  ES_MX = "ES_MX",
  /** Nicaraguan Spanish */
  ES_NI = "ES_NI",
  /** Venezuelan Spanish */
  ES_VE = "ES_VE",
  /** Estonian */
  ET = "ET",
  /** Basque */
  EU = "EU",
  /** Persian */
  FA = "FA",
  /** Finnish */
  FI = "FI",
  /** French */
  FR = "FR",
  /** Frisian */
  FY = "FY",
  /** Irish */
  GA = "GA",
  /** Scottish Gaelic */
  GD = "GD",
  /** Galician */
  GL = "GL",
  /** Hebrew */
  HE = "HE",
  /** Hindi */
  HI = "HI",
  /** Croatian */
  HR = "HR",
  /** Upper Sorbian */
  HSB = "HSB",
  /** Hungarian */
  HU = "HU",
  /** Armenian */
  HY = "HY",
  /** Interlingua */
  IA = "IA",
  /** Indonesian */
  ID = "ID",
  /** Igbo */
  IG = "IG",
  /** Ido */
  IO = "IO",
  /** Icelandic */
  IS = "IS",
  /** Italian */
  IT = "IT",
  /** Japanese */
  JA = "JA",
  /** Georgian */
  KA = "KA",
  /** Kabyle */
  KAB = "KAB",
  /** Kazakh */
  KK = "KK",
  /** Khmer */
  KM = "KM",
  /** Kannada */
  KN = "KN",
  /** Korean */
  KO = "KO",
  /** Kyrgyz */
  KY = "KY",
  /** Luxembourgish */
  LB = "LB",
  /** Lithuanian */
  LT = "LT",
  /** Latvian */
  LV = "LV",
  /** Macedonian */
  MK = "MK",
  /** Malayalam */
  ML = "ML",
  /** Mongolian */
  MN = "MN",
  /** Marathi */
  MR = "MR",
  /** Malay */
  MS = "MS",
  /** Burmese */
  MY = "MY",
  /** Norwegian Bokmål */
  NB = "NB",
  /** Nepali */
  NE = "NE",
  /** Dutch */
  NL = "NL",
  /** Norwegian Nynorsk */
  NN = "NN",
  /** Ossetic */
  OS = "OS",
  /** Punjabi */
  PA = "PA",
  /** Polish */
  PL = "PL",
  /** Portuguese */
  PT = "PT",
  /** Brazilian Portuguese */
  PT_BR = "PT_BR",
  /** Romanian */
  RO = "RO",
  /** Russian */
  RU = "RU",
  /** Slovak */
  SK = "SK",
  /** Slovenian */
  SL = "SL",
  /** Albanian */
  SQ = "SQ",
  /** Serbian */
  SR = "SR",
  /** Serbian Latin */
  SR_LATN = "SR_LATN",
  /** Swedish */
  SV = "SV",
  /** Swahili */
  SW = "SW",
  /** Tamil */
  TA = "TA",
  /** Telugu */
  TE = "TE",
  /** Tajik */
  TG = "TG",
  /** Thai */
  TH = "TH",
  /** Turkmen */
  TK = "TK",
  /** Turkish */
  TR = "TR",
  /** Tatar */
  TT = "TT",
  /** Udmurt */
  UDM = "UDM",
  /** Uyghur */
  UG = "UG",
  /** Ukrainian */
  UK = "UK",
  /** Urdu */
  UR = "UR",
  /** Uzbek */
  UZ = "UZ",
  /** Vietnamese */
  VI = "VI",
  /** Simplified Chinese */
  ZH_HANS = "ZH_HANS",
  /** Traditional Chinese */
  ZH_HANT = "ZH_HANT",
}

/** An enumeration. */
export enum AuthAccountProfileGenderChoices {
  /** Female */
  FEMALE = "FEMALE",
  /** Male */
  MALE = "MALE",
  /** Not Applicable */
  NOT_APPLICABLE = "NOT_APPLICABLE",
  /** Not Known */
  NOT_KNOWN = "NOT_KNOWN",
}

/** An enumeration. */
export enum AuthAccountProfileJobLocationTypeExcludeChoices {
  /** Global */
  GLOBAL = "GLOBAL",
  /** Hybrid */
  HYBRID = "HYBRID",
  /** On-site (Within a Limited Area) */
  LIMITED_AREA = "LIMITED_AREA",
  /** On the road */
  ON_THE_ROAD = "ON_THE_ROAD",
  /** On-site (Precise Location) */
  PRECISE_LOCATION = "PRECISE_LOCATION",
  /** Remote */
  REMOTE = "REMOTE",
}

/** An enumeration. */
export enum AuthAccountProfileJobTypeExcludeChoices {
  /** Apprenticeship */
  APPRENTICESHIP = "APPRENTICESHIP",
  /** Fix Term Contract */
  FIX_TERM_CONTRACT = "FIX_TERM_CONTRACT",
  /** Freelance */
  FREELANCE = "FREELANCE",
  /** Full Time */
  FULL_TIME = "FULL_TIME",
  /** Internship/Co-op */
  INTERNSHIP_CO_OP = "INTERNSHIP_CO_OP",
  /** Part Time */
  PART_TIME = "PART_TIME",
  /** Permanent */
  PERMANENT = "PERMANENT",
  /** Prince Edward Island */
  PRINCE_EDWARD_ISLAND = "PRINCE_EDWARD_ISLAND",
  /** Seasonal */
  SEASONAL = "SEASONAL",
}

/** An enumeration. */
export enum AuthAccountProfileNativeLanguageChoices {
  /** Afrikaans */
  AF = "AF",
  /** Arabic */
  AR = "AR",
  /** Algerian Arabic */
  AR_DZ = "AR_DZ",
  /** Asturian */
  AST = "AST",
  /** Azerbaijani */
  AZ = "AZ",
  /** Belarusian */
  BE = "BE",
  /** Bulgarian */
  BG = "BG",
  /** Bengali */
  BN = "BN",
  /** Breton */
  BR = "BR",
  /** Bosnian */
  BS = "BS",
  /** Catalan */
  CA = "CA",
  /** Central Kurdish (Sorani) */
  CKB = "CKB",
  /** Czech */
  CS = "CS",
  /** Welsh */
  CY = "CY",
  /** Danish */
  DA = "DA",
  /** German */
  DE = "DE",
  /** Lower Sorbian */
  DSB = "DSB",
  /** Greek */
  EL = "EL",
  /** English */
  EN = "EN",
  /** Australian English */
  EN_AU = "EN_AU",
  /** British English */
  EN_GB = "EN_GB",
  /** Esperanto */
  EO = "EO",
  /** Spanish */
  ES = "ES",
  /** Argentinian Spanish */
  ES_AR = "ES_AR",
  /** Colombian Spanish */
  ES_CO = "ES_CO",
  /** Mexican Spanish */
  ES_MX = "ES_MX",
  /** Nicaraguan Spanish */
  ES_NI = "ES_NI",
  /** Venezuelan Spanish */
  ES_VE = "ES_VE",
  /** Estonian */
  ET = "ET",
  /** Basque */
  EU = "EU",
  /** Persian */
  FA = "FA",
  /** Finnish */
  FI = "FI",
  /** French */
  FR = "FR",
  /** Frisian */
  FY = "FY",
  /** Irish */
  GA = "GA",
  /** Scottish Gaelic */
  GD = "GD",
  /** Galician */
  GL = "GL",
  /** Hebrew */
  HE = "HE",
  /** Hindi */
  HI = "HI",
  /** Croatian */
  HR = "HR",
  /** Upper Sorbian */
  HSB = "HSB",
  /** Hungarian */
  HU = "HU",
  /** Armenian */
  HY = "HY",
  /** Interlingua */
  IA = "IA",
  /** Indonesian */
  ID = "ID",
  /** Igbo */
  IG = "IG",
  /** Ido */
  IO = "IO",
  /** Icelandic */
  IS = "IS",
  /** Italian */
  IT = "IT",
  /** Japanese */
  JA = "JA",
  /** Georgian */
  KA = "KA",
  /** Kabyle */
  KAB = "KAB",
  /** Kazakh */
  KK = "KK",
  /** Khmer */
  KM = "KM",
  /** Kannada */
  KN = "KN",
  /** Korean */
  KO = "KO",
  /** Kyrgyz */
  KY = "KY",
  /** Luxembourgish */
  LB = "LB",
  /** Lithuanian */
  LT = "LT",
  /** Latvian */
  LV = "LV",
  /** Macedonian */
  MK = "MK",
  /** Malayalam */
  ML = "ML",
  /** Mongolian */
  MN = "MN",
  /** Marathi */
  MR = "MR",
  /** Malay */
  MS = "MS",
  /** Burmese */
  MY = "MY",
  /** Norwegian Bokmål */
  NB = "NB",
  /** Nepali */
  NE = "NE",
  /** Dutch */
  NL = "NL",
  /** Norwegian Nynorsk */
  NN = "NN",
  /** Ossetic */
  OS = "OS",
  /** Punjabi */
  PA = "PA",
  /** Polish */
  PL = "PL",
  /** Portuguese */
  PT = "PT",
  /** Brazilian Portuguese */
  PT_BR = "PT_BR",
  /** Romanian */
  RO = "RO",
  /** Russian */
  RU = "RU",
  /** Slovak */
  SK = "SK",
  /** Slovenian */
  SL = "SL",
  /** Albanian */
  SQ = "SQ",
  /** Serbian */
  SR = "SR",
  /** Serbian Latin */
  SR_LATN = "SR_LATN",
  /** Swedish */
  SV = "SV",
  /** Swahili */
  SW = "SW",
  /** Tamil */
  TA = "TA",
  /** Telugu */
  TE = "TE",
  /** Tajik */
  TG = "TG",
  /** Thai */
  TH = "TH",
  /** Turkmen */
  TK = "TK",
  /** Turkish */
  TR = "TR",
  /** Tatar */
  TT = "TT",
  /** Udmurt */
  UDM = "UDM",
  /** Uyghur */
  UG = "UG",
  /** Ukrainian */
  UK = "UK",
  /** Urdu */
  UR = "UR",
  /** Uzbek */
  UZ = "UZ",
  /** Vietnamese */
  VI = "VI",
  /** Simplified Chinese */
  ZH_HANS = "ZH_HANS",
  /** Traditional Chinese */
  ZH_HANT = "ZH_HANT",
}

/** An enumeration. */
export enum AuthAccountProfileSkinColorChoices {
  /** Very Dark */
  _3B260B = "_3B260B",
  /** Brown */
  _8D5524 = "_8D5524",
  /** Deep */
  _100C08 = "_100C08",
  /** Dark Brown */
  _60391C = "_60391C",
  /** Olive */
  _A86B33 = "_A86B33",
  /** Medium */
  _C68642 = "_C68642",
  /** Light Medium */
  _D9A377 = "_D9A377",
  /** Light */
  _E5B897 = "_E5B897",
  /** Fair */
  _F0D5B1 = "_F0D5B1",
  /** Very Fair */
  _FFDFC4 = "_FFDFC4",
}

/** An enumeration. */
export enum AuthAccountSupportTicketCategoryTypesChoices {
  /** Job Seeker */
  JOB_SEEKER = "JOB_SEEKER",
  /** Organization */
  ORGANIZATION = "ORGANIZATION",
}

/** An enumeration. */
export enum AuthAccountSupportTicketContactMethodChoices {
  /** Email */
  EMAIL = "EMAIL",
  /** Phone */
  PHONE = "PHONE",
  /** WhatsApp */
  WHATSAPP = "WHATSAPP",
}

/** An enumeration. */
export enum AuthAccountSupportTicketPriorityChoices {
  /** High */
  HIGH = "HIGH",
  /** Low */
  LOW = "LOW",
  /** Medium */
  MEDIUM = "MEDIUM",
  /** Urgent */
  URGENT = "URGENT",
}

/** An enumeration. */
export enum AuthAccountSupportTicketStatusChoices {
  /** Closed */
  CLOSED = "CLOSED",
  /** Open */
  OPEN = "OPEN",
}

/** An enumeration. */
export enum AuthAccountUserFluentLanguagesChoices {
  /** Afrikaans */
  AF = "AF",
  /** Arabic */
  AR = "AR",
  /** Algerian Arabic */
  AR_DZ = "AR_DZ",
  /** Asturian */
  AST = "AST",
  /** Azerbaijani */
  AZ = "AZ",
  /** Belarusian */
  BE = "BE",
  /** Bulgarian */
  BG = "BG",
  /** Bengali */
  BN = "BN",
  /** Breton */
  BR = "BR",
  /** Bosnian */
  BS = "BS",
  /** Catalan */
  CA = "CA",
  /** Central Kurdish (Sorani) */
  CKB = "CKB",
  /** Czech */
  CS = "CS",
  /** Welsh */
  CY = "CY",
  /** Danish */
  DA = "DA",
  /** German */
  DE = "DE",
  /** Lower Sorbian */
  DSB = "DSB",
  /** Greek */
  EL = "EL",
  /** English */
  EN = "EN",
  /** Australian English */
  EN_AU = "EN_AU",
  /** British English */
  EN_GB = "EN_GB",
  /** Esperanto */
  EO = "EO",
  /** Spanish */
  ES = "ES",
  /** Argentinian Spanish */
  ES_AR = "ES_AR",
  /** Colombian Spanish */
  ES_CO = "ES_CO",
  /** Mexican Spanish */
  ES_MX = "ES_MX",
  /** Nicaraguan Spanish */
  ES_NI = "ES_NI",
  /** Venezuelan Spanish */
  ES_VE = "ES_VE",
  /** Estonian */
  ET = "ET",
  /** Basque */
  EU = "EU",
  /** Persian */
  FA = "FA",
  /** Finnish */
  FI = "FI",
  /** French */
  FR = "FR",
  /** Frisian */
  FY = "FY",
  /** Irish */
  GA = "GA",
  /** Scottish Gaelic */
  GD = "GD",
  /** Galician */
  GL = "GL",
  /** Hebrew */
  HE = "HE",
  /** Hindi */
  HI = "HI",
  /** Croatian */
  HR = "HR",
  /** Upper Sorbian */
  HSB = "HSB",
  /** Hungarian */
  HU = "HU",
  /** Armenian */
  HY = "HY",
  /** Interlingua */
  IA = "IA",
  /** Indonesian */
  ID = "ID",
  /** Igbo */
  IG = "IG",
  /** Ido */
  IO = "IO",
  /** Icelandic */
  IS = "IS",
  /** Italian */
  IT = "IT",
  /** Japanese */
  JA = "JA",
  /** Georgian */
  KA = "KA",
  /** Kabyle */
  KAB = "KAB",
  /** Kazakh */
  KK = "KK",
  /** Khmer */
  KM = "KM",
  /** Kannada */
  KN = "KN",
  /** Korean */
  KO = "KO",
  /** Kyrgyz */
  KY = "KY",
  /** Luxembourgish */
  LB = "LB",
  /** Lithuanian */
  LT = "LT",
  /** Latvian */
  LV = "LV",
  /** Macedonian */
  MK = "MK",
  /** Malayalam */
  ML = "ML",
  /** Mongolian */
  MN = "MN",
  /** Marathi */
  MR = "MR",
  /** Malay */
  MS = "MS",
  /** Burmese */
  MY = "MY",
  /** Norwegian Bokmål */
  NB = "NB",
  /** Nepali */
  NE = "NE",
  /** Dutch */
  NL = "NL",
  /** Norwegian Nynorsk */
  NN = "NN",
  /** Ossetic */
  OS = "OS",
  /** Punjabi */
  PA = "PA",
  /** Polish */
  PL = "PL",
  /** Portuguese */
  PT = "PT",
  /** Brazilian Portuguese */
  PT_BR = "PT_BR",
  /** Romanian */
  RO = "RO",
  /** Russian */
  RU = "RU",
  /** Slovak */
  SK = "SK",
  /** Slovenian */
  SL = "SL",
  /** Albanian */
  SQ = "SQ",
  /** Serbian */
  SR = "SR",
  /** Serbian Latin */
  SR_LATN = "SR_LATN",
  /** Swedish */
  SV = "SV",
  /** Swahili */
  SW = "SW",
  /** Tamil */
  TA = "TA",
  /** Telugu */
  TE = "TE",
  /** Tajik */
  TG = "TG",
  /** Thai */
  TH = "TH",
  /** Turkmen */
  TK = "TK",
  /** Turkish */
  TR = "TR",
  /** Tatar */
  TT = "TT",
  /** Udmurt */
  UDM = "UDM",
  /** Uyghur */
  UG = "UG",
  /** Ukrainian */
  UK = "UK",
  /** Urdu */
  UR = "UR",
  /** Uzbek */
  UZ = "UZ",
  /** Vietnamese */
  VI = "VI",
  /** Simplified Chinese */
  ZH_HANS = "ZH_HANS",
  /** Traditional Chinese */
  ZH_HANT = "ZH_HANT",
}

/** An enumeration. */
export enum AuthAccountUserJobTypeChoices {
  /** Apprenticeship */
  APPRENTICESHIP = "APPRENTICESHIP",
  /** Fix Term Contract */
  FIX_TERM_CONTRACT = "FIX_TERM_CONTRACT",
  /** Freelance */
  FREELANCE = "FREELANCE",
  /** Full Time */
  FULL_TIME = "FULL_TIME",
  /** Internship/Co-op */
  INTERNSHIP_CO_OP = "INTERNSHIP_CO_OP",
  /** Part Time */
  PART_TIME = "PART_TIME",
  /** Permanent */
  PERMANENT = "PERMANENT",
  /** Prince Edward Island */
  PRINCE_EDWARD_ISLAND = "PRINCE_EDWARD_ISLAND",
  /** Seasonal */
  SEASONAL = "SEASONAL",
}

/** An enumeration. */
export enum AuthAccountUserOrderByChoices {
  /** Date joined */
  DATE_JOINED = "DATE_JOINED",
  /** Id */
  ID = "ID",
  /** Date joined (descending) */
  _DATE_JOINED = "_DATE_JOINED",
  /** Id (descending) */
  _ID = "_ID",
}

/** An enumeration. */
export enum AuthAccountUserTaskStatusChoices {
  /** Completed */
  COMPLETED = "COMPLETED",
  /** Failed */
  FAILED = "FAILED",
  /** In Progress */
  IN_PROGRESS = "IN_PROGRESS",
  /** Scheduled */
  SCHEDULED = "SCHEDULED",
  /** Timed-Out */
  TIMEDOUT = "TIMEDOUT",
}

/** An enumeration. */
export enum AuthAccountUserTaskTaskNameChoices {
  /** admin_perform_job_suggestion */
  ADMIN_PERFORM_JOB_SUGGESTION = "ADMIN_PERFORM_JOB_SUGGESTION",
  /** clean_revoked_tokens */
  CLEAN_REVOKED_TOKENS = "CLEAN_REVOKED_TOKENS",
  /** clean_unverified_expired_users */
  CLEAN_UNVERIFIED_EXPIRED_USERS = "CLEAN_UNVERIFIED_EXPIRED_USERS",
  /** extract_job_position_from_file_task */
  EXTRACT_JOB_POSITION_FROM_FILE_TASK = "EXTRACT_JOB_POSITION_FROM_FILE_TASK",
  /** get_certificate_text */
  GET_CERTIFICATE_TEXT = "GET_CERTIFICATE_TEXT",
  /** perform_job_suggestion */
  PERFORM_JOB_SUGGESTION = "PERFORM_JOB_SUGGESTION",
  /** render_cv_template */
  RENDER_CV_TEMPLATE = "RENDER_CV_TEMPLATE",
  /** self_verify_documents */
  SELF_VERIFY_DOCUMENTS = "SELF_VERIFY_DOCUMENTS",
  /** send_campaign_notifications */
  SEND_CAMPAIGN_NOTIFICATIONS = "SEND_CAMPAIGN_NOTIFICATIONS",
  /** send_email_async */
  SEND_EMAIL_ASYNC = "SEND_EMAIL_ASYNC",
  /** send_email_async_non_existing_user */
  SEND_EMAIL_ASYNC_NON_EXISTING_USER = "SEND_EMAIL_ASYNC_NON_EXISTING_USER",
  /** set_expiry */
  SET_EXPIRY = "SET_EXPIRY",
  /** set_job_position_cooperation_status */
  SET_JOB_POSITION_COOPERATION_STATUS = "SET_JOB_POSITION_COOPERATION_STATUS",
}

/** An enumeration. */
export enum AuthAccountWorkExperienceGradeChoices {
  /** Associate */
  ASSOCIATE = "ASSOCIATE",
  /** CEO */
  CEO = "CEO",
  /** CFO */
  CFO = "CFO",
  /** CTO */
  CTO = "CTO",
  /** Director */
  DIRECTOR = "DIRECTOR",
  /** Intern */
  INTERN = "INTERN",
  /** Junior */
  JUNIOR = "JUNIOR",
  /** Manager */
  MANAGER = "MANAGER",
  /** Mid-Level */
  MID_LEVEL = "MID_LEVEL",
  /** Senior */
  SENIOR = "SENIOR",
}

/** An enumeration. */
export enum AuthAccountWorkExperienceStatusChoices {
  /** Drafted */
  DRAFTED = "DRAFTED",
  /** Rejected */
  REJECTED = "REJECTED",
  /** Self Verified */
  SELF_VERIFIED = "SELF_VERIFIED",
  /** Submitted */
  SUBMITTED = "SUBMITTED",
  /** Verified */
  VERIFIED = "VERIFIED",
}

export type AvatarFileType = {
  __typename?: "AvatarFileType";
  file: Scalars["String"]["output"];
};

export type BaseFileModelType = {
  __typename?: "BaseFileModelType";
  file: Scalars["String"]["output"];
  id: Scalars["ID"]["output"];
};

export type BatchCreateContactInput = {
  type?: InputMaybe<AuthAccountContactTypeChoices>;
  value: Scalars["String"]["input"];
};

export type CvMutation = {
  __typename?: "CVMutation";
  generateResume?: Maybe<GenerateResumeMutation>;
};

export type CvMutationGenerateResumeArgs = {
  templateId?: InputMaybe<Scalars["NotEmptyID"]["input"]>;
};

export type CvQuery = {
  __typename?: "CVQuery";
  templates?: Maybe<CvTemplateNodeConnection>;
};

export type CvQueryTemplatesArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>;
  before?: InputMaybe<Scalars["String"]["input"]>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  title_Icontains?: InputMaybe<Scalars["String"]["input"]>;
};

export type CvTemplateNode = {
  __typename?: "CVTemplateNode";
  id: Scalars["ID"]["output"];
  title: Scalars["String"]["output"];
};

export type CvTemplateNodeConnection = {
  __typename?: "CVTemplateNodeConnection";
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<CvTemplateNodeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

/** A Relay edge containing a `CVTemplateNode` and its cursor. */
export type CvTemplateNodeEdge = {
  __typename?: "CVTemplateNodeEdge";
  /** A cursor for use in pagination */
  cursor: Scalars["String"]["output"];
  /** The item at the end of the edge */
  node?: Maybe<CvTemplateNode>;
};

export type CalendarEventAttendeeType = {
  __typename?: "CalendarEventAttendeeType";
  firstName?: Maybe<Scalars["String"]["output"]>;
  id: Scalars["ID"]["output"];
  lastName?: Maybe<Scalars["String"]["output"]>;
};

/** An enumeration. */
export enum CalendarEventObjectType {
  job_position_interview = "job_position_interview",
}

export type CalendarEventRelatedObjectType = {
  __typename?: "CalendarEventRelatedObjectType";
  key?: Maybe<CalendarEventObjectType>;
  pk?: Maybe<Scalars["ID"]["output"]>;
};

export type CalendarEventStatusUpdateMutation = {
  __typename?: "CalendarEventStatusUpdateMutation";
  calendarEvent?: Maybe<CalendarEventType>;
};

export type CalendarEventType = {
  __typename?: "CalendarEventType";
  attendees?: Maybe<Array<Maybe<CalendarEventAttendeeType>>>;
  datetime?: Maybe<Scalars["DateTimeRangeScalar"]["output"]>;
  meetUrl?: Maybe<Scalars["String"]["output"]>;
  relatedObject?: Maybe<CalendarEventRelatedObjectType>;
  status: FlexCalendarCalendarEventStatusChoices;
};

export type CalendarQuery = {
  __typename?: "CalendarQuery";
  calendars?: Maybe<Array<Maybe<CalendarType>>>;
};

export type CalendarType = {
  __typename?: "CalendarType";
  events: Array<CalendarEventType>;
  id: Scalars["ID"]["output"];
};

export type CanadaVisaCreateOrUpdateMutation = {
  __typename?: "CanadaVisaCreateOrUpdateMutation";
  canadaVisa?: Maybe<CanadaVisaNode>;
};

export type CanadaVisaMutation = {
  __typename?: "CanadaVisaMutation";
  createOrUpdate?: Maybe<CanadaVisaCreateOrUpdateMutation>;
};

export type CanadaVisaMutationCreateOrUpdateArgs = {
  input: UpdateCanadaVisaInput;
};

export type CanadaVisaNode = {
  __typename?: "CanadaVisaNode";
  citizenshipDocument?: Maybe<CitizenshipDocumentFileType>;
  id: Scalars["ID"]["output"];
  nationality?: Maybe<CountryNode>;
  status: AuthAccountCanadaVisaStatusChoices;
};

export type CertificateAndLicenseAiType = {
  __typename?: "CertificateAndLicenseAIType";
  certifier?: Maybe<Scalars["String"]["output"]>;
  expiredAt?: Maybe<Scalars["Date"]["output"]>;
  issuedAt?: Maybe<Scalars["Date"]["output"]>;
  title?: Maybe<Scalars["String"]["output"]>;
};

export type CertificateAndLicenseAnalyseAndExtractDataMutation = {
  __typename?: "CertificateAndLicenseAnalyseAndExtractDataMutation";
  data?: Maybe<CertificateAndLicenseAiType>;
  isValid?: Maybe<Scalars["Boolean"]["output"]>;
  verificationMethodData?: Maybe<Scalars["String"]["output"]>;
};

export type CertificateAndLicenseCreateMutation = {
  __typename?: "CertificateAndLicenseCreateMutation";
  certificateAndLicense?: Maybe<CertificateAndLicenseNode>;
};

export type CertificateAndLicenseMutation = {
  __typename?: "CertificateAndLicenseMutation";
  analyseAndExtractData?: Maybe<CertificateAndLicenseAnalyseAndExtractDataMutation>;
  create?: Maybe<CertificateAndLicenseCreateMutation>;
  update?: Maybe<CertificateAndLicenseUpdateMutation>;
};

export type CertificateAndLicenseMutationAnalyseAndExtractDataArgs = {
  fileId: Scalars["NotEmptyID"]["input"];
};

export type CertificateAndLicenseMutationCreateArgs = {
  input: CreateCertificateAndLicenseAndSetVerificationMethodInput;
};

export type CertificateAndLicenseMutationUpdateArgs = {
  id: Scalars["ID"]["input"];
  input: PatchCertificateAndLicenseInput;
};

export type CertificateAndLicenseNode = {
  __typename?: "CertificateAndLicenseNode";
  allowSelfVerification: Scalars["Boolean"]["output"];
  certificateandlicenseofflineverificationmethod?: Maybe<CertificateAndLicenseOfflineVerificationMethodType>;
  certificateandlicenseonlineverificationmethod?: Maybe<CertificateAndLicenseOnlineVerificationMethodType>;
  certifier: Scalars["String"]["output"];
  expiredAt?: Maybe<Scalars["Date"]["output"]>;
  id: Scalars["ID"]["output"];
  issuedAt: Scalars["Date"]["output"];
  status: AuthAccountCertificateAndLicenseStatusChoices;
  title: Scalars["String"]["output"];
};

export type CertificateAndLicenseOfflineVerificationMethodType = {
  __typename?: "CertificateAndLicenseOfflineVerificationMethodType";
  certificateFile: CertificateFileType;
  id: Scalars["ID"]["output"];
};

export type CertificateAndLicenseOnlineVerificationMethodType = {
  __typename?: "CertificateAndLicenseOnlineVerificationMethodType";
  certificateLink: Scalars["String"]["output"];
  id: Scalars["ID"]["output"];
};

export type CertificateAndLicenseQuery = {
  __typename?: "CertificateAndLicenseQuery";
  get?: Maybe<CertificateAndLicenseNode>;
};

export type CertificateAndLicenseQueryGetArgs = {
  id: Scalars["NotEmptyID"]["input"];
};

export type CertificateAndLicenseUpdateMutation = {
  __typename?: "CertificateAndLicenseUpdateMutation";
  certificateAndLicense?: Maybe<CertificateAndLicenseNode>;
};

export type CertificateFileType = {
  __typename?: "CertificateFileType";
  file: Scalars["String"]["output"];
};

/** An enumeration. */
export enum CitiesLightCountryContinentChoices {
  /** Africa */
  AF = "AF",
  /** Antarctica */
  AN = "AN",
  /** Asia */
  AS = "AS",
  /** Europe */
  EU = "EU",
  /** North America */
  NA = "NA",
  /** Oceania */
  OC = "OC",
  /** South America */
  SA = "SA",
}

export type CitizenshipDocumentFileType = {
  __typename?: "CitizenshipDocumentFileType";
  file: Scalars["String"]["output"];
};

export type CityNode = {
  __typename?: "CityNode";
  alternateNames?: Maybe<Scalars["String"]["output"]>;
  country: CountryNode;
  displayName: Scalars["String"]["output"];
  featureCode?: Maybe<Scalars["String"]["output"]>;
  geonameId?: Maybe<Scalars["Int"]["output"]>;
  id: Scalars["ID"]["output"];
  latitude?: Maybe<Scalars["Decimal"]["output"]>;
  longitude?: Maybe<Scalars["Decimal"]["output"]>;
  name: Scalars["String"]["output"];
  nameAscii: Scalars["String"]["output"];
  population?: Maybe<Scalars["BigInt"]["output"]>;
  region?: Maybe<RegionNode>;
  searchNames: Scalars["String"]["output"];
  slug: Scalars["String"]["output"];
  subregion?: Maybe<SubRegionNode>;
  timezone?: Maybe<Scalars["String"]["output"]>;
};

export type CityNodeConnection = {
  __typename?: "CityNodeConnection";
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<CityNodeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

/** A Relay edge containing a `CityNode` and its cursor. */
export type CityNodeEdge = {
  __typename?: "CityNodeEdge";
  /** A cursor for use in pagination */
  cursor: Scalars["String"]["output"];
  /** The item at the end of the edge */
  node?: Maybe<CityNode>;
};

/** An enumeration. */
export enum CommonIndustryOrderByChoices {
  /** Order */
  ORDER = "ORDER",
  /** Order (descending) */
  _ORDER = "_ORDER",
}

/** An enumeration. */
export enum CommonLanguageProficiencyTestLanguagesChoices {
  /** Afrikaans */
  AF = "AF",
  /** Arabic */
  AR = "AR",
  /** Algerian Arabic */
  AR_DZ = "AR_DZ",
  /** Asturian */
  AST = "AST",
  /** Azerbaijani */
  AZ = "AZ",
  /** Belarusian */
  BE = "BE",
  /** Bulgarian */
  BG = "BG",
  /** Bengali */
  BN = "BN",
  /** Breton */
  BR = "BR",
  /** Bosnian */
  BS = "BS",
  /** Catalan */
  CA = "CA",
  /** Central Kurdish (Sorani) */
  CKB = "CKB",
  /** Czech */
  CS = "CS",
  /** Welsh */
  CY = "CY",
  /** Danish */
  DA = "DA",
  /** German */
  DE = "DE",
  /** Lower Sorbian */
  DSB = "DSB",
  /** Greek */
  EL = "EL",
  /** English */
  EN = "EN",
  /** Australian English */
  EN_AU = "EN_AU",
  /** British English */
  EN_GB = "EN_GB",
  /** Esperanto */
  EO = "EO",
  /** Spanish */
  ES = "ES",
  /** Argentinian Spanish */
  ES_AR = "ES_AR",
  /** Colombian Spanish */
  ES_CO = "ES_CO",
  /** Mexican Spanish */
  ES_MX = "ES_MX",
  /** Nicaraguan Spanish */
  ES_NI = "ES_NI",
  /** Venezuelan Spanish */
  ES_VE = "ES_VE",
  /** Estonian */
  ET = "ET",
  /** Basque */
  EU = "EU",
  /** Persian */
  FA = "FA",
  /** Finnish */
  FI = "FI",
  /** French */
  FR = "FR",
  /** Frisian */
  FY = "FY",
  /** Irish */
  GA = "GA",
  /** Scottish Gaelic */
  GD = "GD",
  /** Galician */
  GL = "GL",
  /** Hebrew */
  HE = "HE",
  /** Hindi */
  HI = "HI",
  /** Croatian */
  HR = "HR",
  /** Upper Sorbian */
  HSB = "HSB",
  /** Hungarian */
  HU = "HU",
  /** Armenian */
  HY = "HY",
  /** Interlingua */
  IA = "IA",
  /** Indonesian */
  ID = "ID",
  /** Igbo */
  IG = "IG",
  /** Ido */
  IO = "IO",
  /** Icelandic */
  IS = "IS",
  /** Italian */
  IT = "IT",
  /** Japanese */
  JA = "JA",
  /** Georgian */
  KA = "KA",
  /** Kabyle */
  KAB = "KAB",
  /** Kazakh */
  KK = "KK",
  /** Khmer */
  KM = "KM",
  /** Kannada */
  KN = "KN",
  /** Korean */
  KO = "KO",
  /** Kyrgyz */
  KY = "KY",
  /** Luxembourgish */
  LB = "LB",
  /** Lithuanian */
  LT = "LT",
  /** Latvian */
  LV = "LV",
  /** Macedonian */
  MK = "MK",
  /** Malayalam */
  ML = "ML",
  /** Mongolian */
  MN = "MN",
  /** Marathi */
  MR = "MR",
  /** Malay */
  MS = "MS",
  /** Burmese */
  MY = "MY",
  /** Norwegian Bokmål */
  NB = "NB",
  /** Nepali */
  NE = "NE",
  /** Dutch */
  NL = "NL",
  /** Norwegian Nynorsk */
  NN = "NN",
  /** Ossetic */
  OS = "OS",
  /** Punjabi */
  PA = "PA",
  /** Polish */
  PL = "PL",
  /** Portuguese */
  PT = "PT",
  /** Brazilian Portuguese */
  PT_BR = "PT_BR",
  /** Romanian */
  RO = "RO",
  /** Russian */
  RU = "RU",
  /** Slovak */
  SK = "SK",
  /** Slovenian */
  SL = "SL",
  /** Albanian */
  SQ = "SQ",
  /** Serbian */
  SR = "SR",
  /** Serbian Latin */
  SR_LATN = "SR_LATN",
  /** Swedish */
  SV = "SV",
  /** Swahili */
  SW = "SW",
  /** Tamil */
  TA = "TA",
  /** Telugu */
  TE = "TE",
  /** Tajik */
  TG = "TG",
  /** Thai */
  TH = "TH",
  /** Turkmen */
  TK = "TK",
  /** Turkish */
  TR = "TR",
  /** Tatar */
  TT = "TT",
  /** Udmurt */
  UDM = "UDM",
  /** Uyghur */
  UG = "UG",
  /** Ukrainian */
  UK = "UK",
  /** Urdu */
  UR = "UR",
  /** Uzbek */
  UZ = "UZ",
  /** Vietnamese */
  VI = "VI",
  /** Simplified Chinese */
  ZH_HANS = "ZH_HANS",
  /** Traditional Chinese */
  ZH_HANT = "ZH_HANT",
}

export type CommonMutation = {
  __typename?: "CommonMutation";
  uploadFile?: Maybe<UploadFileMutation>;
};

export type CommonMutationUploadFileArgs = {
  file: Scalars["Upload"]["input"];
  type: UploadType;
};

export type CommonQuery = {
  __typename?: "CommonQuery";
  cities?: Maybe<CityNodeConnection>;
  countries?: Maybe<CountryNodeConnection>;
  fields?: Maybe<FieldNodeConnection>;
  industries?: Maybe<IndustryNodeConnection>;
  jobBenefits?: Maybe<JobBenefitNodeConnection>;
  jobs?: Maybe<JobNodeConnection>;
  languagesProficiencyTests?: Maybe<LanguageProficiencyTestNodeConnection>;
  regions?: Maybe<RegionNodeConnection>;
  skills?: Maybe<SkillNodeConnection>;
  universities?: Maybe<UniversityNodeConnection>;
};

export type CommonQueryCitiesArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>;
  before?: InputMaybe<Scalars["String"]["input"]>;
  country_Code2?: InputMaybe<Scalars["String"]["input"]>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  id?: InputMaybe<Scalars["ID"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  name_Icontains?: InputMaybe<Scalars["String"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  region?: InputMaybe<Scalars["ID"]["input"]>;
};

export type CommonQueryCountriesArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>;
  before?: InputMaybe<Scalars["String"]["input"]>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  id?: InputMaybe<Scalars["ID"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  name_Icontains?: InputMaybe<Scalars["String"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
};

export type CommonQueryFieldsArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>;
  before?: InputMaybe<Scalars["String"]["input"]>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  id?: InputMaybe<Scalars["ID"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  name_Icontains?: InputMaybe<Scalars["String"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
};

export type CommonQueryIndustriesArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>;
  before?: InputMaybe<Scalars["String"]["input"]>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  id?: InputMaybe<Scalars["ID"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<CommonIndustryOrderByChoices>;
  title_Icontains?: InputMaybe<Scalars["String"]["input"]>;
};

export type CommonQueryJobBenefitsArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>;
  before?: InputMaybe<Scalars["String"]["input"]>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  id?: InputMaybe<Scalars["ID"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  name_Icontains?: InputMaybe<Scalars["String"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
};

export type CommonQueryJobsArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>;
  before?: InputMaybe<Scalars["String"]["input"]>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  id?: InputMaybe<Scalars["ID"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  title_Icontains?: InputMaybe<Scalars["String"]["input"]>;
};

export type CommonQueryLanguagesProficiencyTestsArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>;
  before?: InputMaybe<Scalars["String"]["input"]>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  id?: InputMaybe<Scalars["ID"]["input"]>;
  languages_Contains?: InputMaybe<Array<InputMaybe<CommonLanguageProficiencyTestLanguagesChoices>>>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  title_Icontains?: InputMaybe<Scalars["String"]["input"]>;
};

export type CommonQueryRegionsArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>;
  before?: InputMaybe<Scalars["String"]["input"]>;
  country?: InputMaybe<Scalars["ID"]["input"]>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  id?: InputMaybe<Scalars["ID"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  name_Icontains?: InputMaybe<Scalars["String"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
};

export type CommonQuerySkillsArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>;
  before?: InputMaybe<Scalars["String"]["input"]>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  id?: InputMaybe<Scalars["ID"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<CommonSkillOrderByChoices>;
  title_Icontains?: InputMaybe<Scalars["String"]["input"]>;
};

export type CommonQueryUniversitiesArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>;
  before?: InputMaybe<Scalars["String"]["input"]>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  id?: InputMaybe<Scalars["ID"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  name_Icontains?: InputMaybe<Scalars["String"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
};

/** An enumeration. */
export enum CommonSkillOrderByChoices {
  /** Order */
  ORDER = "ORDER",
  /** Order (descending) */
  _ORDER = "_ORDER",
}

export type CommunicateOrganizationMethodInput = {
  email?: InputMaybe<Scalars["String"]["input"]>;
  phonenumber: Scalars["String"]["input"];
};

export type CommunicateOrganizationMethodType = {
  __typename?: "CommunicateOrganizationMethodType";
  email?: Maybe<Scalars["String"]["output"]>;
  id: Scalars["ID"]["output"];
  phonenumber: Scalars["String"]["output"];
};

export type CommunicationMethodAiType = {
  __typename?: "CommunicationMethodAIType";
  department?: Maybe<Scalars["String"]["output"]>;
  email?: Maybe<Scalars["String"]["output"]>;
  person?: Maybe<Scalars["String"]["output"]>;
  website?: Maybe<Scalars["String"]["output"]>;
};

export type CommunicationMethodType = {
  __typename?: "CommunicationMethodType";
  degreeFile: DegreeFileType;
  department: Scalars["String"]["output"];
  email: Scalars["String"]["output"];
  id: Scalars["ID"]["output"];
  person: Scalars["String"]["output"];
  website: Scalars["String"]["output"];
};

export type ContactType = {
  __typename?: "ContactType";
  id: Scalars["ID"]["output"];
  type: AuthAccountContactTypeChoices;
  value: Scalars["String"]["output"];
};

export type CountryNode = {
  __typename?: "CountryNode";
  alternateNames?: Maybe<Scalars["String"]["output"]>;
  code2?: Maybe<Scalars["String"]["output"]>;
  code3?: Maybe<Scalars["String"]["output"]>;
  continent: CitiesLightCountryContinentChoices;
  geonameId?: Maybe<Scalars["Int"]["output"]>;
  id: Scalars["ID"]["output"];
  name: Scalars["String"]["output"];
  nameAscii: Scalars["String"]["output"];
  phone?: Maybe<Scalars["String"]["output"]>;
  slug: Scalars["String"]["output"];
  tld: Scalars["String"]["output"];
};

export type CountryNodeConnection = {
  __typename?: "CountryNodeConnection";
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<CountryNodeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

/** A Relay edge containing a `CountryNode` and its cursor. */
export type CountryNodeEdge = {
  __typename?: "CountryNodeEdge";
  /** A cursor for use in pagination */
  cursor: Scalars["String"]["output"];
  /** The item at the end of the edge */
  node?: Maybe<CountryNode>;
};

export type CourseNode = {
  __typename?: "CourseNode";
  description: Scalars["String"]["output"];
  externalId: Scalars["String"]["output"];
  id: Scalars["ID"]["output"];
  industries: IndustryNodeConnection;
  isGeneral?: Maybe<Scalars["Boolean"]["output"]>;
  logo?: Maybe<Scalars["String"]["output"]>;
  name: Scalars["String"]["output"];
  results: CourseResultTypeConnection;
};

export type CourseNodeIndustriesArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>;
  before?: InputMaybe<Scalars["String"]["input"]>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  id?: InputMaybe<Scalars["ID"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<CommonIndustryOrderByChoices>;
  title_Icontains?: InputMaybe<Scalars["String"]["input"]>;
};

export type CourseNodeResultsArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>;
  before?: InputMaybe<Scalars["String"]["input"]>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  status?: InputMaybe<AcademyCourseResultStatusChoices>;
};

export type CourseNodeConnection = {
  __typename?: "CourseNodeConnection";
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<CourseNodeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars["Int"]["output"]>;
};

/** A Relay edge containing a `CourseNode` and its cursor. */
export type CourseNodeEdge = {
  __typename?: "CourseNodeEdge";
  /** A cursor for use in pagination */
  cursor: Scalars["String"]["output"];
  /** The item at the end of the edge */
  node?: Maybe<CourseNode>;
};

export type CourseResultCreateMutation = {
  __typename?: "CourseResultCreateMutation";
  courseResult?: Maybe<CourseResultType>;
  startUrl: Scalars["String"]["output"];
};

export type CourseResultType = {
  __typename?: "CourseResultType";
  course: CourseNode;
  createdAt: Scalars["DateTime"]["output"];
  id: Scalars["ID"]["output"];
  status: AcademyCourseResultStatusChoices;
  updatedAt: Scalars["DateTime"]["output"];
  user: UserNode;
};

export type CourseResultTypeConnection = {
  __typename?: "CourseResultTypeConnection";
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<CourseResultTypeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars["Int"]["output"]>;
};

/** A Relay edge containing a `CourseResultType` and its cursor. */
export type CourseResultTypeEdge = {
  __typename?: "CourseResultTypeEdge";
  /** A cursor for use in pagination */
  cursor: Scalars["String"]["output"];
  /** The item at the end of the edge */
  node?: Maybe<CourseResultType>;
};

export type CreateCertificateAndLicenseAndSetVerificationMethodInput = {
  allowSelfVerification?: InputMaybe<Scalars["Boolean"]["input"]>;
  certificateandlicenseofflineverificationmethod?: InputMaybe<CreateCertificateAndLicenseAndSetVerificationMethodInputCreateCertificateandlicenseofflineverificationmethod>;
  certificateandlicenseonlineverificationmethod?: InputMaybe<CreateCertificateAndLicenseAndSetVerificationMethodInputCreateCertificateandlicenseonlineverificationmethod>;
  certifier: Scalars["String"]["input"];
  expiredAt?: InputMaybe<Scalars["Date"]["input"]>;
  issuedAt: Scalars["Date"]["input"];
  title: Scalars["String"]["input"];
};

export type CreateCertificateAndLicenseAndSetVerificationMethodInputCreateCertificateandlicenseofflineverificationmethod =
  {
    certificateFile: Scalars["ID"]["input"];
  };

export type CreateCertificateAndLicenseAndSetVerificationMethodInputCreateCertificateandlicenseonlineverificationmethod =
  {
    certificateLink: Scalars["String"]["input"];
  };

export type CreateEducationAndSetVerificationMethodInput = {
  allowSelfVerification?: InputMaybe<Scalars["Boolean"]["input"]>;
  city: Scalars["ID"]["input"];
  communicationmethod?: InputMaybe<CreateEducationAndSetVerificationMethodInputCreateCommunicationmethod>;
  degree: AuthAccountEducationDegreeChoices;
  end?: InputMaybe<Scalars["Date"]["input"]>;
  field: Scalars["ID"]["input"];
  ieemethod?: InputMaybe<CreateEducationAndSetVerificationMethodInputCreateIeemethod>;
  start: Scalars["Date"]["input"];
  university: Scalars["ID"]["input"];
};

export type CreateEducationAndSetVerificationMethodInputCreateCommunicationmethod = {
  degreeFile: Scalars["ID"]["input"];
  department: Scalars["String"]["input"];
  email: Scalars["String"]["input"];
  person: Scalars["String"]["input"];
  website: Scalars["String"]["input"];
};

export type CreateEducationAndSetVerificationMethodInputCreateIeemethod = {
  educationEvaluationDocument: Scalars["ID"]["input"];
  evaluator?: InputMaybe<IeeMethodEvaluator>;
};

export type CreateLanguageCertificateAndSetVerificationMethodInput = {
  allowSelfVerification?: InputMaybe<Scalars["Boolean"]["input"]>;
  expiredAt?: InputMaybe<Scalars["Date"]["input"]>;
  issuedAt: Scalars["Date"]["input"];
  language: AuthAccountLanguageCertificateLanguageChoices;
  offlinemethod?: InputMaybe<CreateLanguageCertificateAndSetVerificationMethodInputCreateOfflinemethod>;
  onlinemethod?: InputMaybe<CreateLanguageCertificateAndSetVerificationMethodInputCreateOnlinemethod>;
  test: Scalars["ID"]["input"];
  values?: InputMaybe<
    Array<InputMaybe<CreateLanguageCertificateAndSetVerificationMethodInputExactLanguageCertificateValues>>
  >;
};

export type CreateLanguageCertificateAndSetVerificationMethodInputCreateOfflinemethod = {
  certificateFile: Scalars["ID"]["input"];
};

export type CreateLanguageCertificateAndSetVerificationMethodInputCreateOnlinemethod = {
  certificateLink: Scalars["String"]["input"];
};

export type CreateLanguageCertificateAndSetVerificationMethodInputExactLanguageCertificateValues = {
  skill: Scalars["ID"]["input"];
  value: Scalars["String"]["input"];
};

export type CreateOrganizationInvitationInput = {
  email: Scalars["String"]["input"];
  organization: Scalars["ID"]["input"];
  role: Scalars["ID"]["input"];
};

export type CreateOrganizationJobPositionInput = {
  ageRange?: InputMaybe<Array<InputMaybe<Scalars["Int"]["input"]>>>;
  benefits?: InputMaybe<Array<InputMaybe<Scalars["ID"]["input"]>>>;
  cities?: InputMaybe<Array<InputMaybe<Scalars["ID"]["input"]>>>;
  contractType?: InputMaybe<AuthAccountOrganizationJobPositionContractTypeChoices>;
  daysOff?: InputMaybe<Array<InputMaybe<AuthAccountOrganizationJobPositionDaysOffChoices>>>;
  degrees?: InputMaybe<Array<InputMaybe<AuthAccountOrganizationJobPositionDegreesChoices>>>;
  description?: InputMaybe<Scalars["String"]["input"]>;
  employerQuestions?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  fields?: InputMaybe<Array<InputMaybe<Scalars["ID"]["input"]>>>;
  hiringInCanada?: InputMaybe<Scalars["Boolean"]["input"]>;
  jobRestrictions?: InputMaybe<Scalars["String"]["input"]>;
  languages?: InputMaybe<Array<InputMaybe<AuthAccountOrganizationJobPositionLanguagesChoices>>>;
  locationType?: InputMaybe<AuthAccountOrganizationJobPositionLocationTypeChoices>;
  nativeLanguages?: InputMaybe<Array<InputMaybe<AuthAccountOrganizationJobPositionNativeLanguagesChoices>>>;
  organization: Scalars["ID"]["input"];
  otherBenefits?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  paymentTerm?: InputMaybe<AuthAccountOrganizationJobPositionPaymentTermChoices>;
  performanceExpectation?: InputMaybe<Scalars["String"]["input"]>;
  requiredDocuments?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  salaryRange?: InputMaybe<Array<InputMaybe<Scalars["Int"]["input"]>>>;
  skills?: InputMaybe<Array<InputMaybe<Scalars["ID"]["input"]>>>;
  startAt?: InputMaybe<Scalars["Date"]["input"]>;
  title?: InputMaybe<Scalars["String"]["input"]>;
  vaccancy?: InputMaybe<Scalars["Int"]["input"]>;
  validityDays?: InputMaybe<Scalars["Int"]["input"]>;
  workExperienceYearsRange?: InputMaybe<Array<InputMaybe<Scalars["Int"]["input"]>>>;
  workingEndAt?: InputMaybe<Scalars["Time"]["input"]>;
  workingStartAt?: InputMaybe<Scalars["Time"]["input"]>;
};

export type CreateSupportTicketInput = {
  category: Scalars["ID"]["input"];
  contactMethod: AuthAccountSupportTicketContactMethodChoices;
  contactValue: Scalars["String"]["input"];
  description: Scalars["String"]["input"];
  priority: AuthAccountSupportTicketPriorityChoices;
  title: Scalars["String"]["input"];
};

export type CreateWorkExperienceAndSetVerificationMethodInput = {
  allowSelfVerification?: InputMaybe<Scalars["Boolean"]["input"]>;
  city: Scalars["ID"]["input"];
  employerlettermethod?: InputMaybe<WorkExperienceEmployerLetterMethodInput>;
  end?: InputMaybe<Scalars["Date"]["input"]>;
  grade: AuthAccountWorkExperienceGradeChoices;
  jobTitle: Scalars["String"]["input"];
  organization: Scalars["String"]["input"];
  paystubsmethod?: InputMaybe<CreateWorkExperienceAndSetVerificationMethodInputCreatePaystubsmethod>;
  skills?: InputMaybe<Scalars["String"]["input"]>;
  start: Scalars["Date"]["input"];
};

export type CreateWorkExperienceAndSetVerificationMethodInputCreatePaystubsmethod = {
  paystubs: Scalars["ID"]["input"];
};

export type DnstxtRecordMethodType = {
  __typename?: "DNSTXTRecordMethodType";
  code: Scalars["String"]["output"];
  id: Scalars["ID"]["output"];
};

export type DegreeFileType = {
  __typename?: "DegreeFileType";
  file: Scalars["String"]["output"];
};

export type EducationAiType = {
  __typename?: "EducationAIType";
  city?: Maybe<CityNode>;
  degree?: Maybe<AuthAccountEducationDegreeChoices>;
  end?: Maybe<Scalars["Date"]["output"]>;
  field?: Maybe<FieldType>;
  start?: Maybe<Scalars["Date"]["output"]>;
  university?: Maybe<UniversityNode>;
};

export type EducationAnalyseAndExtractDataMutation = {
  __typename?: "EducationAnalyseAndExtractDataMutation";
  data?: Maybe<EducationAiType>;
  isValid?: Maybe<Scalars["Boolean"]["output"]>;
  verificationMethodData?: Maybe<EducationVerificationMethodType>;
};

export type EducationCreateMutation = {
  __typename?: "EducationCreateMutation";
  education?: Maybe<EducationNode>;
};

export type EducationEvaluationDocumentFileType = {
  __typename?: "EducationEvaluationDocumentFileType";
  file: Scalars["String"]["output"];
};

export type EducationMutation = {
  __typename?: "EducationMutation";
  analyseAndExtractData?: Maybe<EducationAnalyseAndExtractDataMutation>;
  create?: Maybe<EducationCreateMutation>;
  update?: Maybe<EducationUpdateMutation>;
};

export type EducationMutationAnalyseAndExtractDataArgs = {
  fileId: Scalars["NotEmptyID"]["input"];
  verificationType: EducationVerificationMethodUploadType;
};

export type EducationMutationCreateArgs = {
  input: CreateEducationAndSetVerificationMethodInput;
};

export type EducationMutationUpdateArgs = {
  id: Scalars["ID"]["input"];
  input: PatchEducationInput;
};

export type EducationNode = {
  __typename?: "EducationNode";
  allowSelfVerification: Scalars["Boolean"]["output"];
  city: CityNode;
  communicationmethod?: Maybe<CommunicationMethodType>;
  createdAt: Scalars["DateTime"]["output"];
  degree: AuthAccountEducationDegreeChoices;
  end?: Maybe<Scalars["Date"]["output"]>;
  field: FieldType;
  id: Scalars["ID"]["output"];
  ieemethod?: Maybe<IeeMethodType>;
  start: Scalars["Date"]["output"];
  status: AuthAccountEducationStatusChoices;
  university: UniversityNode;
  updatedAt: Scalars["DateTime"]["output"];
};

export type EducationQuery = {
  __typename?: "EducationQuery";
  get?: Maybe<EducationNode>;
};

export type EducationQueryGetArgs = {
  id: Scalars["NotEmptyID"]["input"];
};

export type EducationUpdateMutation = {
  __typename?: "EducationUpdateMutation";
  education?: Maybe<EducationNode>;
};

export type EducationVerificationMethodType = CommunicationMethodAiType | IeeMethodAiType;

/** An enumeration. */
export enum EducationVerificationMethodUploadType {
  /** Degree File */
  DEGREE = "DEGREE",
  /** Education Evaluation Document File */
  EDUCATION_EVALUATION = "EDUCATION_EVALUATION",
}

export type EmployeeType = {
  __typename?: "EmployeeType";
  assessments?: Maybe<Array<Maybe<OrganizationAssessmentType>>>;
  certificateandlicenses?: Maybe<Array<JobSeekerCertificateAndLicenseType>>;
  courses?: Maybe<CourseNodeConnection>;
  cv?: Maybe<JobSeekerGeneratedCvType>;
  educations?: Maybe<Array<JobSeekerEducationType>>;
  email: Scalars["String"]["output"];
  firstName: Scalars["String"]["output"];
  languagecertificates?: Maybe<Array<JobSeekerLanguageCertificateType>>;
  lastName: Scalars["String"]["output"];
  profile?: Maybe<JobSeekerProfileType>;
  resume?: Maybe<ResumeType>;
  workexperiences?: Maybe<Array<JobSeekerWorkExperienceType>>;
};

export type EmployeeTypeCoursesArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>;
  before?: InputMaybe<Scalars["String"]["input"]>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  results_Status?: InputMaybe<AcademyCourseResultStatusChoices>;
};

export type EmployerLetterFileType = {
  __typename?: "EmployerLetterFileType";
  file: Scalars["String"]["output"];
};

export type EmployerLetterMethodType = {
  __typename?: "EmployerLetterMethodType";
  employerLetter: EmployerLetterFileType;
  employers?: Maybe<Array<Maybe<ReferenceCheckEmployerType>>>;
  id: Scalars["ID"]["output"];
};

export type EmploymentMutation = {
  __typename?: "EmploymentMutation";
  selectInterviewSlot?: Maybe<SelectInterviewSlotMutation>;
  updateJobPositionAssignmentStatus?: Maybe<JobSeekerJobPositionAssignmentStatusUpdateMutation>;
};

export type EmploymentMutationSelectInterviewSlotArgs = {
  jobPositionAssignmentId: Scalars["ID"]["input"];
  slotId: Scalars["ID"]["input"];
};

export type EmploymentMutationUpdateJobPositionAssignmentStatusArgs = {
  id: Scalars["ID"]["input"];
  input: JobSeekerJobPositionAssignmentStatusUpdateInput;
};

export type FieldNode = {
  __typename?: "FieldNode";
  id: Scalars["ID"]["output"];
  name: Scalars["String"]["output"];
};

export type FieldNodeConnection = {
  __typename?: "FieldNodeConnection";
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<FieldNodeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

/** A Relay edge containing a `FieldNode` and its cursor. */
export type FieldNodeEdge = {
  __typename?: "FieldNodeEdge";
  /** A cursor for use in pagination */
  cursor: Scalars["String"]["output"];
  /** The item at the end of the edge */
  node?: Maybe<FieldNode>;
};

export type FieldType = {
  __typename?: "FieldType";
  id: Scalars["ID"]["output"];
  name: Scalars["String"]["output"];
};

/** An enumeration. */
export enum FlexCalendarCalendarEventStatusChoices {
  /** Canceled */
  CANCELED = "CANCELED",
  /** Completed */
  COMPLETED = "COMPLETED",
  /** Scheduled */
  SCHEDULED = "SCHEDULED",
  /** Started */
  STARTED = "STARTED",
}

export type FullBodyImageFileType = {
  __typename?: "FullBodyImageFileType";
  file: Scalars["String"]["output"];
};

export type GenerateAssessmentTokenMutation = {
  __typename?: "GenerateAssessmentTokenMutation";
  token?: Maybe<Scalars["String"]["output"]>;
};

export type GenerateResumeMutation = {
  __typename?: "GenerateResumeMutation";
  success?: Maybe<Scalars["Boolean"]["output"]>;
};

export type GeneratedCvNode = {
  __typename?: "GeneratedCVNode";
  file: Scalars["String"]["output"];
  modified: Scalars["DateTime"]["output"];
};

export type GoogleAuth = {
  __typename?: "GoogleAuth";
  payload?: Maybe<Scalars["GenericScalar"]["output"]>;
  refreshExpiresIn?: Maybe<Scalars["Int"]["output"]>;
  refreshToken?: Maybe<Scalars["String"]["output"]>;
  token?: Maybe<Scalars["String"]["output"]>;
};

export type HijackUserMutation = {
  __typename?: "HijackUserMutation";
  payload?: Maybe<Scalars["GenericScalar"]["output"]>;
  refreshExpiresIn?: Maybe<Scalars["Int"]["output"]>;
  refreshToken?: Maybe<Scalars["String"]["output"]>;
  token?: Maybe<Scalars["String"]["output"]>;
  user?: Maybe<UserNode>;
};

export type IeeMethodAiType = {
  __typename?: "IEEMethodAIType";
  evaluator?: Maybe<IeeMethodEvaluator>;
};

/** An enumeration. */
export enum IeeMethodEvaluator {
  /** Comparative Education Service */
  CES = "CES",
  /** International Credential Assessment Service of Canada */
  ICAS = "ICAS",
  /** International Qualifications Assessment Service */
  IQAS = "IQAS",
  /** Other */
  OTHER = "OTHER",
  /** World Education Services */
  WES = "WES",
}

export type IeeMethodType = {
  __typename?: "IEEMethodType";
  educationEvaluationDocument: EducationEvaluationDocumentFileType;
  id: Scalars["ID"]["output"];
};

export type InAppNotificationMutation = {
  __typename?: "InAppNotificationMutation";
  updateReadAt?: Maybe<InAppNotificationReadAtUpdateMutation>;
};

export type InAppNotificationMutationUpdateReadAtArgs = {
  input: Array<InputMaybe<InAppNotificationReadAtUpdateInput>>;
};

export type InAppNotificationNode = {
  __typename?: "InAppNotificationNode";
  action?: Maybe<NotificationActionType>;
  body: Scalars["String"]["output"];
  created: Scalars["DateTime"]["output"];
  id: Scalars["ID"]["output"];
  modified: Scalars["DateTime"]["output"];
  readAt?: Maybe<Scalars["DateTime"]["output"]>;
  title: Scalars["String"]["output"];
};

export type InAppNotificationReadAtUpdateInput = {
  id?: InputMaybe<Scalars["ID"]["input"]>;
};

export type InAppNotificationReadAtUpdateMutation = {
  __typename?: "InAppNotificationReadAtUpdateMutation";
  inAppNotifications?: Maybe<Array<Maybe<InAppNotificationNode>>>;
};

export type IndustryNode = {
  __typename?: "IndustryNode";
  id: Scalars["ID"]["output"];
  title: Scalars["String"]["output"];
};

export type IndustryNodeConnection = {
  __typename?: "IndustryNodeConnection";
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<IndustryNodeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

/** A Relay edge containing a `IndustryNode` and its cursor. */
export type IndustryNodeEdge = {
  __typename?: "IndustryNodeEdge";
  /** A cursor for use in pagination */
  cursor: Scalars["String"]["output"];
  /** The item at the end of the edge */
  node?: Maybe<IndustryNode>;
};

export type JobBenefitNode = {
  __typename?: "JobBenefitNode";
  id: Scalars["ID"]["output"];
  name: Scalars["String"]["output"];
};

export type JobBenefitNodeConnection = {
  __typename?: "JobBenefitNodeConnection";
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<JobBenefitNodeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

/** A Relay edge containing a `JobBenefitNode` and its cursor. */
export type JobBenefitNodeEdge = {
  __typename?: "JobBenefitNodeEdge";
  /** A cursor for use in pagination */
  cursor: Scalars["String"]["output"];
  /** The item at the end of the edge */
  node?: Maybe<JobBenefitNode>;
};

export type JobBenefitType = {
  __typename?: "JobBenefitType";
  id: Scalars["ID"]["output"];
  name: Scalars["String"]["output"];
};

export type JobNode = {
  __typename?: "JobNode";
  id: Scalars["ID"]["output"];
  industries: IndustryNodeConnection;
  requireAppearanceData: Scalars["Boolean"]["output"];
  title: Scalars["String"]["output"];
};

export type JobNodeIndustriesArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>;
  before?: InputMaybe<Scalars["String"]["input"]>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  id?: InputMaybe<Scalars["ID"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<CommonIndustryOrderByChoices>;
  title_Icontains?: InputMaybe<Scalars["String"]["input"]>;
};

export type JobNodeConnection = {
  __typename?: "JobNodeConnection";
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<JobNodeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

/** A Relay edge containing a `JobNode` and its cursor. */
export type JobNodeEdge = {
  __typename?: "JobNodeEdge";
  /** A cursor for use in pagination */
  cursor: Scalars["String"]["output"];
  /** The item at the end of the edge */
  node?: Maybe<JobNode>;
};

export type JobPositionAssignmentNode = {
  __typename?: "JobPositionAssignmentNode";
  createdAt: Scalars["DateTime"]["output"];
  hasActiveCooperationInOtherOrganizations?: Maybe<Scalars["Boolean"]["output"]>;
  id: Scalars["ID"]["output"];
  interviews?: Maybe<Array<Maybe<JobPositionInterviewType>>>;
  jobPosition?: Maybe<OrganizationJobPositionNode>;
  jobSeeker?: Maybe<JobSeekerUnionType>;
  jobSuggestionItem?: Maybe<JobSuggestionResultItemNode>;
  overQualificationReasons?: Maybe<Array<Maybe<Scalars["String"]["output"]>>>;
  status: AuthAccountJobPositionAssignmentStatusChoices;
  statusHistories?: Maybe<Array<Maybe<JobPositionAssignmentStatusHistoryType>>>;
};

export type JobPositionAssignmentNodeConnection = {
  __typename?: "JobPositionAssignmentNodeConnection";
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<JobPositionAssignmentNodeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars["Int"]["output"]>;
};

/** A Relay edge containing a `JobPositionAssignmentNode` and its cursor. */
export type JobPositionAssignmentNodeEdge = {
  __typename?: "JobPositionAssignmentNodeEdge";
  /** A cursor for use in pagination */
  cursor: Scalars["String"]["output"];
  /** The item at the end of the edge */
  node?: Maybe<JobPositionAssignmentNode>;
};

export type JobPositionAssignmentStatisticsType = {
  __typename?: "JobPositionAssignmentStatisticsType";
  acceptedCount?: Maybe<Scalars["Int"]["output"]>;
  awaitingInterviewDateCount?: Maybe<Scalars["Int"]["output"]>;
  awaitingJobseekerApprovalCount?: Maybe<Scalars["Int"]["output"]>;
  interviewCanceledCount?: Maybe<Scalars["Int"]["output"]>;
  interviewDoneCount?: Maybe<Scalars["Int"]["output"]>;
  interviewScheduledCount?: Maybe<Scalars["Int"]["output"]>;
  notReviewedCount?: Maybe<Scalars["Int"]["output"]>;
  rejectedByJobseekerCount?: Maybe<Scalars["Int"]["output"]>;
  rejectedCount?: Maybe<Scalars["Int"]["output"]>;
};

export type JobPositionAssignmentStatusCountType = {
  __typename?: "JobPositionAssignmentStatusCountType";
  count?: Maybe<Scalars["Int"]["output"]>;
  status?: Maybe<Scalars["String"]["output"]>;
};

export type JobPositionAssignmentStatusCountsType = {
  __typename?: "JobPositionAssignmentStatusCountsType";
  accepted?: Maybe<Scalars["Int"]["output"]>;
  awaitingInterviewDate?: Maybe<Scalars["Int"]["output"]>;
  awaitingJobseekerApproval?: Maybe<Scalars["Int"]["output"]>;
  interviewCanceled?: Maybe<Scalars["Int"]["output"]>;
  interviewDone?: Maybe<Scalars["Int"]["output"]>;
  interviewScheduled?: Maybe<Scalars["Int"]["output"]>;
  notReviewed?: Maybe<Scalars["Int"]["output"]>;
  rejected?: Maybe<Scalars["Int"]["output"]>;
  rejectedByJobseeker?: Maybe<Scalars["Int"]["output"]>;
};

export type JobPositionAssignmentStatusHistoryType = {
  __typename?: "JobPositionAssignmentStatusHistoryType";
  createdAt: Scalars["DateTime"]["output"];
  interview?: Maybe<JobPositionInterviewDetailType>;
  status: AuthAccountJobPositionAssignmentStatusHistoryStatusChoices;
};

export type JobPositionAssignmentStatusUpdateInput = {
  startAt?: InputMaybe<Scalars["Date"]["input"]>;
  status: AuthAccountJobPositionAssignmentStatusChoices;
};

export type JobPositionAssignmentStatusUpdateMutation = {
  __typename?: "JobPositionAssignmentStatusUpdateMutation";
  jobPositionAssignment?: Maybe<JobPositionAssignmentNode>;
};

export type JobPositionInterviewDetailType = {
  __typename?: "JobPositionInterviewDetailType";
  event: CalendarEventType;
  id: Scalars["ID"]["output"];
  jobPosition?: Maybe<OrganizationJobPositionNode>;
  jobPositionAssignment?: Maybe<JobPositionAssignmentNode>;
  slot?: Maybe<JobPositionInterviewSlotType>;
};

export type JobPositionInterviewSlotType = {
  __typename?: "JobPositionInterviewSlotType";
  datetime?: Maybe<Scalars["DateTimeRangeScalar"]["output"]>;
  id: Scalars["ID"]["output"];
  isAvailable?: Maybe<Scalars["Boolean"]["output"]>;
};

export type JobPositionInterviewType = {
  __typename?: "JobPositionInterviewType";
  event: CalendarEventType;
  id: Scalars["ID"]["output"];
  slot?: Maybe<JobPositionInterviewSlotType>;
};

export type JobPositionLocationTypeCountsType = {
  __typename?: "JobPositionLocationTypeCountsType";
  globalCount?: Maybe<Scalars["Int"]["output"]>;
  hybridCount?: Maybe<Scalars["Int"]["output"]>;
  limitedAreaCount?: Maybe<Scalars["Int"]["output"]>;
  onTheRoadCount?: Maybe<Scalars["Int"]["output"]>;
  preciseLocationCount?: Maybe<Scalars["Int"]["output"]>;
  remoteCount?: Maybe<Scalars["Int"]["output"]>;
};

export type JobPositionStatusCountsType = {
  __typename?: "JobPositionStatusCountsType";
  capacityFilled?: Maybe<Scalars["Int"]["output"]>;
  drafted?: Maybe<Scalars["Int"]["output"]>;
  expired?: Maybe<Scalars["Int"]["output"]>;
  published?: Maybe<Scalars["Int"]["output"]>;
  rejected?: Maybe<Scalars["Int"]["output"]>;
  submitted?: Maybe<Scalars["Int"]["output"]>;
  suspended?: Maybe<Scalars["Int"]["output"]>;
};

export type JobSeekerAssessmentResultType = {
  __typename?: "JobSeekerAssessmentResultType";
  evaluation?: Maybe<JobSeekerEvaluationType>;
  question: AssessmentResultQuestionType;
};

export type JobSeekerCertificateAndLicenseType = {
  __typename?: "JobSeekerCertificateAndLicenseType";
  certificateandlicenseofflineverificationmethod?: Maybe<CertificateAndLicenseOfflineVerificationMethodType>;
  certificateandlicenseonlineverificationmethod?: Maybe<CertificateAndLicenseOnlineVerificationMethodType>;
  certifier: Scalars["String"]["output"];
  expiredAt?: Maybe<Scalars["Date"]["output"]>;
  id: Scalars["ID"]["output"];
  issuedAt: Scalars["Date"]["output"];
  status: AuthAccountCertificateAndLicenseStatusChoices;
  title: Scalars["String"]["output"];
};

export type JobSeekerCooperationType = {
  __typename?: "JobSeekerCooperationType";
  createdAt: Scalars["DateTime"]["output"];
  employerSatisfactionRate?: Maybe<Scalars["Float"]["output"]>;
  endAt?: Maybe<Scalars["DateTime"]["output"]>;
  id: Scalars["ID"]["output"];
  jobPosition?: Maybe<JobSeekerJobPositionType>;
  performanceReport?: Maybe<OrganizationEmployeePerformanceReportNodeConnection>;
  platformMessages?: Maybe<OrganizationPlatformMessageNodeConnection>;
  startAt?: Maybe<Scalars["DateTime"]["output"]>;
  status: AuthAccountOrganizationEmployeeCooperationStatusChoices;
};

export type JobSeekerCooperationTypePerformanceReportArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>;
  before?: InputMaybe<Scalars["String"]["input"]>;
  date_Gte?: InputMaybe<Scalars["Date"]["input"]>;
  date_Lte?: InputMaybe<Scalars["Date"]["input"]>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
};

export type JobSeekerCooperationTypePlatformMessagesArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>;
  before?: InputMaybe<Scalars["String"]["input"]>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
};

export type JobSeekerEducationType = {
  __typename?: "JobSeekerEducationType";
  city: CityNode;
  communicationmethod?: Maybe<CommunicationMethodType>;
  degree: AuthAccountEducationDegreeChoices;
  end?: Maybe<Scalars["Date"]["output"]>;
  field: FieldType;
  id: Scalars["ID"]["output"];
  ieemethod?: Maybe<IeeMethodType>;
  start: Scalars["Date"]["output"];
  status: AuthAccountEducationStatusChoices;
  university: UniversityNode;
};

export type JobSeekerEmployeeType = {
  __typename?: "JobSeekerEmployeeType";
  cooperations?: Maybe<JobSeekerCooperationType>;
  id: Scalars["ID"]["output"];
  organization?: Maybe<JobSeekerOrganizationType>;
};

export type JobSeekerEvaluationType = {
  __typename?: "JobSeekerEvaluationType";
  score: Score;
  userFeedback: Scalars["String"]["output"];
};

export type JobSeekerGeneratedCvType = {
  __typename?: "JobSeekerGeneratedCVType";
  aboutMe?: Maybe<Scalars["String"]["output"]>;
  file: Scalars["String"]["output"];
  modified: Scalars["DateTime"]["output"];
};

export type JobSeekerJobPositionAssignmentNode = {
  __typename?: "JobSeekerJobPositionAssignmentNode";
  createdAt: Scalars["DateTime"]["output"];
  id: Scalars["ID"]["output"];
  interviews?: Maybe<Array<Maybe<JobPositionInterviewType>>>;
  jobPosition?: Maybe<JobSeekerJobPositionType>;
  status: AuthAccountJobPositionAssignmentStatusChoices;
  statusHistories?: Maybe<Array<Maybe<JobPositionAssignmentStatusHistoryType>>>;
};

export type JobSeekerJobPositionAssignmentNodeConnection = {
  __typename?: "JobSeekerJobPositionAssignmentNodeConnection";
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<JobSeekerJobPositionAssignmentNodeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars["Int"]["output"]>;
};

/** A Relay edge containing a `JobSeekerJobPositionAssignmentNode` and its cursor. */
export type JobSeekerJobPositionAssignmentNodeEdge = {
  __typename?: "JobSeekerJobPositionAssignmentNodeEdge";
  /** A cursor for use in pagination */
  cursor: Scalars["String"]["output"];
  /** The item at the end of the edge */
  node?: Maybe<JobSeekerJobPositionAssignmentNode>;
};

export type JobSeekerJobPositionAssignmentStatusUpdateInput = {
  status: AuthAccountJobPositionAssignmentStatusChoices;
};

export type JobSeekerJobPositionAssignmentStatusUpdateMutation = {
  __typename?: "JobSeekerJobPositionAssignmentStatusUpdateMutation";
  jobPositionAssignment?: Maybe<JobSeekerJobPositionAssignmentNode>;
};

export type JobSeekerJobPositionType = {
  __typename?: "JobSeekerJobPositionType";
  ageRange?: Maybe<Array<Scalars["Int"]["output"]>>;
  benefits?: Maybe<Array<JobBenefitType>>;
  cities: CityNodeConnection;
  contractType?: Maybe<AuthAccountOrganizationJobPositionContractTypeChoices>;
  daysOff?: Maybe<Array<Maybe<AuthAccountOrganizationJobPositionDaysOffChoices>>>;
  degrees?: Maybe<Array<Maybe<AuthAccountOrganizationJobPositionDegreesChoices>>>;
  description?: Maybe<Scalars["String"]["output"]>;
  employerQuestions?: Maybe<Array<Scalars["String"]["output"]>>;
  fields?: Maybe<Array<FieldType>>;
  hiringInCanada?: Maybe<Scalars["Boolean"]["output"]>;
  id: Scalars["ID"]["output"];
  interviewSlots: Array<JobPositionInterviewSlotType>;
  jobRestrictions?: Maybe<Scalars["String"]["output"]>;
  languages?: Maybe<Array<Maybe<AuthAccountOrganizationJobPositionLanguagesChoices>>>;
  locationType?: Maybe<AuthAccountOrganizationJobPositionLocationTypeChoices>;
  nativeLanguages?: Maybe<Array<Maybe<AuthAccountOrganizationJobPositionNativeLanguagesChoices>>>;
  organization?: Maybe<OrganizationType>;
  otherBenefits?: Maybe<Array<Scalars["String"]["output"]>>;
  paymentTerm?: Maybe<AuthAccountOrganizationJobPositionPaymentTermChoices>;
  performanceExpectation?: Maybe<Scalars["String"]["output"]>;
  report?: Maybe<OrganizationJobPositionReportType>;
  requiredDocuments?: Maybe<Array<Scalars["String"]["output"]>>;
  salaryRange?: Maybe<Array<Scalars["Int"]["output"]>>;
  skills?: Maybe<Array<SkillType>>;
  startAt?: Maybe<Scalars["Date"]["output"]>;
  status: AuthAccountOrganizationJobPositionStatusChoices;
  title?: Maybe<Scalars["String"]["output"]>;
  vaccancy?: Maybe<Scalars["Int"]["output"]>;
  validityDate?: Maybe<Scalars["Date"]["output"]>;
  validityDays?: Maybe<Scalars["Int"]["output"]>;
  workExperienceYearsRange?: Maybe<Array<Scalars["Int"]["output"]>>;
  workingEndAt?: Maybe<Scalars["Time"]["output"]>;
  workingStartAt?: Maybe<Scalars["Time"]["output"]>;
};

export type JobSeekerJobPositionTypeCitiesArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>;
  before?: InputMaybe<Scalars["String"]["input"]>;
  country_Code2?: InputMaybe<Scalars["String"]["input"]>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  id?: InputMaybe<Scalars["ID"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  name_Icontains?: InputMaybe<Scalars["String"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  region?: InputMaybe<Scalars["ID"]["input"]>;
};

export type JobSeekerLanguageCertificateType = {
  __typename?: "JobSeekerLanguageCertificateType";
  allowSelfVerification: Scalars["Boolean"]["output"];
  expiredAt?: Maybe<Scalars["Date"]["output"]>;
  id: Scalars["ID"]["output"];
  issuedAt: Scalars["Date"]["output"];
  language: AuthAccountLanguageCertificateLanguageChoices;
  offlinemethod?: Maybe<LanguageCertificateOfflineVerificationMethodType>;
  onlinemethod?: Maybe<LanguageCertificateOnlineVerificationMethodType>;
  status: AuthAccountLanguageCertificateStatusChoices;
  test?: Maybe<LanguageProficiencyTestNode>;
  values?: Maybe<Array<LanguageCertificateValueNode>>;
};

export type JobSeekerOrganizationType = {
  __typename?: "JobSeekerOrganizationType";
  about?: Maybe<Scalars["String"]["output"]>;
  businessType?: Maybe<AuthAccountOrganizationBusinessTypeChoices>;
  city?: Maybe<CityNode>;
  contacts?: Maybe<Array<Maybe<ContactType>>>;
  establishedAt?: Maybe<Scalars["Date"]["output"]>;
  id: Scalars["ID"]["output"];
  industry?: Maybe<IndustryNode>;
  logo?: Maybe<OrganizationLogoFileType>;
  name: Scalars["String"]["output"];
  shortName?: Maybe<Scalars["String"]["output"]>;
  size?: Maybe<AuthAccountOrganizationSizeChoices>;
};

export type JobSeekerPrimitiveType = {
  __typename?: "JobSeekerPrimitiveType";
  firstName: Scalars["String"]["output"];
  lastName: Scalars["String"]["output"];
  profile?: Maybe<JobSeekerProfilePrimitiveType>;
  workexperiences?: Maybe<Array<Maybe<JobSeekerWorkExperienceType>>>;
};

export type JobSeekerProfilePrimitiveType = {
  __typename?: "JobSeekerProfilePrimitiveType";
  avatar?: Maybe<AvatarFileType>;
  score: Scalars["Int"]["output"];
};

export type JobSeekerProfileType = {
  __typename?: "JobSeekerProfileType";
  avatar?: Maybe<AvatarFileType>;
  /** Must be at least 18 years ago and at most 65 years ago */
  birthDate?: Maybe<Scalars["Date"]["output"]>;
  city?: Maybe<CityNode>;
  contacts?: Maybe<Array<Maybe<ContactType>>>;
  fullBodyImage?: Maybe<FullBodyImageFileType>;
  gender?: Maybe<AuthAccountProfileGenderChoices>;
  score: Scalars["Int"]["output"];
};

export type JobSeekerType = {
  __typename?: "JobSeekerType";
  assessments?: Maybe<Array<Maybe<OrganizationAssessmentType>>>;
  certificateandlicenses?: Maybe<Array<JobSeekerCertificateAndLicenseType>>;
  cv?: Maybe<JobSeekerGeneratedCvType>;
  educations?: Maybe<Array<JobSeekerEducationType>>;
  email: Scalars["String"]["output"];
  firstName: Scalars["String"]["output"];
  id: Scalars["ID"]["output"];
  languagecertificates?: Maybe<Array<JobSeekerLanguageCertificateType>>;
  lastName: Scalars["String"]["output"];
  profile?: Maybe<JobSeekerProfileType>;
  resume?: Maybe<ResumeType>;
  workexperiences?: Maybe<Array<JobSeekerWorkExperienceType>>;
};

export type JobSeekerUnionType = JobSeekerPrimitiveType | JobSeekerType;

export type JobSeekerWorkExperienceType = {
  __typename?: "JobSeekerWorkExperienceType";
  city: CityNode;
  employerlettermethod?: Maybe<EmployerLetterMethodType>;
  end?: Maybe<Scalars["Date"]["output"]>;
  grade: AuthAccountWorkExperienceGradeChoices;
  id: Scalars["ID"]["output"];
  jobTitle: Scalars["String"]["output"];
  organization: Scalars["String"]["output"];
  paystubsmethod?: Maybe<PaystubsMethodType>;
  start: Scalars["Date"]["output"];
  status: AuthAccountWorkExperienceStatusChoices;
};

export type JobSuggestionResultItemNode = {
  __typename?: "JobSuggestionResultItemNode";
  confidenceLevel: Scalars["Int"]["output"];
  considerations?: Maybe<Array<Scalars["String"]["output"]>>;
  experienceMatch: Scalars["Int"]["output"];
  id: Scalars["ID"]["output"];
  isAssigned?: Maybe<Scalars["Boolean"]["output"]>;
  jobPositionAssignment?: Maybe<JobPositionAssignmentNode>;
  matchExplanation?: Maybe<Scalars["String"]["output"]>;
  matchScore?: Maybe<Scalars["Int"]["output"]>;
  overQualificationReasons: Array<Scalars["String"]["output"]>;
  recommendation: Scalars["Int"]["output"];
  seniorityMatch: Scalars["Int"]["output"];
  skillMatch: Scalars["Int"]["output"];
  strengths?: Maybe<Array<Scalars["String"]["output"]>>;
  user?: Maybe<UserNode>;
};

export type JobSuggestionResultItemNodeConnection = {
  __typename?: "JobSuggestionResultItemNodeConnection";
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<JobSuggestionResultItemNodeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

/** A Relay edge containing a `JobSuggestionResultItemNode` and its cursor. */
export type JobSuggestionResultItemNodeEdge = {
  __typename?: "JobSuggestionResultItemNodeEdge";
  /** A cursor for use in pagination */
  cursor: Scalars["String"]["output"];
  /** The item at the end of the edge */
  node?: Maybe<JobSuggestionResultItemNode>;
};

export type JobSuggestionResultNode = {
  __typename?: "JobSuggestionResultNode";
  id: Scalars["ID"]["output"];
  items?: Maybe<JobSuggestionResultItemNodeConnection>;
  jobPosition?: Maybe<OrganizationJobPositionNode>;
};

export type JobSuggestionResultNodeItemsArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>;
  before?: InputMaybe<Scalars["String"]["input"]>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
};

export type JobSuggestionResultNodeConnection = {
  __typename?: "JobSuggestionResultNodeConnection";
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<JobSuggestionResultNodeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars["Int"]["output"]>;
};

/** A Relay edge containing a `JobSuggestionResultNode` and its cursor. */
export type JobSuggestionResultNodeEdge = {
  __typename?: "JobSuggestionResultNodeEdge";
  /** A cursor for use in pagination */
  cursor: Scalars["String"]["output"];
  /** The item at the end of the edge */
  node?: Maybe<JobSuggestionResultNode>;
};

export type LanguageCertificateAiType = {
  __typename?: "LanguageCertificateAIType";
  expiredAt?: Maybe<Scalars["Date"]["output"]>;
  issuedAt?: Maybe<Scalars["Date"]["output"]>;
  language?: Maybe<AuthAccountLanguageCertificateLanguageChoices>;
  test?: Maybe<LanguageCertificateTestAiType>;
  values?: Maybe<Array<Maybe<LanguageCertificateValueAiType>>>;
};

export type LanguageCertificateAnalyseAndExtractDataMutation = {
  __typename?: "LanguageCertificateAnalyseAndExtractDataMutation";
  data?: Maybe<LanguageCertificateAiType>;
  isValid?: Maybe<Scalars["Boolean"]["output"]>;
  verificationMethodData?: Maybe<Scalars["String"]["output"]>;
};

export type LanguageCertificateCreateMutation = {
  __typename?: "LanguageCertificateCreateMutation";
  languageCertificate?: Maybe<LanguageCertificateNode>;
};

export type LanguageCertificateFileType = {
  __typename?: "LanguageCertificateFileType";
  file: Scalars["String"]["output"];
};

export type LanguageCertificateMutation = {
  __typename?: "LanguageCertificateMutation";
  analyseAndExtractData?: Maybe<LanguageCertificateAnalyseAndExtractDataMutation>;
  create?: Maybe<LanguageCertificateCreateMutation>;
  update?: Maybe<LanguageCertificateUpdateMutation>;
};

export type LanguageCertificateMutationAnalyseAndExtractDataArgs = {
  fileId: Scalars["NotEmptyID"]["input"];
};

export type LanguageCertificateMutationCreateArgs = {
  input: CreateLanguageCertificateAndSetVerificationMethodInput;
};

export type LanguageCertificateMutationUpdateArgs = {
  id: Scalars["ID"]["input"];
  input: PatchLanguageCertificateInput;
};

export type LanguageCertificateNode = {
  __typename?: "LanguageCertificateNode";
  allowSelfVerification: Scalars["Boolean"]["output"];
  expiredAt?: Maybe<Scalars["Date"]["output"]>;
  id: Scalars["ID"]["output"];
  issuedAt: Scalars["Date"]["output"];
  language: AuthAccountLanguageCertificateLanguageChoices;
  offlinemethod?: Maybe<LanguageCertificateOfflineVerificationMethodType>;
  onlinemethod?: Maybe<LanguageCertificateOnlineVerificationMethodType>;
  status: AuthAccountLanguageCertificateStatusChoices;
  test?: Maybe<LanguageProficiencyTestNode>;
  values?: Maybe<Array<Maybe<LanguageCertificateValueNode>>>;
};

export type LanguageCertificateOfflineVerificationMethodType = {
  __typename?: "LanguageCertificateOfflineVerificationMethodType";
  certificateFile: LanguageCertificateFileType;
  id: Scalars["ID"]["output"];
};

export type LanguageCertificateOnlineVerificationMethodType = {
  __typename?: "LanguageCertificateOnlineVerificationMethodType";
  certificateLink: Scalars["String"]["output"];
  id: Scalars["ID"]["output"];
};

export type LanguageCertificateQuery = {
  __typename?: "LanguageCertificateQuery";
  get?: Maybe<LanguageCertificateNode>;
};

export type LanguageCertificateQueryGetArgs = {
  id: Scalars["NotEmptyID"]["input"];
};

export type LanguageCertificateTestAiType = {
  __typename?: "LanguageCertificateTestAIType";
  id?: Maybe<Scalars["ID"]["output"]>;
  title?: Maybe<Scalars["String"]["output"]>;
};

export type LanguageCertificateUpdateMutation = {
  __typename?: "LanguageCertificateUpdateMutation";
  languageCertificate?: Maybe<LanguageCertificateNode>;
};

export type LanguageCertificateValueAiType = {
  __typename?: "LanguageCertificateValueAIType";
  skill?: Maybe<LanguageCertificateValueSkillAiType>;
  value?: Maybe<Scalars["String"]["output"]>;
};

export type LanguageCertificateValueNode = {
  __typename?: "LanguageCertificateValueNode";
  id: Scalars["ID"]["output"];
  skill?: Maybe<LanguageProficiencySkillNode>;
  value: Scalars["String"]["output"];
};

export type LanguageCertificateValueSkillAiType = {
  __typename?: "LanguageCertificateValueSkillAIType";
  id?: Maybe<Scalars["ID"]["output"]>;
  skillName?: Maybe<Scalars["String"]["output"]>;
  slug?: Maybe<Scalars["String"]["output"]>;
};

export type LanguageProficiencySkillNode = {
  __typename?: "LanguageProficiencySkillNode";
  id: Scalars["ID"]["output"];
  skillName: Scalars["String"]["output"];
  slug: Scalars["String"]["output"];
  /** A list of kwargs dictionaries */
  validatorKwargs: Scalars["JSONString"]["output"];
};

export type LanguageProficiencySkillNodeConnection = {
  __typename?: "LanguageProficiencySkillNodeConnection";
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<LanguageProficiencySkillNodeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

/** A Relay edge containing a `LanguageProficiencySkillNode` and its cursor. */
export type LanguageProficiencySkillNodeEdge = {
  __typename?: "LanguageProficiencySkillNodeEdge";
  /** A cursor for use in pagination */
  cursor: Scalars["String"]["output"];
  /** The item at the end of the edge */
  node?: Maybe<LanguageProficiencySkillNode>;
};

export type LanguageProficiencyTestNode = {
  __typename?: "LanguageProficiencyTestNode";
  id: Scalars["ID"]["output"];
  languages?: Maybe<Array<Maybe<CommonLanguageProficiencyTestLanguagesChoices>>>;
  skills?: Maybe<LanguageProficiencySkillNodeConnection>;
  title: Scalars["String"]["output"];
};

export type LanguageProficiencyTestNodeSkillsArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>;
  before?: InputMaybe<Scalars["String"]["input"]>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  id?: InputMaybe<Scalars["ID"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
};

export type LanguageProficiencyTestNodeConnection = {
  __typename?: "LanguageProficiencyTestNodeConnection";
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<LanguageProficiencyTestNodeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

/** A Relay edge containing a `LanguageProficiencyTestNode` and its cursor. */
export type LanguageProficiencyTestNodeEdge = {
  __typename?: "LanguageProficiencyTestNodeEdge";
  /** A cursor for use in pagination */
  cursor: Scalars["String"]["output"];
  /** The item at the end of the edge */
  node?: Maybe<LanguageProficiencyTestNode>;
};

export type LinkedInAuth = {
  __typename?: "LinkedInAuth";
  payload?: Maybe<Scalars["GenericScalar"]["output"]>;
  refreshExpiresIn?: Maybe<Scalars["Int"]["output"]>;
  refreshToken?: Maybe<Scalars["String"]["output"]>;
  token?: Maybe<Scalars["String"]["output"]>;
};

export type Mutation = {
  __typename?: "Mutation";
  academy: AcademyMutation;
  account: AccountMutation;
  assessment: AssessmentMutation;
  common: CommonMutation;
  cv: CvMutation;
  notification: NotificationMutation;
};

export type NotificationActionDetailType = NotificationRelatedObjectType | NotificationSimpleLinkType;

export type NotificationActionType = {
  __typename?: "NotificationActionType";
  detail?: Maybe<NotificationActionDetailType>;
  text: Scalars["String"]["output"];
};

export type NotificationMutation = {
  __typename?: "NotificationMutation";
  inAppNotification?: Maybe<InAppNotificationMutation>;
  pushNotification?: Maybe<PushNotificationMutation>;
};

/** An enumeration. */
export enum NotificationRelatedObjectSlugEnum {
  JOB_POSITION = "JOB_POSITION",
  JOB_POSITION_ASSIGNMENT = "JOB_POSITION_ASSIGNMENT",
  ORGANIZATION_EMPLOYEE_COOPERATION = "ORGANIZATION_EMPLOYEE_COOPERATION",
}

export type NotificationRelatedObjectType = {
  __typename?: "NotificationRelatedObjectType";
  relatedObjectId: Scalars["Int"]["output"];
  relatedObjectSlug?: Maybe<NotificationRelatedObjectSlugEnum>;
};

export type NotificationSimpleLinkType = {
  __typename?: "NotificationSimpleLinkType";
  id: Scalars["ID"]["output"];
  link: Scalars["String"]["output"];
};

export type ObtainJsonWebToken = {
  __typename?: "ObtainJSONWebToken";
  payload?: Maybe<Scalars["GenericScalar"]["output"]>;
  refreshExpiresIn?: Maybe<Scalars["Int"]["output"]>;
  refreshToken?: Maybe<Scalars["String"]["output"]>;
  success?: Maybe<Scalars["Boolean"]["output"]>;
  token?: Maybe<Scalars["String"]["output"]>;
  unarchiving?: Maybe<Scalars["Boolean"]["output"]>;
  user?: Maybe<UserNode>;
};

export type OnboardingJobSuggestionOutputType = {
  __typename?: "OnboardingJobSuggestionOutputType";
  jobSuggestions?: Maybe<Array<Maybe<OnboardingJobSuggestionType>>>;
  text?: Maybe<Scalars["String"]["output"]>;
};

export type OnboardingJobSuggestionType = {
  __typename?: "OnboardingJobSuggestionType";
  companyName?: Maybe<Scalars["String"]["output"]>;
  country?: Maybe<Scalars["String"]["output"]>;
  salaryRange?: Maybe<Array<Maybe<Scalars["Int"]["output"]>>>;
  shortDescription?: Maybe<Scalars["String"]["output"]>;
  title?: Maybe<Scalars["String"]["output"]>;
};

export type OrganizationAssessmentResultType = {
  __typename?: "OrganizationAssessmentResultType";
  evaluation?: Maybe<OrganizationEvaluationType>;
  question: AssessmentResultQuestionType;
};

export type OrganizationAssessmentType = {
  __typename?: "OrganizationAssessmentType";
  description: Scalars["String"]["output"];
  id: Scalars["String"]["output"];
  remainingQuestions: Scalars["Int"]["output"];
  results?: Maybe<Array<Maybe<OrganizationAssessmentResultType>>>;
  skill?: Maybe<AssessmentSkillType>;
  status: Status;
  title: Scalars["String"]["output"];
  totalEstimatedTime: Scalars["Int"]["output"];
  totalQuestions: Scalars["Int"]["output"];
};

export type OrganizationCertificateFileType = {
  __typename?: "OrganizationCertificateFileType";
  file: Scalars["String"]["output"];
};

export type OrganizationEmployeeCooperationStatusCountsType = {
  __typename?: "OrganizationEmployeeCooperationStatusCountsType";
  active?: Maybe<Scalars["Int"]["output"]>;
  awaiting?: Maybe<Scalars["Int"]["output"]>;
  finished?: Maybe<Scalars["Int"]["output"]>;
  fired?: Maybe<Scalars["Int"]["output"]>;
  resigned?: Maybe<Scalars["Int"]["output"]>;
  suspended?: Maybe<Scalars["Int"]["output"]>;
};

export type OrganizationEmployeeCooperationStatusUpdateInput = {
  status: AuthAccountOrganizationEmployeeCooperationStatusChoices;
};

export type OrganizationEmployeeCooperationStatusUpdateMutation = {
  __typename?: "OrganizationEmployeeCooperationStatusUpdateMutation";
  organizationEmployeeCooperation?: Maybe<OrganizationEmployeeCooperationType>;
};

export type OrganizationEmployeeCooperationType = {
  __typename?: "OrganizationEmployeeCooperationType";
  createdAt: Scalars["DateTime"]["output"];
  employerSatisfactionRate?: Maybe<Scalars["Float"]["output"]>;
  endAt?: Maybe<Scalars["DateTime"]["output"]>;
  id: Scalars["ID"]["output"];
  jobPosition?: Maybe<OrganizationJobPositionNode>;
  performanceReport?: Maybe<OrganizationEmployeePerformanceReportNodeConnection>;
  platformMessages?: Maybe<OrganizationPlatformMessageNodeConnection>;
  startAt?: Maybe<Scalars["DateTime"]["output"]>;
  status: AuthAccountOrganizationEmployeeCooperationStatusChoices;
};

export type OrganizationEmployeeCooperationTypePerformanceReportArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>;
  before?: InputMaybe<Scalars["String"]["input"]>;
  date_Gte?: InputMaybe<Scalars["Date"]["input"]>;
  date_Lte?: InputMaybe<Scalars["Date"]["input"]>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
};

export type OrganizationEmployeeCooperationTypePlatformMessagesArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>;
  before?: InputMaybe<Scalars["String"]["input"]>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
};

export type OrganizationEmployeeNode = {
  __typename?: "OrganizationEmployeeNode";
  cooperations?: Maybe<Array<Maybe<OrganizationEmployeeCooperationType>>>;
  employee?: Maybe<EmployeeType>;
  id: Scalars["ID"]["output"];
};

export type OrganizationEmployeeNodeConnection = {
  __typename?: "OrganizationEmployeeNodeConnection";
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<OrganizationEmployeeNodeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars["Int"]["output"]>;
};

/** A Relay edge containing a `OrganizationEmployeeNode` and its cursor. */
export type OrganizationEmployeeNodeEdge = {
  __typename?: "OrganizationEmployeeNodeEdge";
  /** A cursor for use in pagination */
  cursor: Scalars["String"]["output"];
  /** The item at the end of the edge */
  node?: Maybe<OrganizationEmployeeNode>;
};

export type OrganizationEmployeePerformanceReportNode = {
  __typename?: "OrganizationEmployeePerformanceReportNode";
  date?: Maybe<Scalars["Date"]["output"]>;
  id: Scalars["ID"]["output"];
  reportSummary?: Maybe<Scalars["String"]["output"]>;
  reportText: Scalars["String"]["output"];
  status: AuthAccountOrganizationEmployeePerformanceReportStatusChoices;
  statusHistories: Array<OrganizationEmployeePerformanceReportStatusHistoryType>;
  title?: Maybe<Scalars["String"]["output"]>;
};

export type OrganizationEmployeePerformanceReportNodeConnection = {
  __typename?: "OrganizationEmployeePerformanceReportNodeConnection";
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<OrganizationEmployeePerformanceReportNodeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars["Int"]["output"]>;
};

/** A Relay edge containing a `OrganizationEmployeePerformanceReportNode` and its cursor. */
export type OrganizationEmployeePerformanceReportNodeEdge = {
  __typename?: "OrganizationEmployeePerformanceReportNodeEdge";
  /** A cursor for use in pagination */
  cursor: Scalars["String"]["output"];
  /** The item at the end of the edge */
  node?: Maybe<OrganizationEmployeePerformanceReportNode>;
};

export type OrganizationEmployeePerformanceReportStatusHistoryType = {
  __typename?: "OrganizationEmployeePerformanceReportStatusHistoryType";
  createdAt: Scalars["DateTime"]["output"];
  status: AuthAccountOrganizationEmployeePerformanceReportStatusHistoryStatusChoices;
};

export type OrganizationEmployeeQuery = {
  __typename?: "OrganizationEmployeeQuery";
  get?: Maybe<OrganizationEmployeeNode>;
  list?: Maybe<OrganizationEmployeeNodeConnection>;
};

export type OrganizationEmployeeQueryGetArgs = {
  id: Scalars["NotEmptyID"]["input"];
};

export type OrganizationEmployeeQueryListArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>;
  before?: InputMaybe<Scalars["String"]["input"]>;
  cooperationStartAt?: InputMaybe<Scalars["Date"]["input"]>;
  cooperationStartAtGte?: InputMaybe<Scalars["Date"]["input"]>;
  cooperationStartAtLte?: InputMaybe<Scalars["Date"]["input"]>;
  cooperations_Status?: InputMaybe<AuthAccountOrganizationEmployeeCooperationStatusChoices>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  fullName?: InputMaybe<Scalars["String"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  organization?: InputMaybe<Scalars["ID"]["input"]>;
  user_JobPositionAssignments_JobPosition?: InputMaybe<Scalars["ID"]["input"]>;
};

export type OrganizationEvaluationType = {
  __typename?: "OrganizationEvaluationType";
  negativePoints: Array<Maybe<Scalars["String"]["output"]>>;
  positivePoints: Array<Maybe<Scalars["String"]["output"]>>;
  score: Score;
  scoreReasoning: Scalars["String"]["output"];
  scoreValue?: Maybe<Scalars["Decimal"]["output"]>;
  userFeedback: Scalars["String"]["output"];
};

export type OrganizationExtractJobPosition = {
  __typename?: "OrganizationExtractJobPosition";
  jobPosition?: Maybe<OrganizationJobPositionNode>;
  taskScheduled?: Maybe<Scalars["Boolean"]["output"]>;
};

export type OrganizationInvitationType = {
  __typename?: "OrganizationInvitationType";
  createdAt: Scalars["DateTime"]["output"];
  createdBy: UserNode;
  email: Scalars["String"]["output"];
  id: Scalars["ID"]["output"];
  organization?: Maybe<OrganizationType>;
  role: RoleType;
};

export type OrganizationInviteMutation = {
  __typename?: "OrganizationInviteMutation";
  organizationInvitation?: Maybe<OrganizationInvitationType>;
};

export type OrganizationJobPositionCreateMutation = {
  __typename?: "OrganizationJobPositionCreateMutation";
  organizationJobPosition?: Maybe<OrganizationJobPositionNode>;
};

export type OrganizationJobPositionInterviewSlotSetMutation = {
  __typename?: "OrganizationJobPositionInterviewSlotSetMutation";
  overlappingInterviews?: Maybe<Array<Maybe<JobPositionInterviewType>>>;
};

export type OrganizationJobPositionNode = {
  __typename?: "OrganizationJobPositionNode";
  ageRange?: Maybe<Array<Scalars["Int"]["output"]>>;
  assignments?: Maybe<JobPositionAssignmentNodeConnection>;
  benefits?: Maybe<Array<JobBenefitType>>;
  cities: CityNodeConnection;
  contractType?: Maybe<AuthAccountOrganizationJobPositionContractTypeChoices>;
  daysOff?: Maybe<Array<Maybe<AuthAccountOrganizationJobPositionDaysOffChoices>>>;
  degrees?: Maybe<Array<Maybe<AuthAccountOrganizationJobPositionDegreesChoices>>>;
  description?: Maybe<Scalars["String"]["output"]>;
  employerQuestions?: Maybe<Array<Scalars["String"]["output"]>>;
  fields?: Maybe<Array<FieldType>>;
  hiringInCanada?: Maybe<Scalars["Boolean"]["output"]>;
  id: Scalars["ID"]["output"];
  interviewSlots: Array<JobPositionInterviewSlotType>;
  isEditable?: Maybe<Scalars["Boolean"]["output"]>;
  jobRestrictions?: Maybe<Scalars["String"]["output"]>;
  languages?: Maybe<Array<Maybe<AuthAccountOrganizationJobPositionLanguagesChoices>>>;
  locationType?: Maybe<AuthAccountOrganizationJobPositionLocationTypeChoices>;
  nativeLanguages?: Maybe<Array<Maybe<AuthAccountOrganizationJobPositionNativeLanguagesChoices>>>;
  organization?: Maybe<OrganizationType>;
  otherBenefits?: Maybe<Array<Scalars["String"]["output"]>>;
  paymentTerm?: Maybe<AuthAccountOrganizationJobPositionPaymentTermChoices>;
  performanceExpectation?: Maybe<Scalars["String"]["output"]>;
  report?: Maybe<OrganizationJobPositionReportType>;
  requiredDocuments?: Maybe<Array<Scalars["String"]["output"]>>;
  salaryRange?: Maybe<Array<Scalars["Int"]["output"]>>;
  skills?: Maybe<Array<SkillType>>;
  startAt?: Maybe<Scalars["Date"]["output"]>;
  status: AuthAccountOrganizationJobPositionStatusChoices;
  title?: Maybe<Scalars["String"]["output"]>;
  vaccancy?: Maybe<Scalars["Int"]["output"]>;
  validityDate?: Maybe<Scalars["Date"]["output"]>;
  validityDays?: Maybe<Scalars["Int"]["output"]>;
  workExperienceYearsRange?: Maybe<Array<Scalars["Int"]["output"]>>;
  workingEndAt?: Maybe<Scalars["Time"]["output"]>;
  workingStartAt?: Maybe<Scalars["Time"]["output"]>;
};

export type OrganizationJobPositionNodeAssignmentsArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>;
  before?: InputMaybe<Scalars["String"]["input"]>;
  createdAt_Gte?: InputMaybe<Scalars["DateTime"]["input"]>;
  createdAt_Lte?: InputMaybe<Scalars["DateTime"]["input"]>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  id?: InputMaybe<Scalars["ID"]["input"]>;
  jobPosition_Status_In?: InputMaybe<Array<InputMaybe<AuthAccountOrganizationJobPositionStatusChoices>>>;
  jobSeekerFullName?: InputMaybe<Scalars["String"]["input"]>;
  jobSeeker_Id_In?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  jobSeeker_Profile_Score_Gte?: InputMaybe<Scalars["Int"]["input"]>;
  jobSeeker_Profile_Score_Lte?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<AuthAccountJobPositionAssignmentOrderByChoices>;
  status_In?: InputMaybe<Array<InputMaybe<AuthAccountJobPositionAssignmentStatusChoices>>>;
};

export type OrganizationJobPositionNodeCitiesArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>;
  before?: InputMaybe<Scalars["String"]["input"]>;
  country_Code2?: InputMaybe<Scalars["String"]["input"]>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  id?: InputMaybe<Scalars["ID"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  name_Icontains?: InputMaybe<Scalars["String"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  region?: InputMaybe<Scalars["ID"]["input"]>;
};

export type OrganizationJobPositionNodeConnection = {
  __typename?: "OrganizationJobPositionNodeConnection";
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<OrganizationJobPositionNodeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars["Int"]["output"]>;
};

/** A Relay edge containing a `OrganizationJobPositionNode` and its cursor. */
export type OrganizationJobPositionNodeEdge = {
  __typename?: "OrganizationJobPositionNodeEdge";
  /** A cursor for use in pagination */
  cursor: Scalars["String"]["output"];
  /** The item at the end of the edge */
  node?: Maybe<OrganizationJobPositionNode>;
};

export type OrganizationJobPositionQuery = {
  __typename?: "OrganizationJobPositionQuery";
  get?: Maybe<OrganizationJobPositionNode>;
  list?: Maybe<OrganizationJobPositionNodeConnection>;
};

export type OrganizationJobPositionQueryGetArgs = {
  id: Scalars["NotEmptyID"]["input"];
};

export type OrganizationJobPositionQueryListArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>;
  assignments_Status?: InputMaybe<AuthAccountJobPositionAssignmentStatusChoices>;
  before?: InputMaybe<Scalars["String"]["input"]>;
  cities_DisplayName?: InputMaybe<Scalars["String"]["input"]>;
  cities_DisplayName_Icontains?: InputMaybe<Scalars["String"]["input"]>;
  cities_Id?: InputMaybe<Scalars["ID"]["input"]>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  organization?: InputMaybe<Scalars["ID"]["input"]>;
  startAt_Gte?: InputMaybe<Scalars["Date"]["input"]>;
  startAt_Lte?: InputMaybe<Scalars["Date"]["input"]>;
  status?: InputMaybe<AuthAccountOrganizationJobPositionStatusChoices>;
  title_Icontains?: InputMaybe<Scalars["String"]["input"]>;
};

export type OrganizationJobPositionReportType = {
  __typename?: "OrganizationJobPositionReportType";
  assignmentStatusCounts?: Maybe<Array<Maybe<JobPositionAssignmentStatusCountType>>>;
};

export type OrganizationJobPositionStatusUpdateInput = {
  status: AuthAccountOrganizationJobPositionStatusChoices;
};

export type OrganizationJobPositionStatusUpdateMutation = {
  __typename?: "OrganizationJobPositionStatusUpdateMutation";
  organizationJobPosition?: Maybe<OrganizationJobPositionNode>;
};

export type OrganizationJobPositionUpdateMutation = {
  __typename?: "OrganizationJobPositionUpdateMutation";
  organizationJobPosition?: Maybe<OrganizationJobPositionNode>;
};

export type OrganizationLogoFileType = {
  __typename?: "OrganizationLogoFileType";
  file: Scalars["String"]["output"];
};

export type OrganizationMembershipType = {
  __typename?: "OrganizationMembershipType";
  accessedRoles?: Maybe<Array<Maybe<RoleType>>>;
  organization?: Maybe<OrganizationType>;
  role: RoleType;
  user?: Maybe<OrganizationMembershipUserType>;
};

export type OrganizationMembershipUserType = {
  __typename?: "OrganizationMembershipUserType";
  email: Scalars["String"]["output"];
  firstName: Scalars["String"]["output"];
  id: Scalars["ID"]["output"];
  lastName: Scalars["String"]["output"];
};

export type OrganizationMutation = {
  __typename?: "OrganizationMutation";
  createJobPosition?: Maybe<OrganizationJobPositionCreateMutation>;
  createJobPositionFromFile?: Maybe<OrganizationExtractJobPosition>;
  invite?: Maybe<OrganizationInviteMutation>;
  register?: Maybe<RegisterOrganization>;
  setContacts?: Maybe<SetOrganizationContactsMutation>;
  setJobPositionInterviewSlot?: Maybe<OrganizationJobPositionInterviewSlotSetMutation>;
  setVerificationMethod?: Maybe<OrganizationSetVerificationMethodMutation>;
  update?: Maybe<OrganizationUpdateMutation>;
  updateCalendarEventStatus?: Maybe<CalendarEventStatusUpdateMutation>;
  updateEmployeeCooperationStatus?: Maybe<OrganizationEmployeeCooperationStatusUpdateMutation>;
  updateJobPosition?: Maybe<OrganizationJobPositionUpdateMutation>;
  updateJobPositionAssignmentStatus?: Maybe<JobPositionAssignmentStatusUpdateMutation>;
  updateJobPositionStatus?: Maybe<OrganizationJobPositionStatusUpdateMutation>;
  updatePlatformMessageReadAt?: Maybe<OrganizationPlatformMessageReadAtUpdateMutation>;
  verify?: Maybe<OrganizationVerify>;
};

export type OrganizationMutationCreateJobPositionArgs = {
  input: CreateOrganizationJobPositionInput;
};

export type OrganizationMutationCreateJobPositionFromFileArgs = {
  file: Scalars["Upload"]["input"];
  organizationId: Scalars["ID"]["input"];
};

export type OrganizationMutationInviteArgs = {
  input: CreateOrganizationInvitationInput;
};

export type OrganizationMutationRegisterArgs = {
  email: Scalars["String"]["input"];
  emailCallbackUrl: Scalars["String"]["input"];
  gRecaptchaToken: Scalars["String"]["input"];
  name: Scalars["String"]["input"];
  website: Scalars["String"]["input"];
};

export type OrganizationMutationSetContactsArgs = {
  input: Array<InputMaybe<SetOrganizationContactableInput>>;
};

export type OrganizationMutationSetJobPositionInterviewSlotArgs = {
  jobPositionId: Scalars["ID"]["input"];
  slots: Array<InputMaybe<Scalars["DateTimeRangeScalar"]["input"]>>;
};

export type OrganizationMutationSetVerificationMethodArgs = {
  id: Scalars["NotEmptyID"]["input"];
  input: OrganizationVerificationMethodInput;
};

export type OrganizationMutationUpdateArgs = {
  id: Scalars["ID"]["input"];
  input: PatchOrganizationInput;
};

export type OrganizationMutationUpdateCalendarEventStatusArgs = {
  id: Scalars["ID"]["input"];
  status?: InputMaybe<FlexCalendarCalendarEventStatusChoices>;
};

export type OrganizationMutationUpdateEmployeeCooperationStatusArgs = {
  id: Scalars["ID"]["input"];
  input: OrganizationEmployeeCooperationStatusUpdateInput;
};

export type OrganizationMutationUpdateJobPositionArgs = {
  id: Scalars["ID"]["input"];
  input: PatchOrganizationJobPositionInput;
};

export type OrganizationMutationUpdateJobPositionAssignmentStatusArgs = {
  id: Scalars["ID"]["input"];
  input: JobPositionAssignmentStatusUpdateInput;
};

export type OrganizationMutationUpdateJobPositionStatusArgs = {
  id: Scalars["ID"]["input"];
  input: OrganizationJobPositionStatusUpdateInput;
};

export type OrganizationMutationUpdatePlatformMessageReadAtArgs = {
  id: Scalars["ID"]["input"];
  input: OrganizationPlatformMessageReadAtUpdateInput;
};

export type OrganizationMutationVerifyArgs = {
  organization: Scalars["NotEmptyID"]["input"];
  otp?: InputMaybe<Scalars["String"]["input"]>;
};

export type OrganizationPlatformMessageAttachmentType = {
  __typename?: "OrganizationPlatformMessageAttachmentType";
  attachmentType?: Maybe<AttachmentType>;
  course?: Maybe<CourseNode>;
  courseResult?: Maybe<CourseResultType>;
  file?: Maybe<BaseFileModelType>;
  id: Scalars["ID"]["output"];
  text: Scalars["String"]["output"];
};

export type OrganizationPlatformMessageNode = {
  __typename?: "OrganizationPlatformMessageNode";
  assigneeType: AuthAccountOrganizationPlatformMessageAssigneeTypeChoices;
  attachments: Array<OrganizationPlatformMessageAttachmentType>;
  created: Scalars["DateTime"]["output"];
  id: Scalars["ID"]["output"];
  readAt?: Maybe<Scalars["DateTime"]["output"]>;
  source: AuthAccountOrganizationPlatformMessageSourceChoices;
  text: Scalars["String"]["output"];
  title: Scalars["String"]["output"];
};

export type OrganizationPlatformMessageNodeConnection = {
  __typename?: "OrganizationPlatformMessageNodeConnection";
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<OrganizationPlatformMessageNodeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

/** A Relay edge containing a `OrganizationPlatformMessageNode` and its cursor. */
export type OrganizationPlatformMessageNodeEdge = {
  __typename?: "OrganizationPlatformMessageNodeEdge";
  /** A cursor for use in pagination */
  cursor: Scalars["String"]["output"];
  /** The item at the end of the edge */
  node?: Maybe<OrganizationPlatformMessageNode>;
};

export type OrganizationPlatformMessageReadAtUpdateInput = {
  readAt?: InputMaybe<Scalars["DateTime"]["input"]>;
};

export type OrganizationPlatformMessageReadAtUpdateMutation = {
  __typename?: "OrganizationPlatformMessageReadAtUpdateMutation";
  organizationPlatformMessage?: Maybe<OrganizationPlatformMessageNode>;
};

export type OrganizationQuery = {
  __typename?: "OrganizationQuery";
  employee?: Maybe<OrganizationEmployeeQuery>;
  invitation?: Maybe<OrganizationInvitationType>;
  jobPosition?: Maybe<OrganizationJobPositionQuery>;
  jobPositionAssignment?: Maybe<JobPositionAssignmentNode>;
  jobPositionAssignmentStatistics?: Maybe<JobPositionAssignmentStatisticsType>;
  jobPositionInterview?: Maybe<JobPositionInterviewDetailType>;
};

export type OrganizationQueryInvitationArgs = {
  token: Scalars["NotEmptyID"]["input"];
};

export type OrganizationQueryJobPositionAssignmentArgs = {
  id: Scalars["NotEmptyID"]["input"];
};

export type OrganizationQueryJobPositionAssignmentStatisticsArgs = {
  organizationId: Scalars["NotEmptyID"]["input"];
};

export type OrganizationQueryJobPositionInterviewArgs = {
  id: Scalars["NotEmptyID"]["input"];
};

export type OrganizationSetVerificationMethodMutation = {
  __typename?: "OrganizationSetVerificationMethodMutation";
  output?: Maybe<Scalars["GenericScalar"]["output"]>;
  success?: Maybe<Scalars["Boolean"]["output"]>;
};

export type OrganizationType = {
  __typename?: "OrganizationType";
  about?: Maybe<Scalars["String"]["output"]>;
  businessType?: Maybe<AuthAccountOrganizationBusinessTypeChoices>;
  city?: Maybe<CityNode>;
  contacts?: Maybe<Array<Maybe<ContactType>>>;
  email?: Maybe<Scalars["String"]["output"]>;
  establishedAt?: Maybe<Scalars["Date"]["output"]>;
  hasFinancialData?: Maybe<Scalars["Boolean"]["output"]>;
  id: Scalars["ID"]["output"];
  industry?: Maybe<IndustryNode>;
  invitations: Array<OrganizationInvitationType>;
  logo?: Maybe<OrganizationLogoFileType>;
  memberships: Array<OrganizationMembershipType>;
  name: Scalars["String"]["output"];
  nationalNumber?: Maybe<Scalars["String"]["output"]>;
  shortName?: Maybe<Scalars["String"]["output"]>;
  size?: Maybe<AuthAccountOrganizationSizeChoices>;
  status: AuthAccountOrganizationStatusChoices;
  type?: Maybe<AuthAccountOrganizationTypeChoices>;
};

export type OrganizationUpdateMutation = {
  __typename?: "OrganizationUpdateMutation";
  organization?: Maybe<OrganizationType>;
};

export type OrganizationVerificationMethodInput = {
  communicateorganizationmethod?: InputMaybe<CommunicateOrganizationMethodInput>;
  dnstxtrecordmethod?: InputMaybe<Scalars["String"]["input"]>;
  uploadcompanycertificatemethod?: InputMaybe<UploadCompanyCertificateMethodInput>;
  uploadfiletowebsitemethod?: InputMaybe<Scalars["String"]["input"]>;
};

export type OrganizationVerify = {
  __typename?: "OrganizationVerify";
  success?: Maybe<Scalars["Boolean"]["output"]>;
};

/** The Relay compliant `PageInfo` type, containing data necessary to paginate this connection. */
export type PageInfo = {
  __typename?: "PageInfo";
  /** When paginating forwards, the cursor to continue. */
  endCursor?: Maybe<Scalars["String"]["output"]>;
  /** When paginating forwards, are there more items? */
  hasNextPage: Scalars["Boolean"]["output"];
  /** When paginating backwards, are there more items? */
  hasPreviousPage: Scalars["Boolean"]["output"];
  /** When paginating backwards, the cursor to continue. */
  startCursor?: Maybe<Scalars["String"]["output"]>;
};

export type PasswordReset = {
  __typename?: "PasswordReset";
  success?: Maybe<Scalars["Boolean"]["output"]>;
};

export type PatchCertificateAndLicenseInput = {
  allowSelfVerification?: InputMaybe<Scalars["Boolean"]["input"]>;
  certifier?: InputMaybe<Scalars["String"]["input"]>;
  expiredAt?: InputMaybe<Scalars["Date"]["input"]>;
  issuedAt?: InputMaybe<Scalars["Date"]["input"]>;
  title?: InputMaybe<Scalars["String"]["input"]>;
};

export type PatchEducationInput = {
  allowSelfVerification?: InputMaybe<Scalars["Boolean"]["input"]>;
  city?: InputMaybe<Scalars["ID"]["input"]>;
  degree?: InputMaybe<AuthAccountEducationDegreeChoices>;
  end?: InputMaybe<Scalars["Date"]["input"]>;
  field?: InputMaybe<Scalars["ID"]["input"]>;
  start?: InputMaybe<Scalars["Date"]["input"]>;
  university?: InputMaybe<Scalars["ID"]["input"]>;
};

export type PatchLanguageCertificateInput = {
  allowSelfVerification?: InputMaybe<Scalars["Boolean"]["input"]>;
  expiredAt?: InputMaybe<Scalars["Date"]["input"]>;
  issuedAt?: InputMaybe<Scalars["Date"]["input"]>;
  language?: InputMaybe<AuthAccountLanguageCertificateLanguageChoices>;
  test?: InputMaybe<Scalars["ID"]["input"]>;
  values?: InputMaybe<Array<InputMaybe<PatchLanguageCertificateInputExactLanguageCertificateValues>>>;
};

export type PatchLanguageCertificateInputExactLanguageCertificateValues = {
  skill: Scalars["ID"]["input"];
  value: Scalars["String"]["input"];
};

export type PatchOrganizationInput = {
  about?: InputMaybe<Scalars["String"]["input"]>;
  businessType?: InputMaybe<AuthAccountOrganizationBusinessTypeChoices>;
  city?: InputMaybe<Scalars["ID"]["input"]>;
  establishedAt?: InputMaybe<Scalars["Date"]["input"]>;
  industry?: InputMaybe<Scalars["ID"]["input"]>;
  logo?: InputMaybe<Scalars["ID"]["input"]>;
  name?: InputMaybe<Scalars["String"]["input"]>;
  nationalNumber?: InputMaybe<Scalars["String"]["input"]>;
  shortName?: InputMaybe<Scalars["String"]["input"]>;
  size?: InputMaybe<AuthAccountOrganizationSizeChoices>;
  type?: InputMaybe<AuthAccountOrganizationTypeChoices>;
};

export type PatchOrganizationJobPositionInput = {
  ageRange?: InputMaybe<Array<InputMaybe<Scalars["Int"]["input"]>>>;
  benefits?: InputMaybe<Array<InputMaybe<Scalars["ID"]["input"]>>>;
  cities?: InputMaybe<Array<InputMaybe<Scalars["ID"]["input"]>>>;
  contractType?: InputMaybe<AuthAccountOrganizationJobPositionContractTypeChoices>;
  daysOff?: InputMaybe<Array<InputMaybe<AuthAccountOrganizationJobPositionDaysOffChoices>>>;
  degrees?: InputMaybe<Array<InputMaybe<AuthAccountOrganizationJobPositionDegreesChoices>>>;
  description?: InputMaybe<Scalars["String"]["input"]>;
  employerQuestions?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  fields?: InputMaybe<Array<InputMaybe<Scalars["ID"]["input"]>>>;
  hiringInCanada?: InputMaybe<Scalars["Boolean"]["input"]>;
  jobRestrictions?: InputMaybe<Scalars["String"]["input"]>;
  languages?: InputMaybe<Array<InputMaybe<AuthAccountOrganizationJobPositionLanguagesChoices>>>;
  locationType?: InputMaybe<AuthAccountOrganizationJobPositionLocationTypeChoices>;
  nativeLanguages?: InputMaybe<Array<InputMaybe<AuthAccountOrganizationJobPositionNativeLanguagesChoices>>>;
  otherBenefits?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  paymentTerm?: InputMaybe<AuthAccountOrganizationJobPositionPaymentTermChoices>;
  performanceExpectation?: InputMaybe<Scalars["String"]["input"]>;
  requiredDocuments?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  salaryRange?: InputMaybe<Array<InputMaybe<Scalars["Int"]["input"]>>>;
  skills?: InputMaybe<Array<InputMaybe<Scalars["ID"]["input"]>>>;
  startAt?: InputMaybe<Scalars["Date"]["input"]>;
  title?: InputMaybe<Scalars["String"]["input"]>;
  vaccancy?: InputMaybe<Scalars["Int"]["input"]>;
  validityDays?: InputMaybe<Scalars["Int"]["input"]>;
  workExperienceYearsRange?: InputMaybe<Array<InputMaybe<Scalars["Int"]["input"]>>>;
  workingEndAt?: InputMaybe<Scalars["Time"]["input"]>;
  workingStartAt?: InputMaybe<Scalars["Time"]["input"]>;
};

export type PatchWorkExperienceInput = {
  allowSelfVerification?: InputMaybe<Scalars["Boolean"]["input"]>;
  city?: InputMaybe<Scalars["ID"]["input"]>;
  end?: InputMaybe<Scalars["Date"]["input"]>;
  grade?: InputMaybe<AuthAccountWorkExperienceGradeChoices>;
  jobTitle?: InputMaybe<Scalars["String"]["input"]>;
  organization?: InputMaybe<Scalars["String"]["input"]>;
  skills?: InputMaybe<Scalars["String"]["input"]>;
  start?: InputMaybe<Scalars["Date"]["input"]>;
};

export type PaystubsFileType = {
  __typename?: "PaystubsFileType";
  file: Scalars["String"]["output"];
};

export type PaystubsMethodAiType = {
  __typename?: "PaystubsMethodAIType";
  id?: Maybe<Scalars["ID"]["output"]>;
};

export type PaystubsMethodType = {
  __typename?: "PaystubsMethodType";
  id: Scalars["ID"]["output"];
  paystubs: PaystubsFileType;
};

export type PerformOnboardingInput = {
  country: Scalars["ID"]["input"];
  industry: Scalars["ID"]["input"];
  interestedJobs: Array<InputMaybe<Scalars["ID"]["input"]>>;
};

export type PerformOnboardingJobSuggestionMutation = {
  __typename?: "PerformOnboardingJobSuggestionMutation";
  output?: Maybe<OnboardingJobSuggestionOutputType>;
};

export type PerformOnboardingMutation = {
  __typename?: "PerformOnboardingMutation";
  success?: Maybe<Scalars["Boolean"]["output"]>;
};

export type ProfileMutation = {
  __typename?: "ProfileMutation";
  performOnboarding?: Maybe<PerformOnboardingMutation>;
  setContacts?: Maybe<SetUserContactsMutation>;
  setSkills?: Maybe<UserSetSkillsMutation>;
  update?: Maybe<UserUpdateMutation>;
  uploadResume?: Maybe<ResumeCreateMutation>;
};

export type ProfileMutationPerformOnboardingArgs = {
  input: PerformOnboardingInput;
};

export type ProfileMutationSetContactsArgs = {
  input: Array<InputMaybe<BatchCreateContactInput>>;
};

export type ProfileMutationSetSkillsArgs = {
  input: UserSkillInput;
  shouldAnalyze?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type ProfileMutationUpdateArgs = {
  input: UpdateProfileInput;
};

export type ProfileMutationUploadResumeArgs = {
  input: UpdateResumeInput;
};

export type ProfileType = {
  __typename?: "ProfileType";
  acceptTermsAndConditions: Scalars["Boolean"]["output"];
  allowNotifications: Scalars["Boolean"]["output"];
  avatar?: Maybe<AvatarFileType>;
  /** Must be at least 18 years ago and at most 65 years ago */
  birthDate?: Maybe<Scalars["Date"]["output"]>;
  city?: Maybe<CityNode>;
  completionPercentage?: Maybe<Scalars["Float"]["output"]>;
  contacts?: Maybe<Array<Maybe<ContactType>>>;
  country?: Maybe<CountryNode>;
  credits: Scalars["Int"]["output"];
  employmentStatus?: Maybe<AuthAccountProfileEmploymentStatusChoices>;
  eyeColor?: Maybe<AuthAccountProfileEyeColorChoices>;
  fluentLanguages?: Maybe<Array<Maybe<AuthAccountProfileFluentLanguagesChoices>>>;
  fullBodyImage?: Maybe<FullBodyImageFileType>;
  gender?: Maybe<AuthAccountProfileGenderChoices>;
  hairColor?: Maybe<Scalars["String"]["output"]>;
  height?: Maybe<Scalars["Int"]["output"]>;
  industry?: Maybe<IndustryNode>;
  interestedJobs: JobNodeConnection;
  isOnboardingCompleted?: Maybe<Scalars["Boolean"]["output"]>;
  jobCities: CityNodeConnection;
  jobLocationType?: Maybe<Array<Maybe<AuthAccountProfileJobLocationTypeExcludeChoices>>>;
  jobType?: Maybe<Array<Maybe<AuthAccountProfileJobTypeExcludeChoices>>>;
  nativeLanguage?: Maybe<AuthAccountProfileNativeLanguageChoices>;
  rawSkills?: Maybe<Array<Scalars["String"]["output"]>>;
  score: Scalars["Int"]["output"];
  scores: Scalars["JSONString"]["output"];
  skills: Array<SkillType>;
  skinColor?: Maybe<AuthAccountProfileSkinColorChoices>;
  weight?: Maybe<Scalars["Int"]["output"]>;
};

export type ProfileTypeInterestedJobsArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>;
  before?: InputMaybe<Scalars["String"]["input"]>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  id?: InputMaybe<Scalars["ID"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  title_Icontains?: InputMaybe<Scalars["String"]["input"]>;
};

export type ProfileTypeJobCitiesArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>;
  before?: InputMaybe<Scalars["String"]["input"]>;
  country_Code2?: InputMaybe<Scalars["String"]["input"]>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  id?: InputMaybe<Scalars["ID"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  name_Icontains?: InputMaybe<Scalars["String"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  region?: InputMaybe<Scalars["ID"]["input"]>;
};

export type PushNotificationMutation = {
  __typename?: "PushNotificationMutation";
  registerToken?: Maybe<RegisterPushNotificationTokenMutation>;
};

export type PushNotificationMutationRegisterTokenArgs = {
  token: Scalars["String"]["input"];
};

export type Query = {
  __typename?: "Query";
  academy?: Maybe<AcademyQuery>;
  admin?: Maybe<AdminQuery>;
  calendar?: Maybe<CalendarQuery>;
  certificateAndLicense?: Maybe<CertificateAndLicenseQuery>;
  common?: Maybe<CommonQuery>;
  cv?: Maybe<CvQuery>;
  education?: Maybe<EducationQuery>;
  languageCertificate?: Maybe<LanguageCertificateQuery>;
  me?: Maybe<UserNode>;
  organization?: Maybe<OrganizationQuery>;
  supportTicketCategory?: Maybe<SupportTicketCategoryNodeConnection>;
  workExperience?: Maybe<WorkExperienceQuery>;
};

export type QuerySupportTicketCategoryArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>;
  before?: InputMaybe<Scalars["String"]["input"]>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  types_Contains?: InputMaybe<Array<InputMaybe<AuthAccountSupportTicketCategoryTypesChoices>>>;
};

/** An enumeration. */
export enum QuestionStatus {
  ANSWERED = "ANSWERED",
  NOT_STARTED = "NOT_STARTED",
  SEEN = "SEEN",
  SKIP = "SKIP",
  TIMEOUT = "TIMEOUT",
}

export type ReferenceCheckEmployerAiType = {
  __typename?: "ReferenceCheckEmployerAIType";
  email?: Maybe<Scalars["String"]["output"]>;
  name?: Maybe<Scalars["String"]["output"]>;
  phoneNumber?: Maybe<Scalars["String"]["output"]>;
  position?: Maybe<Scalars["String"]["output"]>;
};

export type ReferenceCheckEmployerType = {
  __typename?: "ReferenceCheckEmployerType";
  email: Scalars["String"]["output"];
  id: Scalars["ID"]["output"];
  name: Scalars["String"]["output"];
  phoneNumber: Scalars["String"]["output"];
  position: Scalars["String"]["output"];
};

export type ReferralType = {
  __typename?: "ReferralType";
  code: Scalars["String"]["output"];
};

export type RefreshToken = {
  __typename?: "RefreshToken";
  payload?: Maybe<Scalars["GenericScalar"]["output"]>;
  success?: Maybe<Scalars["Boolean"]["output"]>;
  token?: Maybe<Scalars["String"]["output"]>;
};

export type RegionNode = {
  __typename?: "RegionNode";
  alternateNames?: Maybe<Scalars["String"]["output"]>;
  country: CountryNode;
  displayName: Scalars["String"]["output"];
  geonameCode?: Maybe<Scalars["String"]["output"]>;
  geonameId?: Maybe<Scalars["Int"]["output"]>;
  id: Scalars["ID"]["output"];
  name: Scalars["String"]["output"];
  nameAscii: Scalars["String"]["output"];
  slug: Scalars["String"]["output"];
};

export type RegionNodeConnection = {
  __typename?: "RegionNodeConnection";
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<RegionNodeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

/** A Relay edge containing a `RegionNode` and its cursor. */
export type RegionNodeEdge = {
  __typename?: "RegionNodeEdge";
  /** A cursor for use in pagination */
  cursor: Scalars["String"]["output"];
  /** The item at the end of the edge */
  node?: Maybe<RegionNode>;
};

export type RegisterOrganization = {
  __typename?: "RegisterOrganization";
  success?: Maybe<Scalars["Boolean"]["output"]>;
};

export type RegisterPushNotificationTokenMutation = {
  __typename?: "RegisterPushNotificationTokenMutation";
  success?: Maybe<Scalars["Boolean"]["output"]>;
};

export type ResendActivationEmail = {
  __typename?: "ResendActivationEmail";
  success?: Maybe<Scalars["Boolean"]["output"]>;
};

export enum ResumeAssessmentsReadyEnum {
  ASSESSMENTS_IN_PROGRESS = "ASSESSMENTS_IN_PROGRESS",
  ASSESSMENTS_READY = "ASSESSMENTS_READY",
  NO_RESUME = "NO_RESUME",
}

export type ResumeCreateMutation = {
  __typename?: "ResumeCreateMutation";
  resume?: Maybe<ResumeType>;
};

export type ResumeFileType = {
  __typename?: "ResumeFileType";
  file: Scalars["String"]["output"];
};

export type ResumeType = {
  __typename?: "ResumeType";
  file: ResumeFileType;
};

export type RevokeTokenMutation = {
  __typename?: "RevokeTokenMutation";
  revoked?: Maybe<Scalars["Int"]["output"]>;
  success?: Maybe<Scalars["Boolean"]["output"]>;
};

export type RoleType = {
  __typename?: "RoleType";
  accesses: Array<AccessType>;
  description?: Maybe<Scalars["String"]["output"]>;
  id: Scalars["ID"]["output"];
  title?: Maybe<Scalars["String"]["output"]>;
};

/** An enumeration. */
export enum Score {
  AVERAGE = "AVERAGE",
  EXCEPTIONAL = "EXCEPTIONAL",
  GOOD = "GOOD",
  GREAT = "GREAT",
  ZERO = "ZERO",
}

export type SelectInterviewSlotMutation = {
  __typename?: "SelectInterviewSlotMutation";
  jobPositionAssignment?: Maybe<JobSeekerJobPositionAssignmentNode>;
};

export type SendPasswordResetEmail = {
  __typename?: "SendPasswordResetEmail";
  success?: Maybe<Scalars["Boolean"]["output"]>;
};

export type SetOrganizationContactableInput = {
  organizationId: Scalars["NotEmptyID"]["input"];
  type?: InputMaybe<AuthAccountContactTypeChoices>;
  value: Scalars["String"]["input"];
};

export type SetOrganizationContactsMutation = {
  __typename?: "SetOrganizationContactsMutation";
  contacts?: Maybe<Array<Maybe<ContactType>>>;
};

export type SetUserContactsMutation = {
  __typename?: "SetUserContactsMutation";
  contacts?: Maybe<Array<Maybe<ContactType>>>;
};

export type SkillNode = {
  __typename?: "SkillNode";
  id: Scalars["ID"]["output"];
  title: Scalars["String"]["output"];
};

export type SkillNodeConnection = {
  __typename?: "SkillNodeConnection";
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<SkillNodeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

/** A Relay edge containing a `SkillNode` and its cursor. */
export type SkillNodeEdge = {
  __typename?: "SkillNodeEdge";
  /** A cursor for use in pagination */
  cursor: Scalars["String"]["output"];
  /** The item at the end of the edge */
  node?: Maybe<SkillNode>;
};

export type SkillType = {
  __typename?: "SkillType";
  id: Scalars["ID"]["output"];
  title: Scalars["String"]["output"];
};

/** An enumeration. */
export enum Status {
  COMPLETED = "COMPLETED",
  EVALUATED = "EVALUATED",
  EXPIRED = "EXPIRED",
  GENERATING = "GENERATING",
  IN_PROGRESS = "IN_PROGRESS",
  NOT_READY = "NOT_READY",
  NOT_STARTED = "NOT_STARTED",
}

export type SubRegionNode = {
  __typename?: "SubRegionNode";
  alternateNames?: Maybe<Scalars["String"]["output"]>;
  country: CountryNode;
  displayName: Scalars["String"]["output"];
  geonameCode?: Maybe<Scalars["String"]["output"]>;
  geonameId?: Maybe<Scalars["Int"]["output"]>;
  id: Scalars["ID"]["output"];
  name: Scalars["String"]["output"];
  nameAscii: Scalars["String"]["output"];
  region?: Maybe<RegionNode>;
  slug: Scalars["String"]["output"];
};

export type SupportTicketCategoryNode = {
  __typename?: "SupportTicketCategoryNode";
  id: Scalars["ID"]["output"];
  title: Scalars["String"]["output"];
  types?: Maybe<Array<Maybe<AuthAccountSupportTicketCategoryTypesChoices>>>;
};

export type SupportTicketCategoryNodeConnection = {
  __typename?: "SupportTicketCategoryNodeConnection";
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<SupportTicketCategoryNodeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

/** A Relay edge containing a `SupportTicketCategoryNode` and its cursor. */
export type SupportTicketCategoryNodeEdge = {
  __typename?: "SupportTicketCategoryNodeEdge";
  /** A cursor for use in pagination */
  cursor: Scalars["String"]["output"];
  /** The item at the end of the edge */
  node?: Maybe<SupportTicketCategoryNode>;
};

export type SupportTicketCreateMutation = {
  __typename?: "SupportTicketCreateMutation";
  supportTicket?: Maybe<SupportTicketType>;
};

export type SupportTicketMutation = {
  __typename?: "SupportTicketMutation";
  create?: Maybe<SupportTicketCreateMutation>;
};

export type SupportTicketMutationCreateArgs = {
  input: CreateSupportTicketInput;
};

export type SupportTicketType = {
  __typename?: "SupportTicketType";
  category: SupportTicketCategoryNode;
  contactMethod: AuthAccountSupportTicketContactMethodChoices;
  contactValue: Scalars["String"]["output"];
  created: Scalars["DateTime"]["output"];
  description: Scalars["String"]["output"];
  id: Scalars["ID"]["output"];
  modified: Scalars["DateTime"]["output"];
  priority: AuthAccountSupportTicketPriorityChoices;
  status: AuthAccountSupportTicketStatusChoices;
  ticketId: Scalars["String"]["output"];
  title: Scalars["String"]["output"];
};

export type TriggerJobSuggestionMutation = {
  __typename?: "TriggerJobSuggestionMutation";
  success?: Maybe<Scalars["Boolean"]["output"]>;
};

export type UnassignJobMutation = {
  __typename?: "UnassignJobMutation";
  deletedId?: Maybe<Scalars["ID"]["output"]>;
  deletedInputId?: Maybe<Scalars["ID"]["output"]>;
  deletedRawId?: Maybe<Scalars["ID"]["output"]>;
  found?: Maybe<Scalars["Boolean"]["output"]>;
};

export type UniversityNode = {
  __typename?: "UniversityNode";
  id: Scalars["ID"]["output"];
  name: Scalars["String"]["output"];
  websites?: Maybe<Array<Scalars["String"]["output"]>>;
};

export type UniversityNodeConnection = {
  __typename?: "UniversityNodeConnection";
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<UniversityNodeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

/** A Relay edge containing a `UniversityNode` and its cursor. */
export type UniversityNodeEdge = {
  __typename?: "UniversityNodeEdge";
  /** A cursor for use in pagination */
  cursor: Scalars["String"]["output"];
  /** The item at the end of the edge */
  node?: Maybe<UniversityNode>;
};

export type UpdateCanadaVisaInput = {
  citizenshipDocument?: InputMaybe<Scalars["ID"]["input"]>;
  nationality?: InputMaybe<Scalars["ID"]["input"]>;
  status: AuthAccountCanadaVisaStatusChoices;
};

export type UpdateCourseResultInput = {
  course: Scalars["ID"]["input"];
};

export type UpdateProfileInput = {
  acceptTermsAndConditions?: InputMaybe<Scalars["Boolean"]["input"]>;
  allowNotifications?: InputMaybe<Scalars["Boolean"]["input"]>;
  avatar?: InputMaybe<Scalars["ID"]["input"]>;
  /** Must be at least 18 years ago and at most 65 years ago */
  birthDate?: InputMaybe<Scalars["Date"]["input"]>;
  city?: InputMaybe<Scalars["ID"]["input"]>;
  employmentStatus?: InputMaybe<AuthAccountProfileEmploymentStatusChoices>;
  eyeColor?: InputMaybe<AuthAccountProfileEyeColorChoices>;
  firstName?: InputMaybe<Scalars["String"]["input"]>;
  fluentLanguages?: InputMaybe<Array<InputMaybe<AuthAccountProfileFluentLanguagesChoices>>>;
  fullBodyImage?: InputMaybe<Scalars["ID"]["input"]>;
  gender?: InputMaybe<AuthAccountProfileGenderChoices>;
  hairColor?: InputMaybe<Scalars["String"]["input"]>;
  height?: InputMaybe<Scalars["Int"]["input"]>;
  industry?: InputMaybe<Scalars["ID"]["input"]>;
  interestedJobs?: InputMaybe<Array<InputMaybe<Scalars["ID"]["input"]>>>;
  jobCities?: InputMaybe<Array<InputMaybe<Scalars["ID"]["input"]>>>;
  jobLocationType?: InputMaybe<Array<InputMaybe<AuthAccountProfileJobLocationTypeExcludeChoices>>>;
  jobType?: InputMaybe<Array<InputMaybe<AuthAccountProfileJobTypeExcludeChoices>>>;
  lastName?: InputMaybe<Scalars["String"]["input"]>;
  nativeLanguage?: InputMaybe<AuthAccountProfileNativeLanguageChoices>;
  skills?: InputMaybe<Array<InputMaybe<Scalars["ID"]["input"]>>>;
  skinColor?: InputMaybe<AuthAccountProfileSkinColorChoices>;
  weight?: InputMaybe<Scalars["Int"]["input"]>;
};

export type UpdateResumeInput = {
  file: Scalars["ID"]["input"];
};

export type UploadCompanyCertificateMethodInput = {
  organizationCertificateFileId: Scalars["NotEmptyID"]["input"];
};

export type UploadCompanyCertificateMethodType = {
  __typename?: "UploadCompanyCertificateMethodType";
  id: Scalars["ID"]["output"];
  organizationCertificateFile: OrganizationCertificateFileType;
};

export type UploadFileMutation = {
  __typename?: "UploadFileMutation";
  pk?: Maybe<Scalars["Int"]["output"]>;
};

export type UploadFileToWebsiteMethodType = {
  __typename?: "UploadFileToWebsiteMethodType";
  fileName: Scalars["String"]["output"];
  id: Scalars["ID"]["output"];
};

/** An enumeration. */
export enum UploadType {
  /** Avatar Image */
  AVATAR = "AVATAR",
  /** Certificate File */
  CERTIFICATE = "CERTIFICATE",
  /** Citizenship Document File */
  CITIZENSHIP_DOCUMENT = "CITIZENSHIP_DOCUMENT",
  /** Degree File */
  DEGREE = "DEGREE",
  /** Education Evaluation Document File */
  EDUCATION_EVALUATION = "EDUCATION_EVALUATION",
  /** Employer Letter File */
  EMPLOYER_LETTER = "EMPLOYER_LETTER",
  /** Full Body Image */
  FULL_BODY_IMAGE = "FULL_BODY_IMAGE",
  /** Language Certificate File */
  LANGUAGE_CERTIFICATE = "LANGUAGE_CERTIFICATE",
  /** Organization Certificate File */
  ORGANIZATION_CERTIFICATE = "ORGANIZATION_CERTIFICATE",
  /** Organization Logo File */
  ORGANIZATION_LOGO = "ORGANIZATION_LOGO",
  /** Paystubs File */
  PAYSTUBS = "PAYSTUBS",
  /** Resume File */
  RESUME = "RESUME",
}

export type UserNode = {
  __typename?: "UserNode";
  archived?: Maybe<Scalars["Boolean"]["output"]>;
  assessments?: Maybe<Array<Maybe<AssessmentType>>>;
  calendar?: Maybe<CalendarType>;
  canadaVisa?: Maybe<CanadaVisaNode>;
  certificateandlicenses?: Maybe<Array<CertificateAndLicenseNode>>;
  currentEmployement?: Maybe<JobSeekerEmployeeType>;
  cv?: Maybe<GeneratedCvNode>;
  educations?: Maybe<Array<EducationNode>>;
  email: Scalars["String"]["output"];
  firstName: Scalars["String"]["output"];
  hasResume?: Maybe<Scalars["Boolean"]["output"]>;
  jobPositionAssignments?: Maybe<JobSeekerJobPositionAssignmentNodeConnection>;
  languagecertificates?: Maybe<Array<LanguageCertificateNode>>;
  lastName: Scalars["String"]["output"];
  notifications?: Maybe<Array<Maybe<InAppNotificationNode>>>;
  organizationMemberships: Array<OrganizationMembershipType>;
  pk?: Maybe<Scalars["Int"]["output"]>;
  profile?: Maybe<ProfileType>;
  referral?: Maybe<ReferralType>;
  relatedCalendarEvents?: Maybe<Array<Maybe<CalendarEventType>>>;
  resume?: Maybe<ResumeType>;
  resumeAssessmentsReady?: Maybe<ResumeAssessmentsReadyEnum>;
  secondaryEmail?: Maybe<Scalars["String"]["output"]>;
  supportTickets?: Maybe<Array<SupportTicketType>>;
  tasks: Array<UserTaskType>;
  verified?: Maybe<Scalars["Boolean"]["output"]>;
  workexperiences?: Maybe<Array<WorkExperienceNode>>;
};

export type UserNodeAssessmentsArgs = {
  filters?: InputMaybe<AssessmentFilter>;
};

export type UserNodeJobPositionAssignmentsArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>;
  before?: InputMaybe<Scalars["String"]["input"]>;
  createdAt_Gte?: InputMaybe<Scalars["DateTime"]["input"]>;
  createdAt_Lte?: InputMaybe<Scalars["DateTime"]["input"]>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  id?: InputMaybe<Scalars["ID"]["input"]>;
  jobPosition_Status_In?: InputMaybe<Array<InputMaybe<AuthAccountOrganizationJobPositionStatusChoices>>>;
  jobSeekerFullName?: InputMaybe<Scalars["String"]["input"]>;
  jobSeeker_Id_In?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  jobSeeker_Profile_Score_Gte?: InputMaybe<Scalars["Int"]["input"]>;
  jobSeeker_Profile_Score_Lte?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<AuthAccountJobPositionAssignmentOrderByChoices>;
  status_In?: InputMaybe<Array<InputMaybe<AuthAccountJobPositionAssignmentStatusChoices>>>;
};

export type UserRegister = {
  __typename?: "UserRegister";
  success?: Maybe<Scalars["Boolean"]["output"]>;
};

export type UserSetSkillsMutation = {
  __typename?: "UserSetSkillsMutation";
  user?: Maybe<UserNode>;
};

export type UserSkillInput = {
  skills: Array<InputMaybe<Scalars["String"]["input"]>>;
};

export type UserTaskType = {
  __typename?: "UserTaskType";
  status?: Maybe<AuthAccountUserTaskStatusChoices>;
  taskName: AuthAccountUserTaskTaskNameChoices;
};

export type UserUpdateMutation = {
  __typename?: "UserUpdateMutation";
  profile?: Maybe<ProfileType>;
};

export type VerifyAccount = {
  __typename?: "VerifyAccount";
  success?: Maybe<Scalars["Boolean"]["output"]>;
  /** The token required to set password after registration with password_reset */
  token?: Maybe<Scalars["String"]["output"]>;
};

export type WorkExperienceAiType = {
  __typename?: "WorkExperienceAIType";
  city?: Maybe<CityNode>;
  end?: Maybe<Scalars["Date"]["output"]>;
  grade?: Maybe<AuthAccountWorkExperienceGradeChoices>;
  industry?: Maybe<IndustryNode>;
  jobTitle?: Maybe<Scalars["String"]["output"]>;
  organization?: Maybe<Scalars["String"]["output"]>;
  skills?: Maybe<Scalars["String"]["output"]>;
  start?: Maybe<Scalars["Date"]["output"]>;
};

export type WorkExperienceAnalyseAndExtractDataMutation = {
  __typename?: "WorkExperienceAnalyseAndExtractDataMutation";
  data?: Maybe<WorkExperienceAiType>;
  isValid?: Maybe<Scalars["Boolean"]["output"]>;
  verificationMethodData?: Maybe<WorkExperienceVerificationMethodType>;
};

export type WorkExperienceCreateMutation = {
  __typename?: "WorkExperienceCreateMutation";
  workExperience?: Maybe<WorkExperienceNode>;
};

export type WorkExperienceEmployerLetterMethodInput = {
  employerLetter: Scalars["ID"]["input"];
  employers?: InputMaybe<Array<InputMaybe<WorkExperienceEmployerLetterMethodInputExactEmployerLetterMethodEmployers>>>;
};

export type WorkExperienceEmployerLetterMethodInputExactEmployerLetterMethodEmployers = {
  email: Scalars["String"]["input"];
  name: Scalars["String"]["input"];
  phoneNumber: Scalars["String"]["input"];
  position: Scalars["String"]["input"];
};

export type WorkExperienceMutation = {
  __typename?: "WorkExperienceMutation";
  analyseAndExtractData?: Maybe<WorkExperienceAnalyseAndExtractDataMutation>;
  create?: Maybe<WorkExperienceCreateMutation>;
  update?: Maybe<WorkExperienceUpdateMutation>;
};

export type WorkExperienceMutationAnalyseAndExtractDataArgs = {
  fileId: Scalars["NotEmptyID"]["input"];
  verificationType: WorkExperienceVerificationMethodUploadType;
};

export type WorkExperienceMutationCreateArgs = {
  input: CreateWorkExperienceAndSetVerificationMethodInput;
};

export type WorkExperienceMutationUpdateArgs = {
  id: Scalars["ID"]["input"];
  input: PatchWorkExperienceInput;
};

export type WorkExperienceNode = {
  __typename?: "WorkExperienceNode";
  allowSelfVerification: Scalars["Boolean"]["output"];
  city: CityNode;
  createdAt: Scalars["DateTime"]["output"];
  employerlettermethod?: Maybe<EmployerLetterMethodType>;
  end?: Maybe<Scalars["Date"]["output"]>;
  grade: AuthAccountWorkExperienceGradeChoices;
  id: Scalars["ID"]["output"];
  jobTitle: Scalars["String"]["output"];
  organization: Scalars["String"]["output"];
  paystubsmethod?: Maybe<PaystubsMethodType>;
  skills?: Maybe<Scalars["String"]["output"]>;
  start: Scalars["Date"]["output"];
  status: AuthAccountWorkExperienceStatusChoices;
  updatedAt: Scalars["DateTime"]["output"];
};

export type WorkExperienceQuery = {
  __typename?: "WorkExperienceQuery";
  get?: Maybe<WorkExperienceNode>;
};

export type WorkExperienceQueryGetArgs = {
  id: Scalars["NotEmptyID"]["input"];
};

export type WorkExperienceUpdateMutation = {
  __typename?: "WorkExperienceUpdateMutation";
  workExperience?: Maybe<WorkExperienceNode>;
};

export type WorkExperienceVerificationMethodType = PaystubsMethodAiType | ReferenceCheckEmployerAiType;

/** An enumeration. */
export enum WorkExperienceVerificationMethodUploadType {
  /** Employer Letter File */
  EMPLOYER_LETTER = "EMPLOYER_LETTER",
  /** Paystubs File */
  PAYSTUBS = "PAYSTUBS",
}

export type AcceptJobSuggestionWithIdMutationVariables = Exact<{
  jobSuggestionResultId: Scalars["ID"]["input"];
}>;

export type AcceptJobSuggestionWithIdMutation = {
  __typename?: "Mutation";
  account: {
    __typename?: "AccountMutation";
    admin?: {
      __typename?: "AdminMutation";
      acceptJobSuggestion?: {
        __typename?: "AcceptJobSuggestionMutation";
        jobPositionAssignment?: {
          __typename?: "JobPositionAssignmentNode";
          status: AuthAccountJobPositionAssignmentStatusChoices;
        } | null;
      } | null;
    } | null;
  };
};

export type AssignJobToJobSeekerMutationVariables = Exact<{
  jobPositionId?: InputMaybe<Scalars["ID"]["input"]>;
  userId?: InputMaybe<Scalars["ID"]["input"]>;
}>;

export type AssignJobToJobSeekerMutation = {
  __typename?: "Mutation";
  account: {
    __typename?: "AccountMutation";
    admin?: {
      __typename?: "AdminMutation";
      assignJob?: {
        __typename?: "AssignJobMutation";
        jobPositionAssignment?: { __typename?: "JobPositionAssignmentNode"; id: string } | null;
      } | null;
    } | null;
  };
};

export type HijackingUserMutationVariables = Exact<{
  userId: Scalars["ID"]["input"];
}>;

export type HijackingUserMutation = {
  __typename?: "Mutation";
  account: {
    __typename?: "AccountMutation";
    admin?: {
      __typename?: "AdminMutation";
      hijack?: {
        __typename?: "HijackUserMutation";
        token?: string | null;
        refreshToken?: string | null;
        refreshExpiresIn?: number | null;
        payload?: any | null;
        user?: { __typename?: "UserNode"; email: string } | null;
      } | null;
    } | null;
  };
};

export type TriggerJobSuggestionWithIdMutationVariables = Exact<{
  jobPositionId: Scalars["ID"]["input"];
}>;

export type TriggerJobSuggestionWithIdMutation = {
  __typename?: "Mutation";
  account: {
    __typename?: "AccountMutation";
    admin?: {
      __typename?: "AdminMutation";
      triggerJobSuggestion?: { __typename?: "TriggerJobSuggestionMutation"; success?: boolean | null } | null;
    } | null;
  };
};

export type UnssignJobToJobSeekerMutationVariables = Exact<{
  jobPositionAssignmentId: Scalars["ID"]["input"];
}>;

export type UnssignJobToJobSeekerMutation = {
  __typename?: "Mutation";
  account: {
    __typename?: "AccountMutation";
    admin?: {
      __typename?: "AdminMutation";
      unassignJob?: { __typename?: "UnassignJobMutation"; found?: boolean | null } | null;
    } | null;
  };
};

export type UpdateJobPositionStatusMutationVariables = Exact<{
  status: AuthAccountOrganizationJobPositionStatusChoices;
  id: Scalars["ID"]["input"];
}>;

export type UpdateJobPositionStatusMutation = {
  __typename?: "Mutation";
  account: {
    __typename?: "AccountMutation";
    admin?: {
      __typename?: "AdminMutation";
      updateJobPositionStatus?: {
        __typename?: "AdminJobPositionStatusUpdateMutation";
        organizationJobPosition?: { __typename?: "AdminJobPositionNode"; id: string } | null;
      } | null;
    } | null;
  };
};

export type UpdateOrganizationInformationMutationVariables = Exact<{
  organizationId: Scalars["ID"]["input"];
  logo?: InputMaybe<Scalars["ID"]["input"]>;
  nationalNumber?: InputMaybe<Scalars["String"]["input"]>;
  shortName?: InputMaybe<Scalars["String"]["input"]>;
  city?: InputMaybe<Scalars["ID"]["input"]>;
  name: Scalars["String"]["input"];
  about?: InputMaybe<Scalars["String"]["input"]>;
  industry?: InputMaybe<Scalars["ID"]["input"]>;
  businessType?: InputMaybe<AuthAccountOrganizationBusinessTypeChoices>;
  type?: InputMaybe<AuthAccountOrganizationTypeChoices>;
  size?: InputMaybe<AuthAccountOrganizationSizeChoices>;
  contacts: Array<InputMaybe<AdminSetOrganizationContactableInput>> | InputMaybe<AdminSetOrganizationContactableInput>;
  establishedAt?: InputMaybe<Scalars["Date"]["input"]>;
}>;

export type UpdateOrganizationInformationMutation = {
  __typename?: "Mutation";
  account: {
    __typename?: "AccountMutation";
    admin?: {
      __typename?: "AdminMutation";
      setOrganizationContacts?: {
        __typename?: "AdminSetOrganizationContactsMutation";
        contacts?: Array<{ __typename?: "ContactType"; id: string } | null> | null;
      } | null;
      updateOrganization?: {
        __typename?: "AdminOrganizationUpdateMutation";
        organization?: {
          __typename?: "AdminOrganizationNode";
          id: string;
          about?: string | null;
          businessType?: AuthAccountOrganizationBusinessTypeChoices | null;
          establishedAt?: any | null;
          hasFinancialData?: boolean | null;
          name: string;
          nationalNumber?: string | null;
          shortName?: string | null;
          size?: AuthAccountOrganizationSizeChoices | null;
          status: AuthAccountOrganizationStatusChoices;
          type?: AuthAccountOrganizationTypeChoices | null;
          email?: string | null;
          industry?: { __typename?: "IndustryNode"; id: string } | null;
          logo?: { __typename?: "OrganizationLogoFileType"; file: string } | null;
          contacts?: Array<{
            __typename?: "ContactType";
            id: string;
            type: AuthAccountContactTypeChoices;
            value: string;
          } | null> | null;
          city?: { __typename?: "CityNode"; id: string } | null;
        } | null;
      } | null;
    } | null;
  };
};

export type UpdateOrganizationStatusMutationVariables = Exact<{
  id: Scalars["ID"]["input"];
  status: AuthAccountOrganizationStatusChoices;
}>;

export type UpdateOrganizationStatusMutation = {
  __typename?: "Mutation";
  account: {
    __typename?: "AccountMutation";
    admin?: {
      __typename?: "AdminMutation";
      updateOrganizationStatus?: {
        __typename?: "AdminOrganizationStatusUpdateMutation";
        organization?: { __typename?: "OrganizationType"; id: string } | null;
      } | null;
    } | null;
  };
};

export type AccountRefreshTokenMutationVariables = Exact<{
  refreshToken: Scalars["String"]["input"];
}>;

export type AccountRefreshTokenMutation = {
  __typename?: "Mutation";
  account: {
    __typename?: "AccountMutation";
    refreshToken?: {
      __typename?: "RefreshToken";
      token?: string | null;
      success?: boolean | null;
      payload?: any | null;
    } | null;
  };
};

export type AccountRevokeTokenMutationVariables = Exact<{
  refreshToken: Scalars["String"]["input"];
}>;

export type AccountRevokeTokenMutation = {
  __typename?: "Mutation";
  account: {
    __typename?: "AccountMutation";
    revokeToken?: { __typename?: "RevokeTokenMutation"; success?: boolean | null } | null;
  };
};

export type AccountTokenAuthMutationVariables = Exact<{
  email: Scalars["String"]["input"];
  password: Scalars["String"]["input"];
  deviceId: Scalars["String"]["input"];
  gRecaptchaToken: Scalars["String"]["input"];
}>;

export type AccountTokenAuthMutation = {
  __typename?: "Mutation";
  account: {
    __typename?: "AccountMutation";
    tokenAuth?: {
      __typename?: "ObtainJSONWebToken";
      token?: string | null;
      success?: boolean | null;
      refreshExpiresIn?: number | null;
      payload?: any | null;
      refreshToken?: string | null;
    } | null;
  };
};

export type GetAssignmentsQueryVariables = Exact<{
  id?: InputMaybe<Scalars["ID"]["input"]>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  jobSeekerFullName?: InputMaybe<Scalars["String"]["input"]>;
  jobSeekerProfileScoreGte?: InputMaybe<Scalars["Int"]["input"]>;
  createdAtGte?: InputMaybe<Scalars["DateTime"]["input"]>;
  statusIn?: InputMaybe<
    | Array<InputMaybe<AuthAccountJobPositionAssignmentStatusChoices>>
    | InputMaybe<AuthAccountJobPositionAssignmentStatusChoices>
  >;
}>;

export type GetAssignmentsQuery = {
  __typename?: "Query";
  admin?: {
    __typename?: "AdminQuery";
    jobPositions?: {
      __typename?: "AdminJobPositionNodeConnection";
      edges: Array<{
        __typename?: "AdminJobPositionNodeEdge";
        node?: {
          __typename?: "AdminJobPositionNode";
          assignments?: {
            __typename?: "AdminJobPositionAssignmentNodeConnection";
            totalCount?: number | null;
            edges: Array<{
              __typename?: "AdminJobPositionAssignmentNodeEdge";
              node?: {
                __typename?: "AdminJobPositionAssignmentNode";
                createdAt: any;
                id: string;
                status: AuthAccountJobPositionAssignmentStatusChoices;
                interviews?: Array<{
                  __typename?: "JobPositionInterviewType";
                  id: string;
                  slot?: {
                    __typename?: "JobPositionInterviewSlotType";
                    datetime?: any | null;
                    id: string;
                    isAvailable?: boolean | null;
                  } | null;
                } | null> | null;
                statusHistories?: Array<{
                  __typename?: "JobPositionAssignmentStatusHistoryType";
                  createdAt: any;
                  status: AuthAccountJobPositionAssignmentStatusHistoryStatusChoices;
                } | null> | null;
                jobSeeker?: {
                  __typename: "JobSeekerType";
                  id: string;
                  email: string;
                  firstName: string;
                  lastName: string;
                  profile?: {
                    __typename?: "JobSeekerProfileType";
                    score: number;
                    avatar?: { __typename?: "AvatarFileType"; file: string } | null;
                  } | null;
                  resume?: { __typename?: "ResumeType"; file: { __typename?: "ResumeFileType"; file: string } } | null;
                  workexperiences?: Array<{
                    __typename?: "JobSeekerWorkExperienceType";
                    organization: string;
                    jobTitle: string;
                  }> | null;
                } | null;
              } | null;
            } | null>;
            pageInfo: {
              __typename?: "PageInfo";
              startCursor?: string | null;
              hasPreviousPage: boolean;
              hasNextPage: boolean;
              endCursor?: string | null;
            };
          } | null;
        } | null;
      } | null>;
    } | null;
  } | null;
};

export type GetJobPositionsQueryVariables = Exact<{
  id?: InputMaybe<Scalars["ID"]["input"]>;
  startDate?: InputMaybe<Scalars["Date"]["input"]>;
  endDate?: InputMaybe<Scalars["Date"]["input"]>;
  status?: InputMaybe<AuthAccountOrganizationJobPositionStatusChoices>;
  title?: InputMaybe<Scalars["String"]["input"]>;
  organizationName?: InputMaybe<Scalars["String"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
}>;

export type GetJobPositionsQuery = {
  __typename?: "Query";
  admin?: {
    __typename?: "AdminQuery";
    jobPositions?: {
      __typename?: "AdminJobPositionNodeConnection";
      totalCount?: number | null;
      edges: Array<{
        __typename?: "AdminJobPositionNodeEdge";
        node?: {
          __typename?: "AdminJobPositionNode";
          ageRange?: Array<number> | null;
          contractType?: AuthAccountOrganizationJobPositionContractTypeChoices | null;
          daysOff?: Array<AuthAccountOrganizationJobPositionDaysOffChoices | null> | null;
          degrees?: Array<AuthAccountOrganizationJobPositionDegreesChoices | null> | null;
          description?: string | null;
          employerQuestions?: Array<string> | null;
          id: string;
          jobRestrictions?: string | null;
          languages?: Array<AuthAccountOrganizationJobPositionLanguagesChoices | null> | null;
          locationType?: AuthAccountOrganizationJobPositionLocationTypeChoices | null;
          nativeLanguages?: Array<AuthAccountOrganizationJobPositionNativeLanguagesChoices | null> | null;
          otherBenefits?: Array<string> | null;
          paymentTerm?: AuthAccountOrganizationJobPositionPaymentTermChoices | null;
          performanceExpectation?: string | null;
          requiredDocuments?: Array<string> | null;
          salaryRange?: Array<number> | null;
          startAt?: any | null;
          status: AuthAccountOrganizationJobPositionStatusChoices;
          title?: string | null;
          vaccancy?: number | null;
          validityDate?: any | null;
          workExperienceYearsRange?: Array<number> | null;
          workingEndAt?: any | null;
          workingStartAt?: any | null;
          isEditable?: boolean | null;
          report?: {
            __typename?: "OrganizationJobPositionReportType";
            assignmentStatusCounts?: Array<{
              __typename?: "JobPositionAssignmentStatusCountType";
              count?: number | null;
              status?: string | null;
            } | null> | null;
          } | null;
          benefits?: Array<{ __typename?: "JobBenefitType"; id: string; name: string }> | null;
          cities: {
            __typename?: "CityNodeConnection";
            edges: Array<{
              __typename?: "CityNodeEdge";
              node?: { __typename?: "CityNode"; id: string; name: string } | null;
            } | null>;
          };
          fields?: Array<{ __typename?: "FieldType"; id: string; name: string }> | null;
          skills?: Array<{ __typename?: "SkillType"; id: string; title: string }> | null;
          organization?: {
            __typename?: "OrganizationType";
            name: string;
            shortName?: string | null;
            logo?: { __typename?: "OrganizationLogoFileType"; file: string } | null;
          } | null;
        } | null;
      } | null>;
      pageInfo: {
        __typename?: "PageInfo";
        endCursor?: string | null;
        hasNextPage: boolean;
        hasPreviousPage: boolean;
        startCursor?: string | null;
      };
    } | null;
  } | null;
};

export type GetJobPositionsSearchQueryVariables = Exact<{
  title?: InputMaybe<Scalars["String"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
}>;

export type GetJobPositionsSearchQuery = {
  __typename?: "Query";
  admin?: {
    __typename?: "AdminQuery";
    jobPositions?: {
      __typename?: "AdminJobPositionNodeConnection";
      totalCount?: number | null;
      edges: Array<{
        __typename?: "AdminJobPositionNodeEdge";
        node?: { __typename?: "AdminJobPositionNode"; id: string; title?: string | null } | null;
      } | null>;
      pageInfo: {
        __typename?: "PageInfo";
        endCursor?: string | null;
        hasNextPage: boolean;
        hasPreviousPage: boolean;
        startCursor?: string | null;
      };
    } | null;
  } | null;
};

export type GetOrganizationJobPositionsQueryVariables = Exact<{
  organizationId?: InputMaybe<Scalars["ID"]["input"]>;
  startDate?: InputMaybe<Scalars["Date"]["input"]>;
  endDate?: InputMaybe<Scalars["Date"]["input"]>;
  status?: InputMaybe<AuthAccountOrganizationJobPositionStatusChoices>;
  title?: InputMaybe<Scalars["String"]["input"]>;
}>;

export type GetOrganizationJobPositionsQuery = {
  __typename?: "Query";
  admin?: {
    __typename?: "AdminQuery";
    jobPositions?: {
      __typename?: "AdminJobPositionNodeConnection";
      edges: Array<{
        __typename?: "AdminJobPositionNodeEdge";
        node?: {
          __typename?: "AdminJobPositionNode";
          id: string;
          status: AuthAccountOrganizationJobPositionStatusChoices;
          title?: string | null;
          validityDate?: any | null;
          assignments?: {
            __typename?: "AdminJobPositionAssignmentNodeConnection";
            edges: Array<{
              __typename?: "AdminJobPositionAssignmentNodeEdge";
              node?: {
                __typename?: "AdminJobPositionAssignmentNode";
                status: AuthAccountJobPositionAssignmentStatusChoices;
              } | null;
            } | null>;
          } | null;
          skills?: Array<{ __typename?: "SkillType"; title: string }> | null;
        } | null;
      } | null>;
    } | null;
    organizations?: {
      __typename?: "AdminOrganizationNodeConnection";
      edges: Array<{
        __typename?: "AdminOrganizationNodeEdge";
        node?: {
          __typename?: "AdminOrganizationNode";
          jobPositionsStatusCounts?: {
            __typename?: "JobPositionStatusCountsType";
            drafted?: number | null;
            expired?: number | null;
            published?: number | null;
            rejected?: number | null;
            submitted?: number | null;
            suspended?: number | null;
          } | null;
        } | null;
      } | null>;
    } | null;
  } | null;
};

export type GetCertificateAndLicenseByIdQueryVariables = Exact<{
  id: Scalars["NotEmptyID"]["input"];
}>;

export type GetCertificateAndLicenseByIdQuery = {
  __typename?: "Query";
  admin?: {
    __typename?: "AdminQuery";
    certificateAndLicense?: {
      __typename?: "CertificateAndLicenseNode";
      certifier: string;
      expiredAt?: any | null;
      id: string;
      issuedAt: any;
      status: AuthAccountCertificateAndLicenseStatusChoices;
      title: string;
      allowSelfVerification: boolean;
      certificateandlicenseofflineverificationmethod?: {
        __typename?: "CertificateAndLicenseOfflineVerificationMethodType";
        id: string;
        certificateFile: { __typename?: "CertificateFileType"; file: string };
      } | null;
      certificateandlicenseonlineverificationmethod?: {
        __typename?: "CertificateAndLicenseOnlineVerificationMethodType";
        certificateLink: string;
        id: string;
      } | null;
    } | null;
  } | null;
};

export type GetEducationInfoByIdQueryVariables = Exact<{
  id: Scalars["NotEmptyID"]["input"];
}>;

export type GetEducationInfoByIdQuery = {
  __typename?: "Query";
  admin?: {
    __typename?: "AdminQuery";
    education?: {
      __typename?: "EducationNode";
      allowSelfVerification: boolean;
      createdAt: any;
      degree: AuthAccountEducationDegreeChoices;
      end?: any | null;
      id: string;
      start: any;
      status: AuthAccountEducationStatusChoices;
      updatedAt: any;
      communicationmethod?: {
        __typename?: "CommunicationMethodType";
        department: string;
        email: string;
        id: string;
        person: string;
        website: string;
        degreeFile: { __typename?: "DegreeFileType"; file: string };
      } | null;
      city: {
        __typename?: "CityNode";
        id: string;
        name: string;
        country: { __typename?: "CountryNode"; id: string; name: string };
        region?: { __typename?: "RegionNode"; id: string; name: string } | null;
      };
      field: { __typename?: "FieldType"; id: string; name: string };
      ieemethod?: {
        __typename?: "IEEMethodType";
        id: string;
        educationEvaluationDocument: { __typename?: "EducationEvaluationDocumentFileType"; file: string };
      } | null;
      university: { __typename?: "UniversityNode"; id: string; name: string };
    } | null;
  } | null;
};

export type GetCanadaVisaQueryVariables = Exact<{
  id: Scalars["Decimal"]["input"];
}>;

export type GetCanadaVisaQuery = {
  __typename?: "Query";
  admin?: {
    __typename?: "AdminQuery";
    jobSeekers?: {
      __typename?: "AdminJobSeekerTypeConnection";
      edges: Array<{
        __typename?: "AdminJobSeekerTypeEdge";
        node?: {
          __typename?: "AdminJobSeekerType";
          canadaVisa?: {
            __typename?: "AdminCanadaVisaType";
            id: string;
            status: AuthAccountCanadaVisaStatusChoices;
            citizenshipDocument?: { __typename?: "CitizenshipDocumentFileType"; file: string } | null;
            nationality?: { __typename?: "CountryNode"; name: string; id: string } | null;
          } | null;
        } | null;
      } | null>;
    } | null;
  } | null;
};

export type GetCertificateAndLicensesQueryVariables = Exact<{
  id: Scalars["Decimal"]["input"];
}>;

export type GetCertificateAndLicensesQuery = {
  __typename?: "Query";
  admin?: {
    __typename?: "AdminQuery";
    jobSeekers?: {
      __typename?: "AdminJobSeekerTypeConnection";
      edges: Array<{
        __typename?: "AdminJobSeekerTypeEdge";
        node?: {
          __typename?: "AdminJobSeekerType";
          certificateandlicenses?: Array<{
            __typename?: "JobSeekerCertificateAndLicenseType";
            id: string;
            expiredAt?: any | null;
            certifier: string;
            issuedAt: any;
            title: string;
            status: AuthAccountCertificateAndLicenseStatusChoices;
          }> | null;
        } | null;
      } | null>;
    } | null;
  } | null;
};

export type GetEducationsQueryVariables = Exact<{
  id: Scalars["Decimal"]["input"];
}>;

export type GetEducationsQuery = {
  __typename?: "Query";
  admin?: {
    __typename?: "AdminQuery";
    jobSeekers?: {
      __typename?: "AdminJobSeekerTypeConnection";
      edges: Array<{
        __typename?: "AdminJobSeekerTypeEdge";
        node?: {
          __typename?: "AdminJobSeekerType";
          educations?: Array<{
            __typename?: "JobSeekerEducationType";
            id: string;
            degree: AuthAccountEducationDegreeChoices;
            start: any;
            end?: any | null;
            status: AuthAccountEducationStatusChoices;
            field: { __typename?: "FieldType"; name: string };
            university: { __typename?: "UniversityNode"; name: string };
            city: {
              __typename?: "CityNode";
              name: string;
              region?: {
                __typename?: "RegionNode";
                name: string;
                country: { __typename?: "CountryNode"; name: string };
              } | null;
            };
          }> | null;
        } | null;
      } | null>;
    } | null;
  } | null;
};

export type GetJobSeekerByIdQueryVariables = Exact<{
  id: Scalars["Decimal"]["input"];
}>;

export type GetJobSeekerByIdQuery = {
  __typename?: "Query";
  admin?: {
    __typename?: "AdminQuery";
    jobSeekers?: {
      __typename?: "AdminJobSeekerTypeConnection";
      edges: Array<{
        __typename?: "AdminJobSeekerTypeEdge";
        node?: {
          __typename?: "AdminJobSeekerType";
          id: string;
          firstName: string;
          lastName: string;
          email: string;
          workexperiences?: Array<{
            __typename?: "JobSeekerWorkExperienceType";
            end?: any | null;
            grade: AuthAccountWorkExperienceGradeChoices;
            id: string;
            jobTitle: string;
            organization: string;
            start: any;
            status: AuthAccountWorkExperienceStatusChoices;
            city: {
              __typename?: "CityNode";
              name: string;
              id: string;
              country: { __typename?: "CountryNode"; id: string; name: string };
              region?: { __typename?: "RegionNode"; name: string; id: string } | null;
            };
            employerlettermethod?: {
              __typename?: "EmployerLetterMethodType";
              id: string;
              employerLetter: { __typename?: "EmployerLetterFileType"; file: string };
              employers?: Array<{
                __typename?: "ReferenceCheckEmployerType";
                email: string;
                id: string;
                name: string;
                phoneNumber: string;
                position: string;
              } | null> | null;
            } | null;
            paystubsmethod?: {
              __typename?: "PaystubsMethodType";
              id: string;
              paystubs: { __typename?: "PaystubsFileType"; file: string };
            } | null;
          }> | null;
          certificateandlicenses?: Array<{
            __typename?: "JobSeekerCertificateAndLicenseType";
            certifier: string;
            expiredAt?: any | null;
            id: string;
            issuedAt: any;
            status: AuthAccountCertificateAndLicenseStatusChoices;
            title: string;
            certificateandlicenseofflineverificationmethod?: {
              __typename?: "CertificateAndLicenseOfflineVerificationMethodType";
              id: string;
              certificateFile: { __typename?: "CertificateFileType"; file: string };
            } | null;
            certificateandlicenseonlineverificationmethod?: {
              __typename?: "CertificateAndLicenseOnlineVerificationMethodType";
              certificateLink: string;
              id: string;
            } | null;
          }> | null;
          languagecertificates?: Array<{
            __typename?: "JobSeekerLanguageCertificateType";
            expiredAt?: any | null;
            id: string;
            issuedAt: any;
            language: AuthAccountLanguageCertificateLanguageChoices;
            status: AuthAccountLanguageCertificateStatusChoices;
            test?: {
              __typename?: "LanguageProficiencyTestNode";
              title: string;
              id: string;
              languages?: Array<CommonLanguageProficiencyTestLanguagesChoices | null> | null;
            } | null;
            onlinemethod?: {
              __typename?: "LanguageCertificateOnlineVerificationMethodType";
              certificateLink: string;
              id: string;
            } | null;
            offlinemethod?: {
              __typename?: "LanguageCertificateOfflineVerificationMethodType";
              id: string;
              certificateFile: { __typename?: "LanguageCertificateFileType"; file: string };
            } | null;
          }> | null;
          cv?: { __typename?: "JobSeekerGeneratedCVType"; file: string; modified: any; aboutMe?: string | null } | null;
          educations?: Array<{
            __typename?: "JobSeekerEducationType";
            degree: AuthAccountEducationDegreeChoices;
            end?: any | null;
            start: any;
            status: AuthAccountEducationStatusChoices;
            id: string;
            city: {
              __typename?: "CityNode";
              id: string;
              name: string;
              country: { __typename?: "CountryNode"; name: string; id: string };
              region?: { __typename?: "RegionNode"; name: string; id: string } | null;
            };
            field: { __typename?: "FieldType"; name: string; id: string };
            university: { __typename?: "UniversityNode"; name: string; id: string; websites?: Array<string> | null };
            communicationmethod?: {
              __typename?: "CommunicationMethodType";
              department: string;
              email: string;
              id: string;
              person: string;
              website: string;
              degreeFile: { __typename?: "DegreeFileType"; file: string };
            } | null;
            ieemethod?: {
              __typename?: "IEEMethodType";
              id: string;
              educationEvaluationDocument: { __typename?: "EducationEvaluationDocumentFileType"; file: string };
            } | null;
          }> | null;
          resume?: { __typename?: "ResumeType"; file: { __typename?: "ResumeFileType"; file: string } } | null;
          profile?: {
            __typename?: "ProfileType";
            score: number;
            jobLocationType?: Array<AuthAccountProfileJobLocationTypeExcludeChoices | null> | null;
            jobType?: Array<AuthAccountProfileJobTypeExcludeChoices | null> | null;
            gender?: AuthAccountProfileGenderChoices | null;
            employmentStatus?: AuthAccountProfileEmploymentStatusChoices | null;
            allowNotifications: boolean;
            birthDate?: any | null;
            fluentLanguages?: Array<AuthAccountProfileFluentLanguagesChoices | null> | null;
            nativeLanguage?: AuthAccountProfileNativeLanguageChoices | null;
            rawSkills?: Array<string> | null;
            avatar?: { __typename?: "AvatarFileType"; file: string } | null;
            contacts?: Array<{
              __typename?: "ContactType";
              value: string;
              type: AuthAccountContactTypeChoices;
              id: string;
            } | null> | null;
            fullBodyImage?: { __typename?: "FullBodyImageFileType"; file: string } | null;
            city?: {
              __typename?: "CityNode";
              name: string;
              id: string;
              country: { __typename?: "CountryNode"; name: string; id: string };
              region?: { __typename?: "RegionNode"; id: string; name: string } | null;
            } | null;
            industry?: { __typename?: "IndustryNode"; id: string; title: string } | null;
            skills: Array<{ __typename?: "SkillType"; id: string; title: string }>;
          } | null;
          canadaVisa?: {
            __typename?: "AdminCanadaVisaType";
            id: string;
            citizenshipDocument?: { __typename?: "CitizenshipDocumentFileType"; file: string } | null;
            nationality?: { __typename?: "CountryNode"; id: string; name: string } | null;
          } | null;
        } | null;
      } | null>;
    } | null;
  } | null;
};

export type GetJobSeekersQueryVariables = Exact<{
  visaStatus?: InputMaybe<
    Array<InputMaybe<AuthAccountCanadaVisaStatusChoices>> | InputMaybe<AuthAccountCanadaVisaStatusChoices>
  >;
  educationDegree?: InputMaybe<
    Array<InputMaybe<AuthAccountEducationDegreeChoices>> | InputMaybe<AuthAccountEducationDegreeChoices>
  >;
  email?: InputMaybe<Scalars["String"]["input"]>;
  fullName?: InputMaybe<Scalars["String"]["input"]>;
  id?: InputMaybe<Scalars["Decimal"]["input"]>;
  birthDateGte?: InputMaybe<Scalars["Date"]["input"]>;
  birthDateLte?: InputMaybe<Scalars["Date"]["input"]>;
  countryId?: InputMaybe<Array<InputMaybe<Scalars["ID"]["input"]>> | InputMaybe<Scalars["ID"]["input"]>>;
  cityId?: InputMaybe<Array<InputMaybe<Scalars["ID"]["input"]>> | InputMaybe<Scalars["ID"]["input"]>>;
  phoneNumber?: InputMaybe<Scalars["String"]["input"]>;
  employmentStatus?: InputMaybe<
    Array<InputMaybe<AuthAccountProfileEmploymentStatusChoices>> | InputMaybe<AuthAccountProfileEmploymentStatusChoices>
  >;
  gender?: InputMaybe<Array<InputMaybe<AuthAccountProfileGenderChoices>> | InputMaybe<AuthAccountProfileGenderChoices>>;
  industryId?: InputMaybe<Array<InputMaybe<Scalars["ID"]["input"]>> | InputMaybe<Scalars["ID"]["input"]>>;
  interestedJobsId?: InputMaybe<Array<InputMaybe<Scalars["ID"]["input"]>> | InputMaybe<Scalars["ID"]["input"]>>;
  nativeLanguage?: InputMaybe<
    Array<InputMaybe<AuthAccountProfileNativeLanguageChoices>> | InputMaybe<AuthAccountProfileNativeLanguageChoices>
  >;
  skillsId?: InputMaybe<Array<InputMaybe<Scalars["ID"]["input"]>> | InputMaybe<Scalars["ID"]["input"]>>;
  workexperiencesGrade?: InputMaybe<
    Array<InputMaybe<AuthAccountWorkExperienceGradeChoices>> | InputMaybe<AuthAccountWorkExperienceGradeChoices>
  >;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  jobType?: InputMaybe<Array<InputMaybe<AuthAccountUserJobTypeChoices>> | InputMaybe<AuthAccountUserJobTypeChoices>>;
  jobCitiesId?: InputMaybe<Array<InputMaybe<Scalars["ID"]["input"]>> | InputMaybe<Scalars["ID"]["input"]>>;
  fluentLanguages?: InputMaybe<
    Array<InputMaybe<AuthAccountUserFluentLanguagesChoices>> | InputMaybe<AuthAccountUserFluentLanguagesChoices>
  >;
  referredJobPositionsId?: InputMaybe<Array<InputMaybe<Scalars["ID"]["input"]>> | InputMaybe<Scalars["ID"]["input"]>>;
  isAssessmentsDone?: InputMaybe<Scalars["Boolean"]["input"]>;
  orderBy?: InputMaybe<AuthAccountUserOrderByChoices>;
}>;

export type GetJobSeekersQuery = {
  __typename?: "Query";
  admin?: {
    __typename?: "AdminQuery";
    jobSeekers?: {
      __typename?: "AdminJobSeekerTypeConnection";
      totalCount?: number | null;
      edges: Array<{
        __typename?: "AdminJobSeekerTypeEdge";
        node?: {
          __typename?: "AdminJobSeekerType";
          id: string;
          email: string;
          firstName: string;
          lastName: string;
          dateJoined: any;
          canadaVisa?: {
            __typename?: "AdminCanadaVisaType";
            status: AuthAccountCanadaVisaStatusChoices;
            id: string;
            nationality?: { __typename?: "CountryNode"; name: string } | null;
          } | null;
          profile?: {
            __typename?: "ProfileType";
            gender?: AuthAccountProfileGenderChoices | null;
            allowNotifications: boolean;
            avatar?: { __typename?: "AvatarFileType"; file: string } | null;
            contacts?: Array<{
              __typename?: "ContactType";
              id: string;
              type: AuthAccountContactTypeChoices;
              value: string;
            } | null> | null;
            city?: {
              __typename?: "CityNode";
              name: string;
              country: { __typename?: "CountryNode"; name: string };
            } | null;
            industry?: { __typename?: "IndustryNode"; title: string } | null;
          } | null;
        } | null;
      } | null>;
      pageInfo: {
        __typename?: "PageInfo";
        endCursor?: string | null;
        hasNextPage: boolean;
        hasPreviousPage: boolean;
        startCursor?: string | null;
      };
    } | null;
  } | null;
};

export type GetJobSeekersAssessmentsQueryVariables = Exact<{
  id: Scalars["Decimal"]["input"];
}>;

export type GetJobSeekersAssessmentsQuery = {
  __typename?: "Query";
  admin?: {
    __typename?: "AdminQuery";
    jobSeekers?: {
      __typename?: "AdminJobSeekerTypeConnection";
      edges: Array<{
        __typename?: "AdminJobSeekerTypeEdge";
        node?: {
          __typename?: "AdminJobSeekerType";
          assessments?: Array<{
            __typename?: "AdminAssessmentType";
            description: string;
            id: string;
            remainingQuestions: number;
            status: Status;
            title: string;
            totalEstimatedTime: number;
            totalQuestions: number;
            results?: Array<{
              __typename?: "OrganizationAssessmentResultType";
              evaluation?: {
                __typename?: "OrganizationEvaluationType";
                negativePoints: Array<string | null>;
                positivePoints: Array<string | null>;
                score: Score;
                scoreReasoning: string;
                scoreValue?: any | null;
                userFeedback: string;
              } | null;
              question: { __typename?: "AssessmentResultQuestionType"; status: QuestionStatus; text: string };
            } | null> | null;
            skill?: { __typename?: "AssessmentSkillType"; title: string; description: string } | null;
          } | null> | null;
        } | null;
      } | null>;
    } | null;
  } | null;
};

export type GetJobSeekersInterestedJobsQueryVariables = Exact<{
  id: Scalars["Decimal"]["input"];
}>;

export type GetJobSeekersInterestedJobsQuery = {
  __typename?: "Query";
  admin?: {
    __typename?: "AdminQuery";
    jobSeekers?: {
      __typename?: "AdminJobSeekerTypeConnection";
      edges: Array<{
        __typename?: "AdminJobSeekerTypeEdge";
        node?: {
          __typename?: "AdminJobSeekerType";
          profile?: {
            __typename?: "ProfileType";
            interestedJobs: {
              __typename?: "JobNodeConnection";
              edges: Array<{
                __typename?: "JobNodeEdge";
                node?: {
                  __typename?: "JobNode";
                  requireAppearanceData: boolean;
                  title: string;
                  industries: {
                    __typename?: "IndustryNodeConnection";
                    edges: Array<{
                      __typename?: "IndustryNodeEdge";
                      node?: { __typename?: "IndustryNode"; title: string } | null;
                    } | null>;
                  };
                } | null;
              } | null>;
            };
          } | null;
        } | null;
      } | null>;
    } | null;
  } | null;
};

export type GetLanguagesCertificatesQueryVariables = Exact<{
  id: Scalars["Decimal"]["input"];
}>;

export type GetLanguagesCertificatesQuery = {
  __typename?: "Query";
  admin?: {
    __typename?: "AdminQuery";
    jobSeekers?: {
      __typename?: "AdminJobSeekerTypeConnection";
      edges: Array<{
        __typename?: "AdminJobSeekerTypeEdge";
        node?: {
          __typename?: "AdminJobSeekerType";
          languagecertificates?: Array<{
            __typename?: "JobSeekerLanguageCertificateType";
            allowSelfVerification: boolean;
            expiredAt?: any | null;
            id: string;
            issuedAt: any;
            language: AuthAccountLanguageCertificateLanguageChoices;
            status: AuthAccountLanguageCertificateStatusChoices;
            test?: { __typename?: "LanguageProficiencyTestNode"; title: string; id: string } | null;
            values?: Array<{
              __typename?: "LanguageCertificateValueNode";
              id: string;
              value: string;
              skill?: {
                __typename?: "LanguageProficiencySkillNode";
                id: string;
                skillName: string;
                slug: string;
              } | null;
            }> | null;
          }> | null;
        } | null;
      } | null>;
    } | null;
  } | null;
};

export type GetNativeLanguagesQueryVariables = Exact<{
  id: Scalars["Decimal"]["input"];
}>;

export type GetNativeLanguagesQuery = {
  __typename?: "Query";
  admin?: {
    __typename?: "AdminQuery";
    jobSeekers?: {
      __typename?: "AdminJobSeekerTypeConnection";
      edges: Array<{
        __typename?: "AdminJobSeekerTypeEdge";
        node?: {
          __typename?: "AdminJobSeekerType";
          profile?: {
            __typename?: "ProfileType";
            fluentLanguages?: Array<AuthAccountProfileFluentLanguagesChoices | null> | null;
            nativeLanguage?: AuthAccountProfileNativeLanguageChoices | null;
          } | null;
        } | null;
      } | null>;
    } | null;
  } | null;
};

export type GetProfileIndustryQueryVariables = Exact<{
  id: Scalars["Decimal"]["input"];
}>;

export type GetProfileIndustryQuery = {
  __typename?: "Query";
  admin?: {
    __typename?: "AdminQuery";
    jobSeekers?: {
      __typename?: "AdminJobSeekerTypeConnection";
      edges: Array<{
        __typename?: "AdminJobSeekerTypeEdge";
        node?: {
          __typename?: "AdminJobSeekerType";
          profile?: {
            __typename?: "ProfileType";
            industry?: { __typename?: "IndustryNode"; id: string; title: string } | null;
          } | null;
        } | null;
      } | null>;
    } | null;
  } | null;
};

export type GetUserSkillsQueryVariables = Exact<{
  id: Scalars["Decimal"]["input"];
}>;

export type GetUserSkillsQuery = {
  __typename?: "Query";
  admin?: {
    __typename?: "AdminQuery";
    jobSeekers?: {
      __typename?: "AdminJobSeekerTypeConnection";
      edges: Array<{
        __typename?: "AdminJobSeekerTypeEdge";
        node?: {
          __typename?: "AdminJobSeekerType";
          profile?: {
            __typename?: "ProfileType";
            rawSkills?: Array<string> | null;
            skills: Array<{ __typename?: "SkillType"; id: string; title: string }>;
          } | null;
        } | null;
      } | null>;
    } | null;
  } | null;
};

export type GetWorkExperiencesQueryVariables = Exact<{
  id: Scalars["Decimal"]["input"];
}>;

export type GetWorkExperiencesQuery = {
  __typename?: "Query";
  admin?: {
    __typename?: "AdminQuery";
    jobSeekers?: {
      __typename?: "AdminJobSeekerTypeConnection";
      edges: Array<{
        __typename?: "AdminJobSeekerTypeEdge";
        node?: {
          __typename?: "AdminJobSeekerType";
          workexperiences?: Array<{
            __typename?: "JobSeekerWorkExperienceType";
            id: string;
            grade: AuthAccountWorkExperienceGradeChoices;
            end?: any | null;
            jobTitle: string;
            organization: string;
            start: any;
            status: AuthAccountWorkExperienceStatusChoices;
            city: {
              __typename?: "CityNode";
              id: string;
              name: string;
              country: { __typename?: "CountryNode"; name: string; id: string };
              region?: { __typename?: "RegionNode"; name: string } | null;
            };
          }> | null;
        } | null;
      } | null>;
    } | null;
  } | null;
};

export type GetJobSuggestionsQueryVariables = Exact<{
  jobPositionId: Scalars["ID"]["input"];
}>;

export type GetJobSuggestionsQuery = {
  __typename?: "Query";
  admin?: {
    __typename?: "AdminQuery";
    jobSuggestionResult?: {
      __typename?: "JobSuggestionResultNodeConnection";
      edges: Array<{
        __typename?: "JobSuggestionResultNodeEdge";
        node?: {
          __typename?: "JobSuggestionResultNode";
          id: string;
          items?: {
            __typename?: "JobSuggestionResultItemNodeConnection";
            edges: Array<{
              __typename?: "JobSuggestionResultItemNodeEdge";
              node?: {
                __typename?: "JobSuggestionResultItemNode";
                id: string;
                matchExplanation?: string | null;
                matchScore?: number | null;
                recommendation: number;
                seniorityMatch: number;
                skillMatch: number;
                strengths?: Array<string> | null;
                considerations?: Array<string> | null;
                confidenceLevel: number;
                experienceMatch: number;
                isAssigned?: boolean | null;
                user?: {
                  __typename?: "UserNode";
                  email: string;
                  firstName: string;
                  lastName: string;
                  profile?: {
                    __typename?: "ProfileType";
                    score: number;
                    avatar?: { __typename?: "AvatarFileType"; file: string } | null;
                  } | null;
                  resume?: { __typename?: "ResumeType"; file: { __typename?: "ResumeFileType"; file: string } } | null;
                  workexperiences?: Array<{
                    __typename?: "WorkExperienceNode";
                    jobTitle: string;
                    organization: string;
                  }> | null;
                } | null;
                jobPositionAssignment?: {
                  __typename?: "JobPositionAssignmentNode";
                  id: string;
                  status: AuthAccountJobPositionAssignmentStatusChoices;
                  createdAt: any;
                } | null;
              } | null;
            } | null>;
          } | null;
        } | null;
      } | null>;
    } | null;
  } | null;
};

export type GetLanguageCertificateByIdQueryVariables = Exact<{
  id: Scalars["NotEmptyID"]["input"];
}>;

export type GetLanguageCertificateByIdQuery = {
  __typename?: "Query";
  admin?: {
    __typename?: "AdminQuery";
    languageCertificate?: {
      __typename?: "LanguageCertificateNode";
      allowSelfVerification: boolean;
      expiredAt?: any | null;
      id: string;
      issuedAt: any;
      language: AuthAccountLanguageCertificateLanguageChoices;
      status: AuthAccountLanguageCertificateStatusChoices;
      test?: {
        __typename?: "LanguageProficiencyTestNode";
        id: string;
        title: string;
        skills?: {
          __typename?: "LanguageProficiencySkillNodeConnection";
          edges: Array<{
            __typename?: "LanguageProficiencySkillNodeEdge";
            node?: { __typename?: "LanguageProficiencySkillNode"; skillName: string; id: string; slug: string } | null;
          } | null>;
        } | null;
      } | null;
      values?: Array<{
        __typename?: "LanguageCertificateValueNode";
        value: string;
        id: string;
        skill?: { __typename?: "LanguageProficiencySkillNode"; id: string; skillName: string; slug: string } | null;
      } | null> | null;
      offlinemethod?: {
        __typename?: "LanguageCertificateOfflineVerificationMethodType";
        certificateFile: { __typename?: "LanguageCertificateFileType"; file: string };
      } | null;
      onlinemethod?: { __typename?: "LanguageCertificateOnlineVerificationMethodType"; certificateLink: string } | null;
    } | null;
  } | null;
};

export type GetUserInfoForLayoutQueryVariables = Exact<{ [key: string]: never }>;

export type GetUserInfoForLayoutQuery = {
  __typename?: "Query";
  me?: {
    __typename?: "UserNode";
    email: string;
    firstName: string;
    lastName: string;
    profile?: { __typename?: "ProfileType"; avatar?: { __typename?: "AvatarFileType"; file: string } | null } | null;
  } | null;
};

export type GetPlatformMessagesByIdQueryVariables = Exact<{
  id: Scalars["ID"]["input"];
}>;

export type GetPlatformMessagesByIdQuery = {
  __typename?: "Query";
  admin?: {
    __typename?: "AdminQuery";
    organizations?: {
      __typename?: "AdminOrganizationNodeConnection";
      edges: Array<{
        __typename?: "AdminOrganizationNodeEdge";
        node?: {
          __typename?: "AdminOrganizationNode";
          platformMessages?: {
            __typename?: "OrganizationPlatformMessageNodeConnection";
            edges: Array<{
              __typename?: "OrganizationPlatformMessageNodeEdge";
              node?: {
                __typename?: "OrganizationPlatformMessageNode";
                title: string;
                text: string;
                source: AuthAccountOrganizationPlatformMessageSourceChoices;
                readAt?: any | null;
                created: any;
                id: string;
                attachments: Array<{
                  __typename?: "OrganizationPlatformMessageAttachmentType";
                  id: string;
                  text: string;
                  attachmentType?: AttachmentType | null;
                  file?: { __typename?: "BaseFileModelType"; file: string } | null;
                  courseResult?: {
                    __typename?: "CourseResultType";
                    status: AcademyCourseResultStatusChoices;
                    course: { __typename?: "CourseNode"; name: string; logo?: string | null };
                  } | null;
                  course?: { __typename?: "CourseNode"; name: string; logo?: string | null } | null;
                }>;
              } | null;
            } | null>;
          } | null;
        } | null;
      } | null>;
    } | null;
  } | null;
};

export type GetEmployeeStatisticsQueryVariables = Exact<{
  organizationId: Scalars["ID"]["input"];
}>;

export type GetEmployeeStatisticsQuery = {
  __typename?: "Query";
  admin?: {
    __typename?: "AdminQuery";
    organizations?: {
      __typename?: "AdminOrganizationNodeConnection";
      edges: Array<{
        __typename?: "AdminOrganizationNodeEdge";
        node?: {
          __typename?: "AdminOrganizationNode";
          employeeCooperationStatusCounts?: {
            __typename?: "OrganizationEmployeeCooperationStatusCountsType";
            active?: number | null;
            awaiting?: number | null;
            finished?: number | null;
            fired?: number | null;
            resigned?: number | null;
            suspended?: number | null;
          } | null;
          jobPositionLocationTypeCounts?: {
            __typename?: "JobPositionLocationTypeCountsType";
            globalCount?: number | null;
            hybridCount?: number | null;
            limitedAreaCount?: number | null;
            onTheRoadCount?: number | null;
            preciseLocationCount?: number | null;
            remoteCount?: number | null;
          } | null;
        } | null;
      } | null>;
    } | null;
  } | null;
};

export type GetOrganizationDetailQueryVariables = Exact<{
  id: Scalars["ID"]["input"];
}>;

export type GetOrganizationDetailQuery = {
  __typename?: "Query";
  admin?: {
    __typename?: "AdminQuery";
    organizations?: {
      __typename?: "AdminOrganizationNodeConnection";
      edges: Array<{
        __typename?: "AdminOrganizationNodeEdge";
        node?: {
          __typename?: "AdminOrganizationNode";
          id: string;
          name: string;
          status: AuthAccountOrganizationStatusChoices;
          businessType?: AuthAccountOrganizationBusinessTypeChoices | null;
          logo?: { __typename?: "OrganizationLogoFileType"; file: string } | null;
          employeeCooperationStatusCounts?: {
            __typename?: "OrganizationEmployeeCooperationStatusCountsType";
            suspended?: number | null;
            resigned?: number | null;
            fired?: number | null;
            finished?: number | null;
            awaiting?: number | null;
            active?: number | null;
          } | null;
        } | null;
      } | null>;
    } | null;
  } | null;
};

export type GetOrganizationEmployeesQueryVariables = Exact<{
  organizationId: Scalars["ID"]["input"];
  first?: InputMaybe<Scalars["Int"]["input"]>;
  locationType?: InputMaybe<AuthAccountOrganizationJobPositionLocationTypeChoices>;
  title?: InputMaybe<Scalars["String"]["input"]>;
  status?: InputMaybe<AuthAccountOrganizationEmployeeCooperationStatusChoices>;
}>;

export type GetOrganizationEmployeesQuery = {
  __typename?: "Query";
  admin?: {
    __typename?: "AdminQuery";
    organizations?: {
      __typename?: "AdminOrganizationNodeConnection";
      edges: Array<{
        __typename?: "AdminOrganizationNodeEdge";
        node?: {
          __typename?: "AdminOrganizationNode";
          organizationEmployees?: {
            __typename?: "AdminOrganizationEmployeeNodeConnection";
            edges: Array<{
              __typename?: "AdminOrganizationEmployeeNodeEdge";
              node?: {
                __typename?: "AdminOrganizationEmployeeNode";
                cooperation?: {
                  __typename?: "AdminCooperationType";
                  id: string;
                  status: AuthAccountOrganizationEmployeeCooperationStatusChoices;
                  startAt?: any | null;
                  jobPosition?: {
                    __typename?: "AdminJobPositionNode";
                    title?: string | null;
                    locationType?: AuthAccountOrganizationJobPositionLocationTypeChoices | null;
                    contractType?: AuthAccountOrganizationJobPositionContractTypeChoices | null;
                  } | null;
                } | null;
                employee?: {
                  __typename?: "EmployeeType";
                  email: string;
                  firstName: string;
                  lastName: string;
                  profile?: {
                    __typename?: "JobSeekerProfileType";
                    score: number;
                    avatar?: { __typename?: "AvatarFileType"; file: string } | null;
                    contacts?: Array<{
                      __typename?: "ContactType";
                      id: string;
                      value: string;
                      type: AuthAccountContactTypeChoices;
                    } | null> | null;
                  } | null;
                } | null;
              } | null;
            } | null>;
          } | null;
        } | null;
      } | null>;
    } | null;
  } | null;
};

export type GetOrganizationInformationAndCredentialsQueryVariables = Exact<{
  id: Scalars["ID"]["input"];
}>;

export type GetOrganizationInformationAndCredentialsQuery = {
  __typename?: "Query";
  admin?: {
    __typename?: "AdminQuery";
    organizations?: {
      __typename?: "AdminOrganizationNodeConnection";
      edges: Array<{
        __typename?: "AdminOrganizationNodeEdge";
        node?: {
          __typename?: "AdminOrganizationNode";
          id: string;
          name: string;
          status: AuthAccountOrganizationStatusChoices;
          shortName?: string | null;
          email?: string | null;
          size?: AuthAccountOrganizationSizeChoices | null;
          nationalNumber?: string | null;
          businessType?: AuthAccountOrganizationBusinessTypeChoices | null;
          type?: AuthAccountOrganizationTypeChoices | null;
          establishedAt?: any | null;
          about?: string | null;
          industry?: { __typename?: "IndustryNode"; title: string; id: string } | null;
          dnstxtrecordmethod?: { __typename?: "DNSTXTRecordMethodType"; id: string; code: string } | null;
          communicateorganizationmethod?: {
            __typename?: "CommunicateOrganizationMethodType";
            email?: string | null;
            id: string;
            phonenumber: string;
          } | null;
          contacts?: Array<{
            __typename?: "ContactType";
            value: string;
            type: AuthAccountContactTypeChoices;
            id: string;
          } | null> | null;
          uploadfiletowebsitemethod?: {
            __typename?: "UploadFileToWebsiteMethodType";
            fileName: string;
            id: string;
          } | null;
          uploadcompanycertificatemethod?: {
            __typename?: "UploadCompanyCertificateMethodType";
            id: string;
            organizationCertificateFile: { __typename?: "OrganizationCertificateFileType"; file: string };
          } | null;
          city?: { __typename?: "CityNode"; id: string } | null;
        } | null;
      } | null>;
    } | null;
  } | null;
};

export type GetOrganizationsQueryVariables = Exact<{
  industry?: InputMaybe<Scalars["ID"]["input"]>;
  name?: InputMaybe<Scalars["String"]["input"]>;
  shortName?: InputMaybe<Scalars["String"]["input"]>;
  businessType?: InputMaybe<AuthAccountOrganizationBusinessTypeChoices>;
  status?: InputMaybe<AuthAccountOrganizationStatusChoices>;
  sizeGte?: InputMaybe<AuthAccountOrganizationSizeChoices>;
  phone?: InputMaybe<Scalars["String"]["input"]>;
  email?: InputMaybe<Scalars["String"]["input"]>;
  jobPositionId?: InputMaybe<Scalars["String"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
}>;

export type GetOrganizationsQuery = {
  __typename?: "Query";
  admin?: {
    __typename?: "AdminQuery";
    organizations?: {
      __typename?: "AdminOrganizationNodeConnection";
      totalCount?: number | null;
      edges: Array<{
        __typename?: "AdminOrganizationNodeEdge";
        node?: {
          __typename?: "AdminOrganizationNode";
          id: string;
          name: string;
          shortName?: string | null;
          email?: string | null;
          size?: AuthAccountOrganizationSizeChoices | null;
          status: AuthAccountOrganizationStatusChoices;
          logo?: { __typename?: "OrganizationLogoFileType"; file: string } | null;
          industry?: { __typename?: "IndustryNode"; title: string } | null;
          contacts?: Array<{
            __typename?: "ContactType";
            value: string;
            type: AuthAccountContactTypeChoices;
            id: string;
          } | null> | null;
          employeeCooperationStatusCounts?: {
            __typename?: "OrganizationEmployeeCooperationStatusCountsType";
            suspended?: number | null;
            resigned?: number | null;
            fired?: number | null;
            finished?: number | null;
            awaiting?: number | null;
            active?: number | null;
          } | null;
          jobPositionsStatusCounts?: {
            __typename?: "JobPositionStatusCountsType";
            submitted?: number | null;
            drafted?: number | null;
            expired?: number | null;
            published?: number | null;
            suspended?: number | null;
          } | null;
          user?: { __typename?: "OrganizationMembershipUserType"; id: string } | null;
        } | null;
      } | null>;
      pageInfo: {
        __typename?: "PageInfo";
        endCursor?: string | null;
        hasNextPage: boolean;
        hasPreviousPage: boolean;
        startCursor?: string | null;
      };
    } | null;
    organizationStatistics?: {
      __typename?: "AdminOrganizationStatisticsType";
      blockedCount?: number | null;
      completedCount?: number | null;
      draftedCount?: number | null;
      rejectedCount?: number | null;
      submittedCount?: number | null;
      verifiedCount?: number | null;
      withJobPositionsCount?: number | null;
      totalCount?: number | null;
    } | null;
  } | null;
};

export type GetWorkExperienceByIdQueryVariables = Exact<{
  id: Scalars["NotEmptyID"]["input"];
}>;

export type GetWorkExperienceByIdQuery = {
  __typename?: "Query";
  admin?: {
    __typename?: "AdminQuery";
    workExperience?: {
      __typename?: "WorkExperienceNode";
      grade: AuthAccountWorkExperienceGradeChoices;
      skills?: string | null;
      allowSelfVerification: boolean;
      end?: any | null;
      id: string;
      jobTitle: string;
      organization: string;
      start: any;
      status: AuthAccountWorkExperienceStatusChoices;
      city: {
        __typename?: "CityNode";
        id: string;
        name: string;
        country: { __typename?: "CountryNode"; id: string; name: string };
        region?: { __typename?: "RegionNode"; id: string; name: string } | null;
      };
      employerlettermethod?: {
        __typename?: "EmployerLetterMethodType";
        id: string;
        employerLetter: { __typename?: "EmployerLetterFileType"; file: string };
        employers?: Array<{
          __typename?: "ReferenceCheckEmployerType";
          email: string;
          id: string;
          name: string;
          phoneNumber: string;
          position: string;
        } | null> | null;
      } | null;
      paystubsmethod?: {
        __typename?: "PaystubsMethodType";
        id: string;
        paystubs: { __typename?: "PaystubsFileType"; file: string };
      } | null;
    } | null;
  } | null;
};

export type GetCitiesQueryVariables = Exact<{
  first?: InputMaybe<Scalars["Int"]["input"]>;
  after?: InputMaybe<Scalars["String"]["input"]>;
  before?: InputMaybe<Scalars["String"]["input"]>;
  name?: InputMaybe<Scalars["String"]["input"]>;
  region?: InputMaybe<Scalars["ID"]["input"]>;
  id?: InputMaybe<Scalars["ID"]["input"]>;
  country?: InputMaybe<Scalars["String"]["input"]>;
}>;

export type GetCitiesQuery = {
  __typename?: "Query";
  common?: {
    __typename?: "CommonQuery";
    cities?: {
      __typename?: "CityNodeConnection";
      edges: Array<{
        __typename?: "CityNodeEdge";
        node?: { __typename?: "CityNode"; id: string; name: string } | null;
      } | null>;
      pageInfo: {
        __typename?: "PageInfo";
        endCursor?: string | null;
        hasNextPage: boolean;
        hasPreviousPage: boolean;
        startCursor?: string | null;
      };
    } | null;
  } | null;
};

export type GetCountriesQueryVariables = Exact<{
  first?: InputMaybe<Scalars["Int"]["input"]>;
  after?: InputMaybe<Scalars["String"]["input"]>;
  before?: InputMaybe<Scalars["String"]["input"]>;
  name?: InputMaybe<Scalars["String"]["input"]>;
  id?: InputMaybe<Scalars["ID"]["input"]>;
}>;

export type GetCountriesQuery = {
  __typename?: "Query";
  common?: {
    __typename?: "CommonQuery";
    countries?: {
      __typename?: "CountryNodeConnection";
      pageInfo: {
        __typename?: "PageInfo";
        endCursor?: string | null;
        hasNextPage: boolean;
        hasPreviousPage: boolean;
        startCursor?: string | null;
      };
      edges: Array<{
        __typename?: "CountryNodeEdge";
        node?: { __typename?: "CountryNode"; name: string; id: string } | null;
      } | null>;
    } | null;
  } | null;
};

export type GetIndustriesQueryVariables = Exact<{ [key: string]: never }>;

export type GetIndustriesQuery = {
  __typename?: "Query";
  common?: {
    __typename?: "CommonQuery";
    industries?: {
      __typename?: "IndustryNodeConnection";
      edges: Array<{
        __typename?: "IndustryNodeEdge";
        node?: { __typename?: "IndustryNode"; id: string; title: string } | null;
      } | null>;
    } | null;
  } | null;
};

export type GetJobsQueryVariables = Exact<{
  first?: InputMaybe<Scalars["Int"]["input"]>;
  after?: InputMaybe<Scalars["String"]["input"]>;
  before?: InputMaybe<Scalars["String"]["input"]>;
  id?: InputMaybe<Scalars["ID"]["input"]>;
  title_Icontains?: InputMaybe<Scalars["String"]["input"]>;
}>;

export type GetJobsQuery = {
  __typename?: "Query";
  common?: {
    __typename?: "CommonQuery";
    jobs?: {
      __typename?: "JobNodeConnection";
      pageInfo: {
        __typename?: "PageInfo";
        endCursor?: string | null;
        hasNextPage: boolean;
        hasPreviousPage: boolean;
        startCursor?: string | null;
      };
      edges: Array<{
        __typename?: "JobNodeEdge";
        node?: { __typename?: "JobNode"; id: string; title: string } | null;
      } | null>;
    } | null;
  } | null;
};

export type GetSkillsQueryVariables = Exact<{
  after?: InputMaybe<Scalars["String"]["input"]>;
  before?: InputMaybe<Scalars["String"]["input"]>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  title_Icontains?: InputMaybe<Scalars["String"]["input"]>;
}>;

export type GetSkillsQuery = {
  __typename?: "Query";
  common?: {
    __typename?: "CommonQuery";
    skills?: {
      __typename?: "SkillNodeConnection";
      edges: Array<{
        __typename?: "SkillNodeEdge";
        node?: { __typename?: "SkillNode"; id: string; title: string } | null;
      } | null>;
      pageInfo: {
        __typename?: "PageInfo";
        endCursor?: string | null;
        hasNextPage: boolean;
        hasPreviousPage: boolean;
        startCursor?: string | null;
      };
    } | null;
  } | null;
};

export const AcceptJobSuggestionWithIdDocument = gql`
  mutation acceptJobSuggestionWithId($jobSuggestionResultId: ID!) {
    account {
      admin {
        acceptJobSuggestion(suggestionItemId: $jobSuggestionResultId) {
          jobPositionAssignment {
            status
          }
        }
      }
    }
  }
`;
export type AcceptJobSuggestionWithIdMutationFn = Apollo.MutationFunction<
  AcceptJobSuggestionWithIdMutation,
  AcceptJobSuggestionWithIdMutationVariables
>;

/**
 * __useAcceptJobSuggestionWithIdMutation__
 *
 * To run a mutation, you first call `useAcceptJobSuggestionWithIdMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAcceptJobSuggestionWithIdMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [acceptJobSuggestionWithIdMutation, { data, loading, error }] = useAcceptJobSuggestionWithIdMutation({
 *   variables: {
 *      jobSuggestionResultId: // value for 'jobSuggestionResultId'
 *   },
 * });
 */
export function useAcceptJobSuggestionWithIdMutation(
  baseOptions?: Apollo.MutationHookOptions<
    AcceptJobSuggestionWithIdMutation,
    AcceptJobSuggestionWithIdMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<AcceptJobSuggestionWithIdMutation, AcceptJobSuggestionWithIdMutationVariables>(
    AcceptJobSuggestionWithIdDocument,
    options,
  );
}
export type AcceptJobSuggestionWithIdMutationHookResult = ReturnType<typeof useAcceptJobSuggestionWithIdMutation>;
export type AcceptJobSuggestionWithIdMutationResult = Apollo.MutationResult<AcceptJobSuggestionWithIdMutation>;
export type AcceptJobSuggestionWithIdMutationOptions = Apollo.BaseMutationOptions<
  AcceptJobSuggestionWithIdMutation,
  AcceptJobSuggestionWithIdMutationVariables
>;
export const AssignJobToJobSeekerDocument = gql`
  mutation AssignJobToJobSeeker($jobPositionId: ID = "", $userId: ID = "") {
    account {
      admin {
        assignJob(jobPositionId: $jobPositionId, userId: $userId) {
          jobPositionAssignment {
            id
          }
        }
      }
    }
  }
`;
export type AssignJobToJobSeekerMutationFn = Apollo.MutationFunction<
  AssignJobToJobSeekerMutation,
  AssignJobToJobSeekerMutationVariables
>;

/**
 * __useAssignJobToJobSeekerMutation__
 *
 * To run a mutation, you first call `useAssignJobToJobSeekerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAssignJobToJobSeekerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [assignJobToJobSeekerMutation, { data, loading, error }] = useAssignJobToJobSeekerMutation({
 *   variables: {
 *      jobPositionId: // value for 'jobPositionId'
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useAssignJobToJobSeekerMutation(
  baseOptions?: Apollo.MutationHookOptions<AssignJobToJobSeekerMutation, AssignJobToJobSeekerMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<AssignJobToJobSeekerMutation, AssignJobToJobSeekerMutationVariables>(
    AssignJobToJobSeekerDocument,
    options,
  );
}
export type AssignJobToJobSeekerMutationHookResult = ReturnType<typeof useAssignJobToJobSeekerMutation>;
export type AssignJobToJobSeekerMutationResult = Apollo.MutationResult<AssignJobToJobSeekerMutation>;
export type AssignJobToJobSeekerMutationOptions = Apollo.BaseMutationOptions<
  AssignJobToJobSeekerMutation,
  AssignJobToJobSeekerMutationVariables
>;
export const HijackingUserDocument = gql`
  mutation HijackingUser($userId: ID!) {
    account {
      admin {
        hijack(userId: $userId) {
          token
          refreshToken
          refreshExpiresIn
          payload
          user {
            email
          }
        }
      }
    }
  }
`;
export type HijackingUserMutationFn = Apollo.MutationFunction<HijackingUserMutation, HijackingUserMutationVariables>;

/**
 * __useHijackingUserMutation__
 *
 * To run a mutation, you first call `useHijackingUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useHijackingUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [hijackingUserMutation, { data, loading, error }] = useHijackingUserMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useHijackingUserMutation(
  baseOptions?: Apollo.MutationHookOptions<HijackingUserMutation, HijackingUserMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<HijackingUserMutation, HijackingUserMutationVariables>(HijackingUserDocument, options);
}
export type HijackingUserMutationHookResult = ReturnType<typeof useHijackingUserMutation>;
export type HijackingUserMutationResult = Apollo.MutationResult<HijackingUserMutation>;
export type HijackingUserMutationOptions = Apollo.BaseMutationOptions<
  HijackingUserMutation,
  HijackingUserMutationVariables
>;
export const TriggerJobSuggestionWithIdDocument = gql`
  mutation triggerJobSuggestionWithId($jobPositionId: ID!) {
    account {
      admin {
        triggerJobSuggestion(jobPositionId: $jobPositionId) {
          success
        }
      }
    }
  }
`;
export type TriggerJobSuggestionWithIdMutationFn = Apollo.MutationFunction<
  TriggerJobSuggestionWithIdMutation,
  TriggerJobSuggestionWithIdMutationVariables
>;

/**
 * __useTriggerJobSuggestionWithIdMutation__
 *
 * To run a mutation, you first call `useTriggerJobSuggestionWithIdMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTriggerJobSuggestionWithIdMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [triggerJobSuggestionWithIdMutation, { data, loading, error }] = useTriggerJobSuggestionWithIdMutation({
 *   variables: {
 *      jobPositionId: // value for 'jobPositionId'
 *   },
 * });
 */
export function useTriggerJobSuggestionWithIdMutation(
  baseOptions?: Apollo.MutationHookOptions<
    TriggerJobSuggestionWithIdMutation,
    TriggerJobSuggestionWithIdMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<TriggerJobSuggestionWithIdMutation, TriggerJobSuggestionWithIdMutationVariables>(
    TriggerJobSuggestionWithIdDocument,
    options,
  );
}
export type TriggerJobSuggestionWithIdMutationHookResult = ReturnType<typeof useTriggerJobSuggestionWithIdMutation>;
export type TriggerJobSuggestionWithIdMutationResult = Apollo.MutationResult<TriggerJobSuggestionWithIdMutation>;
export type TriggerJobSuggestionWithIdMutationOptions = Apollo.BaseMutationOptions<
  TriggerJobSuggestionWithIdMutation,
  TriggerJobSuggestionWithIdMutationVariables
>;
export const UnssignJobToJobSeekerDocument = gql`
  mutation UnssignJobToJobSeeker($jobPositionAssignmentId: ID!) {
    account {
      admin {
        unassignJob(id: $jobPositionAssignmentId) {
          found
        }
      }
    }
  }
`;
export type UnssignJobToJobSeekerMutationFn = Apollo.MutationFunction<
  UnssignJobToJobSeekerMutation,
  UnssignJobToJobSeekerMutationVariables
>;

/**
 * __useUnssignJobToJobSeekerMutation__
 *
 * To run a mutation, you first call `useUnssignJobToJobSeekerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUnssignJobToJobSeekerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [unssignJobToJobSeekerMutation, { data, loading, error }] = useUnssignJobToJobSeekerMutation({
 *   variables: {
 *      jobPositionAssignmentId: // value for 'jobPositionAssignmentId'
 *   },
 * });
 */
export function useUnssignJobToJobSeekerMutation(
  baseOptions?: Apollo.MutationHookOptions<UnssignJobToJobSeekerMutation, UnssignJobToJobSeekerMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<UnssignJobToJobSeekerMutation, UnssignJobToJobSeekerMutationVariables>(
    UnssignJobToJobSeekerDocument,
    options,
  );
}
export type UnssignJobToJobSeekerMutationHookResult = ReturnType<typeof useUnssignJobToJobSeekerMutation>;
export type UnssignJobToJobSeekerMutationResult = Apollo.MutationResult<UnssignJobToJobSeekerMutation>;
export type UnssignJobToJobSeekerMutationOptions = Apollo.BaseMutationOptions<
  UnssignJobToJobSeekerMutation,
  UnssignJobToJobSeekerMutationVariables
>;
export const UpdateJobPositionStatusDocument = gql`
  mutation UpdateJobPositionStatus($status: AuthAccountOrganizationJobPositionStatusChoices!, $id: ID!) {
    account {
      admin {
        updateJobPositionStatus(id: $id, input: { status: $status }) {
          organizationJobPosition {
            id
          }
        }
      }
    }
  }
`;
export type UpdateJobPositionStatusMutationFn = Apollo.MutationFunction<
  UpdateJobPositionStatusMutation,
  UpdateJobPositionStatusMutationVariables
>;

/**
 * __useUpdateJobPositionStatusMutation__
 *
 * To run a mutation, you first call `useUpdateJobPositionStatusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateJobPositionStatusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateJobPositionStatusMutation, { data, loading, error }] = useUpdateJobPositionStatusMutation({
 *   variables: {
 *      status: // value for 'status'
 *      id: // value for 'id'
 *   },
 * });
 */
export function useUpdateJobPositionStatusMutation(
  baseOptions?: Apollo.MutationHookOptions<UpdateJobPositionStatusMutation, UpdateJobPositionStatusMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<UpdateJobPositionStatusMutation, UpdateJobPositionStatusMutationVariables>(
    UpdateJobPositionStatusDocument,
    options,
  );
}
export type UpdateJobPositionStatusMutationHookResult = ReturnType<typeof useUpdateJobPositionStatusMutation>;
export type UpdateJobPositionStatusMutationResult = Apollo.MutationResult<UpdateJobPositionStatusMutation>;
export type UpdateJobPositionStatusMutationOptions = Apollo.BaseMutationOptions<
  UpdateJobPositionStatusMutation,
  UpdateJobPositionStatusMutationVariables
>;
export const UpdateOrganizationInformationDocument = gql`
  mutation UpdateOrganizationInformation(
    $organizationId: ID!
    $logo: ID
    $nationalNumber: String
    $shortName: String
    $city: ID
    $name: String!
    $about: String
    $industry: ID
    $businessType: AuthAccountOrganizationBusinessTypeChoices
    $type: AuthAccountOrganizationTypeChoices
    $size: AuthAccountOrganizationSizeChoices = _1_10
    $contacts: [AdminSetOrganizationContactableInput]!
    $establishedAt: Date
  ) {
    account {
      admin {
        setOrganizationContacts(input: $contacts) {
          contacts {
            id
          }
        }
        updateOrganization(
          id: $organizationId
          input: {
            about: $about
            name: $name
            shortName: $shortName
            nationalNumber: $nationalNumber
            industry: $industry
            businessType: $businessType
            type: $type
            establishedAt: $establishedAt
            size: $size
            logo: $logo
            city: $city
          }
        ) {
          organization {
            id
            about
            businessType
            establishedAt
            hasFinancialData
            industry {
              id
            }
            logo {
              file
            }
            name
            nationalNumber
            shortName
            size
            status
            type
            contacts {
              id
              type
              value
            }
            email
            city {
              id
            }
          }
        }
      }
    }
  }
`;
export type UpdateOrganizationInformationMutationFn = Apollo.MutationFunction<
  UpdateOrganizationInformationMutation,
  UpdateOrganizationInformationMutationVariables
>;

/**
 * __useUpdateOrganizationInformationMutation__
 *
 * To run a mutation, you first call `useUpdateOrganizationInformationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateOrganizationInformationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateOrganizationInformationMutation, { data, loading, error }] = useUpdateOrganizationInformationMutation({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *      logo: // value for 'logo'
 *      nationalNumber: // value for 'nationalNumber'
 *      shortName: // value for 'shortName'
 *      city: // value for 'city'
 *      name: // value for 'name'
 *      about: // value for 'about'
 *      industry: // value for 'industry'
 *      businessType: // value for 'businessType'
 *      type: // value for 'type'
 *      size: // value for 'size'
 *      contacts: // value for 'contacts'
 *      establishedAt: // value for 'establishedAt'
 *   },
 * });
 */
export function useUpdateOrganizationInformationMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateOrganizationInformationMutation,
    UpdateOrganizationInformationMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<UpdateOrganizationInformationMutation, UpdateOrganizationInformationMutationVariables>(
    UpdateOrganizationInformationDocument,
    options,
  );
}
export type UpdateOrganizationInformationMutationHookResult = ReturnType<
  typeof useUpdateOrganizationInformationMutation
>;
export type UpdateOrganizationInformationMutationResult = Apollo.MutationResult<UpdateOrganizationInformationMutation>;
export type UpdateOrganizationInformationMutationOptions = Apollo.BaseMutationOptions<
  UpdateOrganizationInformationMutation,
  UpdateOrganizationInformationMutationVariables
>;
export const UpdateOrganizationStatusDocument = gql`
  mutation UpdateOrganizationStatus($id: ID!, $status: AuthAccountOrganizationStatusChoices!) {
    account {
      admin {
        updateOrganizationStatus(id: $id, input: { status: $status }) {
          organization {
            id
          }
        }
      }
    }
  }
`;
export type UpdateOrganizationStatusMutationFn = Apollo.MutationFunction<
  UpdateOrganizationStatusMutation,
  UpdateOrganizationStatusMutationVariables
>;

/**
 * __useUpdateOrganizationStatusMutation__
 *
 * To run a mutation, you first call `useUpdateOrganizationStatusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateOrganizationStatusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateOrganizationStatusMutation, { data, loading, error }] = useUpdateOrganizationStatusMutation({
 *   variables: {
 *      id: // value for 'id'
 *      status: // value for 'status'
 *   },
 * });
 */
export function useUpdateOrganizationStatusMutation(
  baseOptions?: Apollo.MutationHookOptions<UpdateOrganizationStatusMutation, UpdateOrganizationStatusMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<UpdateOrganizationStatusMutation, UpdateOrganizationStatusMutationVariables>(
    UpdateOrganizationStatusDocument,
    options,
  );
}
export type UpdateOrganizationStatusMutationHookResult = ReturnType<typeof useUpdateOrganizationStatusMutation>;
export type UpdateOrganizationStatusMutationResult = Apollo.MutationResult<UpdateOrganizationStatusMutation>;
export type UpdateOrganizationStatusMutationOptions = Apollo.BaseMutationOptions<
  UpdateOrganizationStatusMutation,
  UpdateOrganizationStatusMutationVariables
>;
export const AccountRefreshTokenDocument = gql`
  mutation AccountRefreshToken($refreshToken: String!) {
    account {
      refreshToken(refreshToken: $refreshToken) {
        token
        success
        payload
      }
    }
  }
`;
export type AccountRefreshTokenMutationFn = Apollo.MutationFunction<
  AccountRefreshTokenMutation,
  AccountRefreshTokenMutationVariables
>;

/**
 * __useAccountRefreshTokenMutation__
 *
 * To run a mutation, you first call `useAccountRefreshTokenMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAccountRefreshTokenMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [accountRefreshTokenMutation, { data, loading, error }] = useAccountRefreshTokenMutation({
 *   variables: {
 *      refreshToken: // value for 'refreshToken'
 *   },
 * });
 */
export function useAccountRefreshTokenMutation(
  baseOptions?: Apollo.MutationHookOptions<AccountRefreshTokenMutation, AccountRefreshTokenMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<AccountRefreshTokenMutation, AccountRefreshTokenMutationVariables>(
    AccountRefreshTokenDocument,
    options,
  );
}
export type AccountRefreshTokenMutationHookResult = ReturnType<typeof useAccountRefreshTokenMutation>;
export type AccountRefreshTokenMutationResult = Apollo.MutationResult<AccountRefreshTokenMutation>;
export type AccountRefreshTokenMutationOptions = Apollo.BaseMutationOptions<
  AccountRefreshTokenMutation,
  AccountRefreshTokenMutationVariables
>;
export const AccountRevokeTokenDocument = gql`
  mutation AccountRevokeToken($refreshToken: String!) {
    account {
      revokeToken(refreshToken: $refreshToken) {
        success
      }
    }
  }
`;
export type AccountRevokeTokenMutationFn = Apollo.MutationFunction<
  AccountRevokeTokenMutation,
  AccountRevokeTokenMutationVariables
>;

/**
 * __useAccountRevokeTokenMutation__
 *
 * To run a mutation, you first call `useAccountRevokeTokenMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAccountRevokeTokenMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [accountRevokeTokenMutation, { data, loading, error }] = useAccountRevokeTokenMutation({
 *   variables: {
 *      refreshToken: // value for 'refreshToken'
 *   },
 * });
 */
export function useAccountRevokeTokenMutation(
  baseOptions?: Apollo.MutationHookOptions<AccountRevokeTokenMutation, AccountRevokeTokenMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<AccountRevokeTokenMutation, AccountRevokeTokenMutationVariables>(
    AccountRevokeTokenDocument,
    options,
  );
}
export type AccountRevokeTokenMutationHookResult = ReturnType<typeof useAccountRevokeTokenMutation>;
export type AccountRevokeTokenMutationResult = Apollo.MutationResult<AccountRevokeTokenMutation>;
export type AccountRevokeTokenMutationOptions = Apollo.BaseMutationOptions<
  AccountRevokeTokenMutation,
  AccountRevokeTokenMutationVariables
>;
export const AccountTokenAuthDocument = gql`
  mutation AccountTokenAuth($email: String!, $password: String!, $deviceId: String!, $gRecaptchaToken: String!) {
    account {
      tokenAuth(email: $email, password: $password, deviceId: $deviceId, gRecaptchaToken: $gRecaptchaToken) {
        token
        success
        refreshExpiresIn
        payload
        refreshToken
      }
    }
  }
`;
export type AccountTokenAuthMutationFn = Apollo.MutationFunction<
  AccountTokenAuthMutation,
  AccountTokenAuthMutationVariables
>;

/**
 * __useAccountTokenAuthMutation__
 *
 * To run a mutation, you first call `useAccountTokenAuthMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAccountTokenAuthMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [accountTokenAuthMutation, { data, loading, error }] = useAccountTokenAuthMutation({
 *   variables: {
 *      email: // value for 'email'
 *      password: // value for 'password'
 *      deviceId: // value for 'deviceId'
 *      gRecaptchaToken: // value for 'gRecaptchaToken'
 *   },
 * });
 */
export function useAccountTokenAuthMutation(
  baseOptions?: Apollo.MutationHookOptions<AccountTokenAuthMutation, AccountTokenAuthMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<AccountTokenAuthMutation, AccountTokenAuthMutationVariables>(
    AccountTokenAuthDocument,
    options,
  );
}
export type AccountTokenAuthMutationHookResult = ReturnType<typeof useAccountTokenAuthMutation>;
export type AccountTokenAuthMutationResult = Apollo.MutationResult<AccountTokenAuthMutation>;
export type AccountTokenAuthMutationOptions = Apollo.BaseMutationOptions<
  AccountTokenAuthMutation,
  AccountTokenAuthMutationVariables
>;
export const GetAssignmentsDocument = gql`
  query GetAssignments(
    $id: ID
    $first: Int = 10
    $offset: Int = 0
    $jobSeekerFullName: String
    $jobSeekerProfileScoreGte: Int
    $createdAtGte: DateTime
    $statusIn: [AuthAccountJobPositionAssignmentStatusChoices]
  ) {
    admin {
      jobPositions(id: $id) {
        edges {
          node {
            assignments(
              first: $first
              offset: $offset
              jobSeekerFullName: $jobSeekerFullName
              jobSeeker_Profile_Score_Gte: $jobSeekerProfileScoreGte
              createdAt_Gte: $createdAtGte
              status_In: $statusIn
            ) {
              edges {
                node {
                  interviews {
                    id
                    slot {
                      datetime
                      id
                      isAvailable
                    }
                  }
                  createdAt
                  id
                  statusHistories {
                    createdAt
                    status
                  }
                  status
                  jobSeeker {
                    ... on JobSeekerType {
                      __typename
                      id
                      email
                      firstName
                      lastName
                      profile {
                        avatar {
                          file
                        }
                        score
                      }
                      resume {
                        file {
                          file
                        }
                      }
                      workexperiences {
                        organization
                        jobTitle
                      }
                    }
                  }
                }
              }
              pageInfo {
                startCursor
                hasPreviousPage
                hasNextPage
                endCursor
              }
              totalCount
            }
          }
        }
      }
    }
  }
`;

/**
 * __useGetAssignmentsQuery__
 *
 * To run a query within a React component, call `useGetAssignmentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAssignmentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAssignmentsQuery({
 *   variables: {
 *      id: // value for 'id'
 *      first: // value for 'first'
 *      offset: // value for 'offset'
 *      jobSeekerFullName: // value for 'jobSeekerFullName'
 *      jobSeekerProfileScoreGte: // value for 'jobSeekerProfileScoreGte'
 *      createdAtGte: // value for 'createdAtGte'
 *      statusIn: // value for 'statusIn'
 *   },
 * });
 */
export function useGetAssignmentsQuery(
  baseOptions?: Apollo.QueryHookOptions<GetAssignmentsQuery, GetAssignmentsQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetAssignmentsQuery, GetAssignmentsQueryVariables>(GetAssignmentsDocument, options);
}
export function useGetAssignmentsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetAssignmentsQuery, GetAssignmentsQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetAssignmentsQuery, GetAssignmentsQueryVariables>(GetAssignmentsDocument, options);
}
export function useGetAssignmentsSuspenseQuery(
  baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAssignmentsQuery, GetAssignmentsQueryVariables>,
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<GetAssignmentsQuery, GetAssignmentsQueryVariables>(GetAssignmentsDocument, options);
}
export type GetAssignmentsQueryHookResult = ReturnType<typeof useGetAssignmentsQuery>;
export type GetAssignmentsLazyQueryHookResult = ReturnType<typeof useGetAssignmentsLazyQuery>;
export type GetAssignmentsSuspenseQueryHookResult = ReturnType<typeof useGetAssignmentsSuspenseQuery>;
export type GetAssignmentsQueryResult = Apollo.QueryResult<GetAssignmentsQuery, GetAssignmentsQueryVariables>;
export const GetJobPositionsDocument = gql`
  query GetJobPositions(
    $id: ID
    $startDate: Date
    $endDate: Date
    $status: AuthAccountOrganizationJobPositionStatusChoices
    $title: String
    $organizationName: String
    $offset: Int = 0
    $first: Int = 10
  ) {
    admin {
      jobPositions(
        id: $id
        title_Icontains: $title
        status: $status
        startAt_Gte: $startDate
        startAt_Lte: $endDate
        offset: $offset
        first: $first
        organization_Name_Icontains: $organizationName
      ) {
        edges {
          node {
            report {
              assignmentStatusCounts {
                count
                status
              }
            }
            ageRange
            benefits {
              id
              name
            }
            cities {
              edges {
                node {
                  id
                  name
                }
              }
            }
            contractType
            daysOff
            degrees
            description
            employerQuestions
            fields {
              id
              name
            }
            id
            jobRestrictions
            languages
            locationType
            nativeLanguages
            otherBenefits
            paymentTerm
            performanceExpectation
            requiredDocuments
            salaryRange
            skills {
              id
              title
            }
            startAt
            status
            title
            vaccancy
            validityDate
            workExperienceYearsRange
            workingEndAt
            workingStartAt
            isEditable
            organization {
              name
              logo {
                file
              }
              shortName
            }
          }
        }
        totalCount
        pageInfo {
          endCursor
          hasNextPage
          hasPreviousPage
          startCursor
        }
      }
    }
  }
`;

/**
 * __useGetJobPositionsQuery__
 *
 * To run a query within a React component, call `useGetJobPositionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetJobPositionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetJobPositionsQuery({
 *   variables: {
 *      id: // value for 'id'
 *      startDate: // value for 'startDate'
 *      endDate: // value for 'endDate'
 *      status: // value for 'status'
 *      title: // value for 'title'
 *      organizationName: // value for 'organizationName'
 *      offset: // value for 'offset'
 *      first: // value for 'first'
 *   },
 * });
 */
export function useGetJobPositionsQuery(
  baseOptions?: Apollo.QueryHookOptions<GetJobPositionsQuery, GetJobPositionsQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetJobPositionsQuery, GetJobPositionsQueryVariables>(GetJobPositionsDocument, options);
}
export function useGetJobPositionsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetJobPositionsQuery, GetJobPositionsQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetJobPositionsQuery, GetJobPositionsQueryVariables>(GetJobPositionsDocument, options);
}
export function useGetJobPositionsSuspenseQuery(
  baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetJobPositionsQuery, GetJobPositionsQueryVariables>,
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<GetJobPositionsQuery, GetJobPositionsQueryVariables>(GetJobPositionsDocument, options);
}
export type GetJobPositionsQueryHookResult = ReturnType<typeof useGetJobPositionsQuery>;
export type GetJobPositionsLazyQueryHookResult = ReturnType<typeof useGetJobPositionsLazyQuery>;
export type GetJobPositionsSuspenseQueryHookResult = ReturnType<typeof useGetJobPositionsSuspenseQuery>;
export type GetJobPositionsQueryResult = Apollo.QueryResult<GetJobPositionsQuery, GetJobPositionsQueryVariables>;
export const GetJobPositionsSearchDocument = gql`
  query GetJobPositionsSearch($title: String, $offset: Int = 0, $first: Int = 10) {
    admin {
      jobPositions(title_Icontains: $title, offset: $offset, first: $first) {
        edges {
          node {
            id
            title
          }
        }
        totalCount
        pageInfo {
          endCursor
          hasNextPage
          hasPreviousPage
          startCursor
        }
      }
    }
  }
`;

/**
 * __useGetJobPositionsSearchQuery__
 *
 * To run a query within a React component, call `useGetJobPositionsSearchQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetJobPositionsSearchQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetJobPositionsSearchQuery({
 *   variables: {
 *      title: // value for 'title'
 *      offset: // value for 'offset'
 *      first: // value for 'first'
 *   },
 * });
 */
export function useGetJobPositionsSearchQuery(
  baseOptions?: Apollo.QueryHookOptions<GetJobPositionsSearchQuery, GetJobPositionsSearchQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetJobPositionsSearchQuery, GetJobPositionsSearchQueryVariables>(
    GetJobPositionsSearchDocument,
    options,
  );
}
export function useGetJobPositionsSearchLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetJobPositionsSearchQuery, GetJobPositionsSearchQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetJobPositionsSearchQuery, GetJobPositionsSearchQueryVariables>(
    GetJobPositionsSearchDocument,
    options,
  );
}
export function useGetJobPositionsSearchSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetJobPositionsSearchQuery, GetJobPositionsSearchQueryVariables>,
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<GetJobPositionsSearchQuery, GetJobPositionsSearchQueryVariables>(
    GetJobPositionsSearchDocument,
    options,
  );
}
export type GetJobPositionsSearchQueryHookResult = ReturnType<typeof useGetJobPositionsSearchQuery>;
export type GetJobPositionsSearchLazyQueryHookResult = ReturnType<typeof useGetJobPositionsSearchLazyQuery>;
export type GetJobPositionsSearchSuspenseQueryHookResult = ReturnType<typeof useGetJobPositionsSearchSuspenseQuery>;
export type GetJobPositionsSearchQueryResult = Apollo.QueryResult<
  GetJobPositionsSearchQuery,
  GetJobPositionsSearchQueryVariables
>;
export const GetOrganizationJobPositionsDocument = gql`
  query GetOrganizationJobPositions(
    $organizationId: ID
    $startDate: Date
    $endDate: Date
    $status: AuthAccountOrganizationJobPositionStatusChoices
    $title: String
  ) {
    admin {
      jobPositions(
        title_Icontains: $title
        status: $status
        startAt_Gte: $startDate
        startAt_Lte: $endDate
        organization: $organizationId
      ) {
        edges {
          node {
            id
            status
            title
            validityDate
            assignments {
              edges {
                node {
                  status
                }
              }
            }
            skills {
              title
            }
          }
        }
      }
      organizations(id: $organizationId) {
        edges {
          node {
            jobPositionsStatusCounts {
              drafted
              expired
              published
              rejected
              submitted
              suspended
            }
          }
        }
      }
    }
  }
`;

/**
 * __useGetOrganizationJobPositionsQuery__
 *
 * To run a query within a React component, call `useGetOrganizationJobPositionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOrganizationJobPositionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOrganizationJobPositionsQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *      startDate: // value for 'startDate'
 *      endDate: // value for 'endDate'
 *      status: // value for 'status'
 *      title: // value for 'title'
 *   },
 * });
 */
export function useGetOrganizationJobPositionsQuery(
  baseOptions?: Apollo.QueryHookOptions<GetOrganizationJobPositionsQuery, GetOrganizationJobPositionsQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetOrganizationJobPositionsQuery, GetOrganizationJobPositionsQueryVariables>(
    GetOrganizationJobPositionsDocument,
    options,
  );
}
export function useGetOrganizationJobPositionsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetOrganizationJobPositionsQuery,
    GetOrganizationJobPositionsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetOrganizationJobPositionsQuery, GetOrganizationJobPositionsQueryVariables>(
    GetOrganizationJobPositionsDocument,
    options,
  );
}
export function useGetOrganizationJobPositionsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetOrganizationJobPositionsQuery, GetOrganizationJobPositionsQueryVariables>,
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<GetOrganizationJobPositionsQuery, GetOrganizationJobPositionsQueryVariables>(
    GetOrganizationJobPositionsDocument,
    options,
  );
}
export type GetOrganizationJobPositionsQueryHookResult = ReturnType<typeof useGetOrganizationJobPositionsQuery>;
export type GetOrganizationJobPositionsLazyQueryHookResult = ReturnType<typeof useGetOrganizationJobPositionsLazyQuery>;
export type GetOrganizationJobPositionsSuspenseQueryHookResult = ReturnType<
  typeof useGetOrganizationJobPositionsSuspenseQuery
>;
export type GetOrganizationJobPositionsQueryResult = Apollo.QueryResult<
  GetOrganizationJobPositionsQuery,
  GetOrganizationJobPositionsQueryVariables
>;
export const GetCertificateAndLicenseByIdDocument = gql`
  query GetCertificateAndLicenseById($id: NotEmptyID!) {
    admin {
      certificateAndLicense(id: $id) {
        certificateandlicenseofflineverificationmethod {
          id
          certificateFile {
            file
          }
        }
        certificateandlicenseonlineverificationmethod {
          certificateLink
          id
        }
        certifier
        expiredAt
        id
        issuedAt
        status
        title
        allowSelfVerification
      }
    }
  }
`;

/**
 * __useGetCertificateAndLicenseByIdQuery__
 *
 * To run a query within a React component, call `useGetCertificateAndLicenseByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCertificateAndLicenseByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCertificateAndLicenseByIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetCertificateAndLicenseByIdQuery(
  baseOptions: Apollo.QueryHookOptions<GetCertificateAndLicenseByIdQuery, GetCertificateAndLicenseByIdQueryVariables> &
    ({ variables: GetCertificateAndLicenseByIdQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetCertificateAndLicenseByIdQuery, GetCertificateAndLicenseByIdQueryVariables>(
    GetCertificateAndLicenseByIdDocument,
    options,
  );
}
export function useGetCertificateAndLicenseByIdLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetCertificateAndLicenseByIdQuery,
    GetCertificateAndLicenseByIdQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetCertificateAndLicenseByIdQuery, GetCertificateAndLicenseByIdQueryVariables>(
    GetCertificateAndLicenseByIdDocument,
    options,
  );
}
export function useGetCertificateAndLicenseByIdSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetCertificateAndLicenseByIdQuery, GetCertificateAndLicenseByIdQueryVariables>,
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<GetCertificateAndLicenseByIdQuery, GetCertificateAndLicenseByIdQueryVariables>(
    GetCertificateAndLicenseByIdDocument,
    options,
  );
}
export type GetCertificateAndLicenseByIdQueryHookResult = ReturnType<typeof useGetCertificateAndLicenseByIdQuery>;
export type GetCertificateAndLicenseByIdLazyQueryHookResult = ReturnType<
  typeof useGetCertificateAndLicenseByIdLazyQuery
>;
export type GetCertificateAndLicenseByIdSuspenseQueryHookResult = ReturnType<
  typeof useGetCertificateAndLicenseByIdSuspenseQuery
>;
export type GetCertificateAndLicenseByIdQueryResult = Apollo.QueryResult<
  GetCertificateAndLicenseByIdQuery,
  GetCertificateAndLicenseByIdQueryVariables
>;
export const GetEducationInfoByIdDocument = gql`
  query GetEducationInfoById($id: NotEmptyID!) {
    admin {
      education(id: $id) {
        allowSelfVerification
        communicationmethod {
          degreeFile {
            file
          }
          department
          email
          id
          person
          website
        }
        city {
          id
          name
          country {
            id
            name
          }
          region {
            id
            name
          }
        }
        createdAt
        degree
        end
        field {
          id
          name
        }
        id
        ieemethod {
          educationEvaluationDocument {
            file
          }
          id
        }
        start
        status
        allowSelfVerification
        updatedAt
        university {
          id
          name
        }
      }
    }
  }
`;

/**
 * __useGetEducationInfoByIdQuery__
 *
 * To run a query within a React component, call `useGetEducationInfoByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEducationInfoByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEducationInfoByIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetEducationInfoByIdQuery(
  baseOptions: Apollo.QueryHookOptions<GetEducationInfoByIdQuery, GetEducationInfoByIdQueryVariables> &
    ({ variables: GetEducationInfoByIdQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetEducationInfoByIdQuery, GetEducationInfoByIdQueryVariables>(
    GetEducationInfoByIdDocument,
    options,
  );
}
export function useGetEducationInfoByIdLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetEducationInfoByIdQuery, GetEducationInfoByIdQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetEducationInfoByIdQuery, GetEducationInfoByIdQueryVariables>(
    GetEducationInfoByIdDocument,
    options,
  );
}
export function useGetEducationInfoByIdSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetEducationInfoByIdQuery, GetEducationInfoByIdQueryVariables>,
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<GetEducationInfoByIdQuery, GetEducationInfoByIdQueryVariables>(
    GetEducationInfoByIdDocument,
    options,
  );
}
export type GetEducationInfoByIdQueryHookResult = ReturnType<typeof useGetEducationInfoByIdQuery>;
export type GetEducationInfoByIdLazyQueryHookResult = ReturnType<typeof useGetEducationInfoByIdLazyQuery>;
export type GetEducationInfoByIdSuspenseQueryHookResult = ReturnType<typeof useGetEducationInfoByIdSuspenseQuery>;
export type GetEducationInfoByIdQueryResult = Apollo.QueryResult<
  GetEducationInfoByIdQuery,
  GetEducationInfoByIdQueryVariables
>;
export const GetCanadaVisaDocument = gql`
  query GetCanadaVisa($id: Decimal!) {
    admin {
      jobSeekers(id: $id) {
        edges {
          node {
            canadaVisa {
              citizenshipDocument {
                file
              }
              id
              status
              nationality {
                name
                id
              }
            }
          }
        }
      }
    }
  }
`;

/**
 * __useGetCanadaVisaQuery__
 *
 * To run a query within a React component, call `useGetCanadaVisaQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCanadaVisaQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCanadaVisaQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetCanadaVisaQuery(
  baseOptions: Apollo.QueryHookOptions<GetCanadaVisaQuery, GetCanadaVisaQueryVariables> &
    ({ variables: GetCanadaVisaQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetCanadaVisaQuery, GetCanadaVisaQueryVariables>(GetCanadaVisaDocument, options);
}
export function useGetCanadaVisaLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetCanadaVisaQuery, GetCanadaVisaQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetCanadaVisaQuery, GetCanadaVisaQueryVariables>(GetCanadaVisaDocument, options);
}
export function useGetCanadaVisaSuspenseQuery(
  baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCanadaVisaQuery, GetCanadaVisaQueryVariables>,
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<GetCanadaVisaQuery, GetCanadaVisaQueryVariables>(GetCanadaVisaDocument, options);
}
export type GetCanadaVisaQueryHookResult = ReturnType<typeof useGetCanadaVisaQuery>;
export type GetCanadaVisaLazyQueryHookResult = ReturnType<typeof useGetCanadaVisaLazyQuery>;
export type GetCanadaVisaSuspenseQueryHookResult = ReturnType<typeof useGetCanadaVisaSuspenseQuery>;
export type GetCanadaVisaQueryResult = Apollo.QueryResult<GetCanadaVisaQuery, GetCanadaVisaQueryVariables>;
export const GetCertificateAndLicensesDocument = gql`
  query GetCertificateAndLicenses($id: Decimal!) {
    admin {
      jobSeekers(id: $id) {
        edges {
          node {
            certificateandlicenses {
              id
              expiredAt
              certifier
              issuedAt
              title
              status
            }
          }
        }
      }
    }
  }
`;

/**
 * __useGetCertificateAndLicensesQuery__
 *
 * To run a query within a React component, call `useGetCertificateAndLicensesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCertificateAndLicensesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCertificateAndLicensesQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetCertificateAndLicensesQuery(
  baseOptions: Apollo.QueryHookOptions<GetCertificateAndLicensesQuery, GetCertificateAndLicensesQueryVariables> &
    ({ variables: GetCertificateAndLicensesQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetCertificateAndLicensesQuery, GetCertificateAndLicensesQueryVariables>(
    GetCertificateAndLicensesDocument,
    options,
  );
}
export function useGetCertificateAndLicensesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetCertificateAndLicensesQuery, GetCertificateAndLicensesQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetCertificateAndLicensesQuery, GetCertificateAndLicensesQueryVariables>(
    GetCertificateAndLicensesDocument,
    options,
  );
}
export function useGetCertificateAndLicensesSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetCertificateAndLicensesQuery, GetCertificateAndLicensesQueryVariables>,
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<GetCertificateAndLicensesQuery, GetCertificateAndLicensesQueryVariables>(
    GetCertificateAndLicensesDocument,
    options,
  );
}
export type GetCertificateAndLicensesQueryHookResult = ReturnType<typeof useGetCertificateAndLicensesQuery>;
export type GetCertificateAndLicensesLazyQueryHookResult = ReturnType<typeof useGetCertificateAndLicensesLazyQuery>;
export type GetCertificateAndLicensesSuspenseQueryHookResult = ReturnType<
  typeof useGetCertificateAndLicensesSuspenseQuery
>;
export type GetCertificateAndLicensesQueryResult = Apollo.QueryResult<
  GetCertificateAndLicensesQuery,
  GetCertificateAndLicensesQueryVariables
>;
export const GetEducationsDocument = gql`
  query GetEducations($id: Decimal!) {
    admin {
      jobSeekers(id: $id) {
        edges {
          node {
            educations {
              id
              field {
                name
              }
              degree
              start
              end
              status
              university {
                name
              }
              city {
                name
                region {
                  name
                  country {
                    name
                  }
                }
              }
            }
          }
        }
      }
    }
  }
`;

/**
 * __useGetEducationsQuery__
 *
 * To run a query within a React component, call `useGetEducationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEducationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEducationsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetEducationsQuery(
  baseOptions: Apollo.QueryHookOptions<GetEducationsQuery, GetEducationsQueryVariables> &
    ({ variables: GetEducationsQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetEducationsQuery, GetEducationsQueryVariables>(GetEducationsDocument, options);
}
export function useGetEducationsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetEducationsQuery, GetEducationsQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetEducationsQuery, GetEducationsQueryVariables>(GetEducationsDocument, options);
}
export function useGetEducationsSuspenseQuery(
  baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetEducationsQuery, GetEducationsQueryVariables>,
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<GetEducationsQuery, GetEducationsQueryVariables>(GetEducationsDocument, options);
}
export type GetEducationsQueryHookResult = ReturnType<typeof useGetEducationsQuery>;
export type GetEducationsLazyQueryHookResult = ReturnType<typeof useGetEducationsLazyQuery>;
export type GetEducationsSuspenseQueryHookResult = ReturnType<typeof useGetEducationsSuspenseQuery>;
export type GetEducationsQueryResult = Apollo.QueryResult<GetEducationsQuery, GetEducationsQueryVariables>;
export const GetJobSeekerByIdDocument = gql`
  query GetJobSeekerById($id: Decimal!) {
    admin {
      jobSeekers(id: $id) {
        edges {
          node {
            id
            workexperiences {
              city {
                name
                id
                country {
                  id
                  name
                }
                region {
                  name
                  id
                }
              }
              end
              grade
              id
              jobTitle
              organization
              start
              status
              employerlettermethod {
                employerLetter {
                  file
                }
                employers {
                  email
                  id
                  name
                  phoneNumber
                  position
                }
                id
              }
              paystubsmethod {
                paystubs {
                  file
                }
                id
              }
            }
            certificateandlicenses {
              certifier
              expiredAt
              id
              issuedAt
              status
              title
              certificateandlicenseofflineverificationmethod {
                certificateFile {
                  file
                }
                id
              }
              certificateandlicenseonlineverificationmethod {
                certificateLink
                id
              }
            }
            languagecertificates {
              expiredAt
              id
              issuedAt
              language
              status
              test {
                title
                id
                languages
              }
              onlinemethod {
                certificateLink
                id
              }
              offlinemethod {
                certificateFile {
                  file
                }
                id
              }
            }
            cv {
              file
              modified
              aboutMe
            }
            educations {
              city {
                id
                country {
                  name
                  id
                }
                name
                region {
                  name
                  id
                }
              }
              degree
              end
              field {
                name
                id
              }
              start
              status
              university {
                name
                id
                websites
              }
              communicationmethod {
                degreeFile {
                  file
                }
                department
                email
                id
                person
                website
              }
              ieemethod {
                educationEvaluationDocument {
                  file
                }
                id
              }
              id
            }
            resume {
              file {
                file
              }
            }
            profile {
              avatar {
                file
              }
              contacts {
                value
                type
                id
              }
              fullBodyImage {
                file
              }
              score
              city {
                name
                country {
                  name
                  id
                }
                id
                region {
                  id
                  name
                }
              }
              jobLocationType
              jobType
              gender
              employmentStatus
              allowNotifications
              birthDate
              fluentLanguages
              industry {
                id
                title
              }
              nativeLanguage
              rawSkills
              skills {
                id
                title
              }
            }
            firstName
            lastName
            email
            canadaVisa {
              citizenshipDocument {
                file
              }
              id
              nationality {
                id
                name
              }
            }
          }
        }
      }
    }
  }
`;

/**
 * __useGetJobSeekerByIdQuery__
 *
 * To run a query within a React component, call `useGetJobSeekerByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetJobSeekerByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetJobSeekerByIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetJobSeekerByIdQuery(
  baseOptions: Apollo.QueryHookOptions<GetJobSeekerByIdQuery, GetJobSeekerByIdQueryVariables> &
    ({ variables: GetJobSeekerByIdQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetJobSeekerByIdQuery, GetJobSeekerByIdQueryVariables>(GetJobSeekerByIdDocument, options);
}
export function useGetJobSeekerByIdLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetJobSeekerByIdQuery, GetJobSeekerByIdQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetJobSeekerByIdQuery, GetJobSeekerByIdQueryVariables>(GetJobSeekerByIdDocument, options);
}
export function useGetJobSeekerByIdSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetJobSeekerByIdQuery, GetJobSeekerByIdQueryVariables>,
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<GetJobSeekerByIdQuery, GetJobSeekerByIdQueryVariables>(
    GetJobSeekerByIdDocument,
    options,
  );
}
export type GetJobSeekerByIdQueryHookResult = ReturnType<typeof useGetJobSeekerByIdQuery>;
export type GetJobSeekerByIdLazyQueryHookResult = ReturnType<typeof useGetJobSeekerByIdLazyQuery>;
export type GetJobSeekerByIdSuspenseQueryHookResult = ReturnType<typeof useGetJobSeekerByIdSuspenseQuery>;
export type GetJobSeekerByIdQueryResult = Apollo.QueryResult<GetJobSeekerByIdQuery, GetJobSeekerByIdQueryVariables>;
export const GetJobSeekersDocument = gql`
  query GetJobSeekers(
    $visaStatus: [AuthAccountCanadaVisaStatusChoices]
    $educationDegree: [AuthAccountEducationDegreeChoices]
    $email: String
    $fullName: String
    $id: Decimal
    $birthDateGte: Date
    $birthDateLte: Date
    $countryId: [ID]
    $cityId: [ID]
    $phoneNumber: String
    $employmentStatus: [AuthAccountProfileEmploymentStatusChoices]
    $gender: [AuthAccountProfileGenderChoices]
    $industryId: [ID]
    $interestedJobsId: [ID]
    $nativeLanguage: [AuthAccountProfileNativeLanguageChoices]
    $skillsId: [ID]
    $workexperiencesGrade: [AuthAccountWorkExperienceGradeChoices]
    $first: Int = 10
    $offset: Int = 0
    $jobType: [AuthAccountUserJobTypeChoices]
    $jobCitiesId: [ID]
    $fluentLanguages: [AuthAccountUserFluentLanguagesChoices]
    $referredJobPositionsId: [ID]
    $isAssessmentsDone: Boolean
    $orderBy: AuthAccountUserOrderByChoices = _DATE_JOINED
  ) {
    admin {
      jobSeekers(
        canadaVisa_Status_In: $visaStatus
        educations_Degree_In: $educationDegree
        email_Icontains: $email
        fullName: $fullName
        id: $id
        profile_BirthDate_Gte: $birthDateGte
        profile_BirthDate_Lte: $birthDateLte
        profile_City_Country_Id_In: $countryId
        profile_City_Id_In: $cityId
        profile_Contactable_Contacts_Value_Icontains: $phoneNumber
        profile_EmploymentStatus_In: $employmentStatus
        profile_Gender_In: $gender
        profile_Industry_Id_In: $industryId
        profile_InterestedJobs_Id_In: $interestedJobsId
        profile_NativeLanguage_In: $nativeLanguage
        profile_Skills_Id_In: $skillsId
        workexperiences_Grade_In: $workexperiencesGrade
        offset: $offset
        first: $first
        jobType: $jobType
        fluentLanguages: $fluentLanguages
        jobCities: $jobCitiesId
        referredJobPositions_Id_In: $referredJobPositionsId
        isAssessmentsDone: $isAssessmentsDone
        orderBy: $orderBy
      ) {
        edges {
          node {
            canadaVisa {
              status
              id
              nationality {
                name
              }
            }
            id
            email
            firstName
            lastName
            dateJoined
            profile {
              avatar {
                file
              }
              gender
              allowNotifications
              contacts {
                id
                type
                value
              }
              city {
                country {
                  name
                }
                name
              }
              industry {
                title
              }
            }
          }
        }
        totalCount
        pageInfo {
          endCursor
          hasNextPage
          hasPreviousPage
          startCursor
        }
      }
    }
  }
`;

/**
 * __useGetJobSeekersQuery__
 *
 * To run a query within a React component, call `useGetJobSeekersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetJobSeekersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetJobSeekersQuery({
 *   variables: {
 *      visaStatus: // value for 'visaStatus'
 *      educationDegree: // value for 'educationDegree'
 *      email: // value for 'email'
 *      fullName: // value for 'fullName'
 *      id: // value for 'id'
 *      birthDateGte: // value for 'birthDateGte'
 *      birthDateLte: // value for 'birthDateLte'
 *      countryId: // value for 'countryId'
 *      cityId: // value for 'cityId'
 *      phoneNumber: // value for 'phoneNumber'
 *      employmentStatus: // value for 'employmentStatus'
 *      gender: // value for 'gender'
 *      industryId: // value for 'industryId'
 *      interestedJobsId: // value for 'interestedJobsId'
 *      nativeLanguage: // value for 'nativeLanguage'
 *      skillsId: // value for 'skillsId'
 *      workexperiencesGrade: // value for 'workexperiencesGrade'
 *      first: // value for 'first'
 *      offset: // value for 'offset'
 *      jobType: // value for 'jobType'
 *      jobCitiesId: // value for 'jobCitiesId'
 *      fluentLanguages: // value for 'fluentLanguages'
 *      referredJobPositionsId: // value for 'referredJobPositionsId'
 *      isAssessmentsDone: // value for 'isAssessmentsDone'
 *      orderBy: // value for 'orderBy'
 *   },
 * });
 */
export function useGetJobSeekersQuery(
  baseOptions?: Apollo.QueryHookOptions<GetJobSeekersQuery, GetJobSeekersQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetJobSeekersQuery, GetJobSeekersQueryVariables>(GetJobSeekersDocument, options);
}
export function useGetJobSeekersLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetJobSeekersQuery, GetJobSeekersQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetJobSeekersQuery, GetJobSeekersQueryVariables>(GetJobSeekersDocument, options);
}
export function useGetJobSeekersSuspenseQuery(
  baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetJobSeekersQuery, GetJobSeekersQueryVariables>,
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<GetJobSeekersQuery, GetJobSeekersQueryVariables>(GetJobSeekersDocument, options);
}
export type GetJobSeekersQueryHookResult = ReturnType<typeof useGetJobSeekersQuery>;
export type GetJobSeekersLazyQueryHookResult = ReturnType<typeof useGetJobSeekersLazyQuery>;
export type GetJobSeekersSuspenseQueryHookResult = ReturnType<typeof useGetJobSeekersSuspenseQuery>;
export type GetJobSeekersQueryResult = Apollo.QueryResult<GetJobSeekersQuery, GetJobSeekersQueryVariables>;
export const GetJobSeekersAssessmentsDocument = gql`
  query GetJobSeekersAssessments($id: Decimal!) {
    admin {
      jobSeekers(id: $id) {
        edges {
          node {
            assessments {
              description
              id
              remainingQuestions
              results {
                evaluation {
                  negativePoints
                  positivePoints
                  score
                  scoreReasoning
                  scoreValue
                  userFeedback
                }
                question {
                  status
                  text
                }
              }
              skill {
                title
                description
              }
              status
              title
              totalEstimatedTime
              totalQuestions
            }
          }
        }
      }
    }
  }
`;

/**
 * __useGetJobSeekersAssessmentsQuery__
 *
 * To run a query within a React component, call `useGetJobSeekersAssessmentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetJobSeekersAssessmentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetJobSeekersAssessmentsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetJobSeekersAssessmentsQuery(
  baseOptions: Apollo.QueryHookOptions<GetJobSeekersAssessmentsQuery, GetJobSeekersAssessmentsQueryVariables> &
    ({ variables: GetJobSeekersAssessmentsQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetJobSeekersAssessmentsQuery, GetJobSeekersAssessmentsQueryVariables>(
    GetJobSeekersAssessmentsDocument,
    options,
  );
}
export function useGetJobSeekersAssessmentsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetJobSeekersAssessmentsQuery, GetJobSeekersAssessmentsQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetJobSeekersAssessmentsQuery, GetJobSeekersAssessmentsQueryVariables>(
    GetJobSeekersAssessmentsDocument,
    options,
  );
}
export function useGetJobSeekersAssessmentsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetJobSeekersAssessmentsQuery, GetJobSeekersAssessmentsQueryVariables>,
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<GetJobSeekersAssessmentsQuery, GetJobSeekersAssessmentsQueryVariables>(
    GetJobSeekersAssessmentsDocument,
    options,
  );
}
export type GetJobSeekersAssessmentsQueryHookResult = ReturnType<typeof useGetJobSeekersAssessmentsQuery>;
export type GetJobSeekersAssessmentsLazyQueryHookResult = ReturnType<typeof useGetJobSeekersAssessmentsLazyQuery>;
export type GetJobSeekersAssessmentsSuspenseQueryHookResult = ReturnType<
  typeof useGetJobSeekersAssessmentsSuspenseQuery
>;
export type GetJobSeekersAssessmentsQueryResult = Apollo.QueryResult<
  GetJobSeekersAssessmentsQuery,
  GetJobSeekersAssessmentsQueryVariables
>;
export const GetJobSeekersInterestedJobsDocument = gql`
  query GetJobSeekersInterestedJobs($id: Decimal!) {
    admin {
      jobSeekers(id: $id) {
        edges {
          node {
            profile {
              interestedJobs {
                edges {
                  node {
                    requireAppearanceData
                    title
                    industries {
                      edges {
                        node {
                          title
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
`;

/**
 * __useGetJobSeekersInterestedJobsQuery__
 *
 * To run a query within a React component, call `useGetJobSeekersInterestedJobsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetJobSeekersInterestedJobsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetJobSeekersInterestedJobsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetJobSeekersInterestedJobsQuery(
  baseOptions: Apollo.QueryHookOptions<GetJobSeekersInterestedJobsQuery, GetJobSeekersInterestedJobsQueryVariables> &
    ({ variables: GetJobSeekersInterestedJobsQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetJobSeekersInterestedJobsQuery, GetJobSeekersInterestedJobsQueryVariables>(
    GetJobSeekersInterestedJobsDocument,
    options,
  );
}
export function useGetJobSeekersInterestedJobsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetJobSeekersInterestedJobsQuery,
    GetJobSeekersInterestedJobsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetJobSeekersInterestedJobsQuery, GetJobSeekersInterestedJobsQueryVariables>(
    GetJobSeekersInterestedJobsDocument,
    options,
  );
}
export function useGetJobSeekersInterestedJobsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetJobSeekersInterestedJobsQuery, GetJobSeekersInterestedJobsQueryVariables>,
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<GetJobSeekersInterestedJobsQuery, GetJobSeekersInterestedJobsQueryVariables>(
    GetJobSeekersInterestedJobsDocument,
    options,
  );
}
export type GetJobSeekersInterestedJobsQueryHookResult = ReturnType<typeof useGetJobSeekersInterestedJobsQuery>;
export type GetJobSeekersInterestedJobsLazyQueryHookResult = ReturnType<typeof useGetJobSeekersInterestedJobsLazyQuery>;
export type GetJobSeekersInterestedJobsSuspenseQueryHookResult = ReturnType<
  typeof useGetJobSeekersInterestedJobsSuspenseQuery
>;
export type GetJobSeekersInterestedJobsQueryResult = Apollo.QueryResult<
  GetJobSeekersInterestedJobsQuery,
  GetJobSeekersInterestedJobsQueryVariables
>;
export const GetLanguagesCertificatesDocument = gql`
  query GetLanguagesCertificates($id: Decimal!) {
    admin {
      jobSeekers(id: $id) {
        edges {
          node {
            languagecertificates {
              allowSelfVerification
              expiredAt
              id
              issuedAt
              language
              status
              test {
                title
                id
              }
              values {
                id
                skill {
                  id
                  skillName
                  slug
                }
                value
              }
            }
          }
        }
      }
    }
  }
`;

/**
 * __useGetLanguagesCertificatesQuery__
 *
 * To run a query within a React component, call `useGetLanguagesCertificatesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLanguagesCertificatesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLanguagesCertificatesQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetLanguagesCertificatesQuery(
  baseOptions: Apollo.QueryHookOptions<GetLanguagesCertificatesQuery, GetLanguagesCertificatesQueryVariables> &
    ({ variables: GetLanguagesCertificatesQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetLanguagesCertificatesQuery, GetLanguagesCertificatesQueryVariables>(
    GetLanguagesCertificatesDocument,
    options,
  );
}
export function useGetLanguagesCertificatesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetLanguagesCertificatesQuery, GetLanguagesCertificatesQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetLanguagesCertificatesQuery, GetLanguagesCertificatesQueryVariables>(
    GetLanguagesCertificatesDocument,
    options,
  );
}
export function useGetLanguagesCertificatesSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetLanguagesCertificatesQuery, GetLanguagesCertificatesQueryVariables>,
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<GetLanguagesCertificatesQuery, GetLanguagesCertificatesQueryVariables>(
    GetLanguagesCertificatesDocument,
    options,
  );
}
export type GetLanguagesCertificatesQueryHookResult = ReturnType<typeof useGetLanguagesCertificatesQuery>;
export type GetLanguagesCertificatesLazyQueryHookResult = ReturnType<typeof useGetLanguagesCertificatesLazyQuery>;
export type GetLanguagesCertificatesSuspenseQueryHookResult = ReturnType<
  typeof useGetLanguagesCertificatesSuspenseQuery
>;
export type GetLanguagesCertificatesQueryResult = Apollo.QueryResult<
  GetLanguagesCertificatesQuery,
  GetLanguagesCertificatesQueryVariables
>;
export const GetNativeLanguagesDocument = gql`
  query GetNativeLanguages($id: Decimal!) {
    admin {
      jobSeekers(id: $id) {
        edges {
          node {
            profile {
              fluentLanguages
              nativeLanguage
            }
          }
        }
      }
    }
  }
`;

/**
 * __useGetNativeLanguagesQuery__
 *
 * To run a query within a React component, call `useGetNativeLanguagesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetNativeLanguagesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetNativeLanguagesQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetNativeLanguagesQuery(
  baseOptions: Apollo.QueryHookOptions<GetNativeLanguagesQuery, GetNativeLanguagesQueryVariables> &
    ({ variables: GetNativeLanguagesQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetNativeLanguagesQuery, GetNativeLanguagesQueryVariables>(
    GetNativeLanguagesDocument,
    options,
  );
}
export function useGetNativeLanguagesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetNativeLanguagesQuery, GetNativeLanguagesQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetNativeLanguagesQuery, GetNativeLanguagesQueryVariables>(
    GetNativeLanguagesDocument,
    options,
  );
}
export function useGetNativeLanguagesSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetNativeLanguagesQuery, GetNativeLanguagesQueryVariables>,
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<GetNativeLanguagesQuery, GetNativeLanguagesQueryVariables>(
    GetNativeLanguagesDocument,
    options,
  );
}
export type GetNativeLanguagesQueryHookResult = ReturnType<typeof useGetNativeLanguagesQuery>;
export type GetNativeLanguagesLazyQueryHookResult = ReturnType<typeof useGetNativeLanguagesLazyQuery>;
export type GetNativeLanguagesSuspenseQueryHookResult = ReturnType<typeof useGetNativeLanguagesSuspenseQuery>;
export type GetNativeLanguagesQueryResult = Apollo.QueryResult<
  GetNativeLanguagesQuery,
  GetNativeLanguagesQueryVariables
>;
export const GetProfileIndustryDocument = gql`
  query GetProfileIndustry($id: Decimal!) {
    admin {
      jobSeekers(id: $id) {
        edges {
          node {
            profile {
              industry {
                id
                title
              }
            }
          }
        }
      }
    }
  }
`;

/**
 * __useGetProfileIndustryQuery__
 *
 * To run a query within a React component, call `useGetProfileIndustryQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProfileIndustryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProfileIndustryQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetProfileIndustryQuery(
  baseOptions: Apollo.QueryHookOptions<GetProfileIndustryQuery, GetProfileIndustryQueryVariables> &
    ({ variables: GetProfileIndustryQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetProfileIndustryQuery, GetProfileIndustryQueryVariables>(
    GetProfileIndustryDocument,
    options,
  );
}
export function useGetProfileIndustryLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetProfileIndustryQuery, GetProfileIndustryQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetProfileIndustryQuery, GetProfileIndustryQueryVariables>(
    GetProfileIndustryDocument,
    options,
  );
}
export function useGetProfileIndustrySuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetProfileIndustryQuery, GetProfileIndustryQueryVariables>,
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<GetProfileIndustryQuery, GetProfileIndustryQueryVariables>(
    GetProfileIndustryDocument,
    options,
  );
}
export type GetProfileIndustryQueryHookResult = ReturnType<typeof useGetProfileIndustryQuery>;
export type GetProfileIndustryLazyQueryHookResult = ReturnType<typeof useGetProfileIndustryLazyQuery>;
export type GetProfileIndustrySuspenseQueryHookResult = ReturnType<typeof useGetProfileIndustrySuspenseQuery>;
export type GetProfileIndustryQueryResult = Apollo.QueryResult<
  GetProfileIndustryQuery,
  GetProfileIndustryQueryVariables
>;
export const GetUserSkillsDocument = gql`
  query GetUserSkills($id: Decimal!) {
    admin {
      jobSeekers(id: $id) {
        edges {
          node {
            profile {
              rawSkills
              skills {
                id
                title
              }
            }
          }
        }
      }
    }
  }
`;

/**
 * __useGetUserSkillsQuery__
 *
 * To run a query within a React component, call `useGetUserSkillsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserSkillsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserSkillsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetUserSkillsQuery(
  baseOptions: Apollo.QueryHookOptions<GetUserSkillsQuery, GetUserSkillsQueryVariables> &
    ({ variables: GetUserSkillsQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetUserSkillsQuery, GetUserSkillsQueryVariables>(GetUserSkillsDocument, options);
}
export function useGetUserSkillsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetUserSkillsQuery, GetUserSkillsQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetUserSkillsQuery, GetUserSkillsQueryVariables>(GetUserSkillsDocument, options);
}
export function useGetUserSkillsSuspenseQuery(
  baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetUserSkillsQuery, GetUserSkillsQueryVariables>,
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<GetUserSkillsQuery, GetUserSkillsQueryVariables>(GetUserSkillsDocument, options);
}
export type GetUserSkillsQueryHookResult = ReturnType<typeof useGetUserSkillsQuery>;
export type GetUserSkillsLazyQueryHookResult = ReturnType<typeof useGetUserSkillsLazyQuery>;
export type GetUserSkillsSuspenseQueryHookResult = ReturnType<typeof useGetUserSkillsSuspenseQuery>;
export type GetUserSkillsQueryResult = Apollo.QueryResult<GetUserSkillsQuery, GetUserSkillsQueryVariables>;
export const GetWorkExperiencesDocument = gql`
  query GetWorkExperiences($id: Decimal!) {
    admin {
      jobSeekers(id: $id) {
        edges {
          node {
            workexperiences {
              id
              grade
              city {
                country {
                  name
                  id
                }
                id
                name
                region {
                  name
                }
              }
              end
              jobTitle
              organization
              start
              status
            }
          }
        }
      }
    }
  }
`;

/**
 * __useGetWorkExperiencesQuery__
 *
 * To run a query within a React component, call `useGetWorkExperiencesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetWorkExperiencesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetWorkExperiencesQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetWorkExperiencesQuery(
  baseOptions: Apollo.QueryHookOptions<GetWorkExperiencesQuery, GetWorkExperiencesQueryVariables> &
    ({ variables: GetWorkExperiencesQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetWorkExperiencesQuery, GetWorkExperiencesQueryVariables>(
    GetWorkExperiencesDocument,
    options,
  );
}
export function useGetWorkExperiencesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetWorkExperiencesQuery, GetWorkExperiencesQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetWorkExperiencesQuery, GetWorkExperiencesQueryVariables>(
    GetWorkExperiencesDocument,
    options,
  );
}
export function useGetWorkExperiencesSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetWorkExperiencesQuery, GetWorkExperiencesQueryVariables>,
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<GetWorkExperiencesQuery, GetWorkExperiencesQueryVariables>(
    GetWorkExperiencesDocument,
    options,
  );
}
export type GetWorkExperiencesQueryHookResult = ReturnType<typeof useGetWorkExperiencesQuery>;
export type GetWorkExperiencesLazyQueryHookResult = ReturnType<typeof useGetWorkExperiencesLazyQuery>;
export type GetWorkExperiencesSuspenseQueryHookResult = ReturnType<typeof useGetWorkExperiencesSuspenseQuery>;
export type GetWorkExperiencesQueryResult = Apollo.QueryResult<
  GetWorkExperiencesQuery,
  GetWorkExperiencesQueryVariables
>;
export const GetJobSuggestionsDocument = gql`
  query getJobSuggestions($jobPositionId: ID!) {
    admin {
      jobSuggestionResult(jobPosition_Id: $jobPositionId) {
        edges {
          node {
            id
            items(first: 100) {
              edges {
                node {
                  id
                  user {
                    email
                    firstName
                    lastName
                    profile {
                      avatar {
                        file
                      }
                      score
                    }
                    resume {
                      file {
                        file
                      }
                    }
                    workexperiences {
                      jobTitle
                      organization
                    }
                  }
                  jobPositionAssignment {
                    id
                    status
                    createdAt
                  }
                  matchExplanation
                  matchScore
                  recommendation
                  seniorityMatch
                  skillMatch
                  strengths
                  considerations
                  confidenceLevel
                  experienceMatch
                  isAssigned
                }
              }
            }
          }
        }
      }
    }
  }
`;

/**
 * __useGetJobSuggestionsQuery__
 *
 * To run a query within a React component, call `useGetJobSuggestionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetJobSuggestionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetJobSuggestionsQuery({
 *   variables: {
 *      jobPositionId: // value for 'jobPositionId'
 *   },
 * });
 */
export function useGetJobSuggestionsQuery(
  baseOptions: Apollo.QueryHookOptions<GetJobSuggestionsQuery, GetJobSuggestionsQueryVariables> &
    ({ variables: GetJobSuggestionsQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetJobSuggestionsQuery, GetJobSuggestionsQueryVariables>(GetJobSuggestionsDocument, options);
}
export function useGetJobSuggestionsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetJobSuggestionsQuery, GetJobSuggestionsQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetJobSuggestionsQuery, GetJobSuggestionsQueryVariables>(
    GetJobSuggestionsDocument,
    options,
  );
}
export function useGetJobSuggestionsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetJobSuggestionsQuery, GetJobSuggestionsQueryVariables>,
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<GetJobSuggestionsQuery, GetJobSuggestionsQueryVariables>(
    GetJobSuggestionsDocument,
    options,
  );
}
export type GetJobSuggestionsQueryHookResult = ReturnType<typeof useGetJobSuggestionsQuery>;
export type GetJobSuggestionsLazyQueryHookResult = ReturnType<typeof useGetJobSuggestionsLazyQuery>;
export type GetJobSuggestionsSuspenseQueryHookResult = ReturnType<typeof useGetJobSuggestionsSuspenseQuery>;
export type GetJobSuggestionsQueryResult = Apollo.QueryResult<GetJobSuggestionsQuery, GetJobSuggestionsQueryVariables>;
export const GetLanguageCertificateByIdDocument = gql`
  query GetLanguageCertificateById($id: NotEmptyID!) {
    admin {
      languageCertificate(id: $id) {
        allowSelfVerification
        expiredAt
        id
        issuedAt
        language
        status
        test {
          id
          title
          skills {
            edges {
              node {
                skillName
                id
                slug
              }
            }
          }
        }
        values {
          value
          skill {
            id
            skillName
            slug
          }
          id
        }
        offlinemethod {
          certificateFile {
            file
          }
        }
        onlinemethod {
          certificateLink
        }
      }
    }
  }
`;

/**
 * __useGetLanguageCertificateByIdQuery__
 *
 * To run a query within a React component, call `useGetLanguageCertificateByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLanguageCertificateByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLanguageCertificateByIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetLanguageCertificateByIdQuery(
  baseOptions: Apollo.QueryHookOptions<GetLanguageCertificateByIdQuery, GetLanguageCertificateByIdQueryVariables> &
    ({ variables: GetLanguageCertificateByIdQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetLanguageCertificateByIdQuery, GetLanguageCertificateByIdQueryVariables>(
    GetLanguageCertificateByIdDocument,
    options,
  );
}
export function useGetLanguageCertificateByIdLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetLanguageCertificateByIdQuery, GetLanguageCertificateByIdQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetLanguageCertificateByIdQuery, GetLanguageCertificateByIdQueryVariables>(
    GetLanguageCertificateByIdDocument,
    options,
  );
}
export function useGetLanguageCertificateByIdSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetLanguageCertificateByIdQuery, GetLanguageCertificateByIdQueryVariables>,
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<GetLanguageCertificateByIdQuery, GetLanguageCertificateByIdQueryVariables>(
    GetLanguageCertificateByIdDocument,
    options,
  );
}
export type GetLanguageCertificateByIdQueryHookResult = ReturnType<typeof useGetLanguageCertificateByIdQuery>;
export type GetLanguageCertificateByIdLazyQueryHookResult = ReturnType<typeof useGetLanguageCertificateByIdLazyQuery>;
export type GetLanguageCertificateByIdSuspenseQueryHookResult = ReturnType<
  typeof useGetLanguageCertificateByIdSuspenseQuery
>;
export type GetLanguageCertificateByIdQueryResult = Apollo.QueryResult<
  GetLanguageCertificateByIdQuery,
  GetLanguageCertificateByIdQueryVariables
>;
export const GetUserInfoForLayoutDocument = gql`
  query GetUserInfoForLayout {
    me {
      email
      firstName
      lastName
      profile {
        avatar {
          file
        }
      }
    }
  }
`;

/**
 * __useGetUserInfoForLayoutQuery__
 *
 * To run a query within a React component, call `useGetUserInfoForLayoutQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserInfoForLayoutQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserInfoForLayoutQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetUserInfoForLayoutQuery(
  baseOptions?: Apollo.QueryHookOptions<GetUserInfoForLayoutQuery, GetUserInfoForLayoutQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetUserInfoForLayoutQuery, GetUserInfoForLayoutQueryVariables>(
    GetUserInfoForLayoutDocument,
    options,
  );
}
export function useGetUserInfoForLayoutLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetUserInfoForLayoutQuery, GetUserInfoForLayoutQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetUserInfoForLayoutQuery, GetUserInfoForLayoutQueryVariables>(
    GetUserInfoForLayoutDocument,
    options,
  );
}
export function useGetUserInfoForLayoutSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetUserInfoForLayoutQuery, GetUserInfoForLayoutQueryVariables>,
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<GetUserInfoForLayoutQuery, GetUserInfoForLayoutQueryVariables>(
    GetUserInfoForLayoutDocument,
    options,
  );
}
export type GetUserInfoForLayoutQueryHookResult = ReturnType<typeof useGetUserInfoForLayoutQuery>;
export type GetUserInfoForLayoutLazyQueryHookResult = ReturnType<typeof useGetUserInfoForLayoutLazyQuery>;
export type GetUserInfoForLayoutSuspenseQueryHookResult = ReturnType<typeof useGetUserInfoForLayoutSuspenseQuery>;
export type GetUserInfoForLayoutQueryResult = Apollo.QueryResult<
  GetUserInfoForLayoutQuery,
  GetUserInfoForLayoutQueryVariables
>;
export const GetPlatformMessagesByIdDocument = gql`
  query GetPlatformMessagesById($id: ID!) {
    admin {
      organizations(id: $id) {
        edges {
          node {
            platformMessages {
              edges {
                node {
                  title
                  text
                  source
                  readAt
                  created
                  id
                  attachments {
                    id
                    file {
                      file
                    }
                    text
                    courseResult {
                      status
                      course {
                        name
                        logo
                      }
                    }
                    course {
                      name
                      logo
                    }
                    attachmentType
                  }
                }
              }
            }
          }
        }
      }
    }
  }
`;

/**
 * __useGetPlatformMessagesByIdQuery__
 *
 * To run a query within a React component, call `useGetPlatformMessagesByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPlatformMessagesByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPlatformMessagesByIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetPlatformMessagesByIdQuery(
  baseOptions: Apollo.QueryHookOptions<GetPlatformMessagesByIdQuery, GetPlatformMessagesByIdQueryVariables> &
    ({ variables: GetPlatformMessagesByIdQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetPlatformMessagesByIdQuery, GetPlatformMessagesByIdQueryVariables>(
    GetPlatformMessagesByIdDocument,
    options,
  );
}
export function useGetPlatformMessagesByIdLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetPlatformMessagesByIdQuery, GetPlatformMessagesByIdQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetPlatformMessagesByIdQuery, GetPlatformMessagesByIdQueryVariables>(
    GetPlatformMessagesByIdDocument,
    options,
  );
}
export function useGetPlatformMessagesByIdSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetPlatformMessagesByIdQuery, GetPlatformMessagesByIdQueryVariables>,
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<GetPlatformMessagesByIdQuery, GetPlatformMessagesByIdQueryVariables>(
    GetPlatformMessagesByIdDocument,
    options,
  );
}
export type GetPlatformMessagesByIdQueryHookResult = ReturnType<typeof useGetPlatformMessagesByIdQuery>;
export type GetPlatformMessagesByIdLazyQueryHookResult = ReturnType<typeof useGetPlatformMessagesByIdLazyQuery>;
export type GetPlatformMessagesByIdSuspenseQueryHookResult = ReturnType<typeof useGetPlatformMessagesByIdSuspenseQuery>;
export type GetPlatformMessagesByIdQueryResult = Apollo.QueryResult<
  GetPlatformMessagesByIdQuery,
  GetPlatformMessagesByIdQueryVariables
>;
export const GetEmployeeStatisticsDocument = gql`
  query getEmployeeStatistics($organizationId: ID!) {
    admin {
      organizations(id: $organizationId) {
        edges {
          node {
            employeeCooperationStatusCounts {
              active
              awaiting
              finished
              fired
              resigned
              suspended
              resigned
            }
            jobPositionLocationTypeCounts {
              globalCount
              hybridCount
              limitedAreaCount
              onTheRoadCount
              preciseLocationCount
              remoteCount
            }
          }
        }
      }
    }
  }
`;

/**
 * __useGetEmployeeStatisticsQuery__
 *
 * To run a query within a React component, call `useGetEmployeeStatisticsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEmployeeStatisticsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEmployeeStatisticsQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *   },
 * });
 */
export function useGetEmployeeStatisticsQuery(
  baseOptions: Apollo.QueryHookOptions<GetEmployeeStatisticsQuery, GetEmployeeStatisticsQueryVariables> &
    ({ variables: GetEmployeeStatisticsQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetEmployeeStatisticsQuery, GetEmployeeStatisticsQueryVariables>(
    GetEmployeeStatisticsDocument,
    options,
  );
}
export function useGetEmployeeStatisticsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetEmployeeStatisticsQuery, GetEmployeeStatisticsQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetEmployeeStatisticsQuery, GetEmployeeStatisticsQueryVariables>(
    GetEmployeeStatisticsDocument,
    options,
  );
}
export function useGetEmployeeStatisticsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetEmployeeStatisticsQuery, GetEmployeeStatisticsQueryVariables>,
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<GetEmployeeStatisticsQuery, GetEmployeeStatisticsQueryVariables>(
    GetEmployeeStatisticsDocument,
    options,
  );
}
export type GetEmployeeStatisticsQueryHookResult = ReturnType<typeof useGetEmployeeStatisticsQuery>;
export type GetEmployeeStatisticsLazyQueryHookResult = ReturnType<typeof useGetEmployeeStatisticsLazyQuery>;
export type GetEmployeeStatisticsSuspenseQueryHookResult = ReturnType<typeof useGetEmployeeStatisticsSuspenseQuery>;
export type GetEmployeeStatisticsQueryResult = Apollo.QueryResult<
  GetEmployeeStatisticsQuery,
  GetEmployeeStatisticsQueryVariables
>;
export const GetOrganizationDetailDocument = gql`
  query GetOrganizationDetail($id: ID!) {
    admin {
      organizations(id: $id) {
        edges {
          node {
            id
            logo {
              file
            }
            name
            status
            businessType
            employeeCooperationStatusCounts {
              suspended
              resigned
              fired
              finished
              awaiting
              active
            }
          }
        }
      }
    }
  }
`;

/**
 * __useGetOrganizationDetailQuery__
 *
 * To run a query within a React component, call `useGetOrganizationDetailQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOrganizationDetailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOrganizationDetailQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetOrganizationDetailQuery(
  baseOptions: Apollo.QueryHookOptions<GetOrganizationDetailQuery, GetOrganizationDetailQueryVariables> &
    ({ variables: GetOrganizationDetailQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetOrganizationDetailQuery, GetOrganizationDetailQueryVariables>(
    GetOrganizationDetailDocument,
    options,
  );
}
export function useGetOrganizationDetailLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetOrganizationDetailQuery, GetOrganizationDetailQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetOrganizationDetailQuery, GetOrganizationDetailQueryVariables>(
    GetOrganizationDetailDocument,
    options,
  );
}
export function useGetOrganizationDetailSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetOrganizationDetailQuery, GetOrganizationDetailQueryVariables>,
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<GetOrganizationDetailQuery, GetOrganizationDetailQueryVariables>(
    GetOrganizationDetailDocument,
    options,
  );
}
export type GetOrganizationDetailQueryHookResult = ReturnType<typeof useGetOrganizationDetailQuery>;
export type GetOrganizationDetailLazyQueryHookResult = ReturnType<typeof useGetOrganizationDetailLazyQuery>;
export type GetOrganizationDetailSuspenseQueryHookResult = ReturnType<typeof useGetOrganizationDetailSuspenseQuery>;
export type GetOrganizationDetailQueryResult = Apollo.QueryResult<
  GetOrganizationDetailQuery,
  GetOrganizationDetailQueryVariables
>;
export const GetOrganizationEmployeesDocument = gql`
  query getOrganizationEmployees(
    $organizationId: ID!
    $first: Int
    $locationType: AuthAccountOrganizationJobPositionLocationTypeChoices
    $title: String
    $status: AuthAccountOrganizationEmployeeCooperationStatusChoices
  ) {
    admin {
      organizations(id: $organizationId) {
        edges {
          node {
            organizationEmployees(
              first: $first
              cooperations_Status: $status
              cooperations_JobPositionAssignment_JobPosition_LocationType: $locationType
              cooperations_JobPositionAssignment_JobPosition_Fields_Name_Icontains: $title
            ) {
              edges {
                node {
                  cooperation {
                    id
                    status
                    startAt
                    jobPosition {
                      title
                      locationType
                      contractType
                    }
                  }
                  employee {
                    email
                    firstName
                    lastName
                    profile {
                      score
                      avatar {
                        file
                      }
                      contacts {
                        id
                        value
                        type
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
`;

/**
 * __useGetOrganizationEmployeesQuery__
 *
 * To run a query within a React component, call `useGetOrganizationEmployeesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOrganizationEmployeesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOrganizationEmployeesQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *      first: // value for 'first'
 *      locationType: // value for 'locationType'
 *      title: // value for 'title'
 *      status: // value for 'status'
 *   },
 * });
 */
export function useGetOrganizationEmployeesQuery(
  baseOptions: Apollo.QueryHookOptions<GetOrganizationEmployeesQuery, GetOrganizationEmployeesQueryVariables> &
    ({ variables: GetOrganizationEmployeesQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetOrganizationEmployeesQuery, GetOrganizationEmployeesQueryVariables>(
    GetOrganizationEmployeesDocument,
    options,
  );
}
export function useGetOrganizationEmployeesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetOrganizationEmployeesQuery, GetOrganizationEmployeesQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetOrganizationEmployeesQuery, GetOrganizationEmployeesQueryVariables>(
    GetOrganizationEmployeesDocument,
    options,
  );
}
export function useGetOrganizationEmployeesSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetOrganizationEmployeesQuery, GetOrganizationEmployeesQueryVariables>,
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<GetOrganizationEmployeesQuery, GetOrganizationEmployeesQueryVariables>(
    GetOrganizationEmployeesDocument,
    options,
  );
}
export type GetOrganizationEmployeesQueryHookResult = ReturnType<typeof useGetOrganizationEmployeesQuery>;
export type GetOrganizationEmployeesLazyQueryHookResult = ReturnType<typeof useGetOrganizationEmployeesLazyQuery>;
export type GetOrganizationEmployeesSuspenseQueryHookResult = ReturnType<
  typeof useGetOrganizationEmployeesSuspenseQuery
>;
export type GetOrganizationEmployeesQueryResult = Apollo.QueryResult<
  GetOrganizationEmployeesQuery,
  GetOrganizationEmployeesQueryVariables
>;
export const GetOrganizationInformationAndCredentialsDocument = gql`
  query GetOrganizationInformationAndCredentials($id: ID!) {
    admin {
      organizations(id: $id) {
        edges {
          node {
            id
            name
            status
            shortName
            industry {
              title
              id
            }
            email
            size
            dnstxtrecordmethod {
              id
              code
            }
            communicateorganizationmethod {
              email
              id
              phonenumber
            }
            nationalNumber
            businessType
            type
            establishedAt
            about
            contacts {
              value
              type
              id
            }
            uploadfiletowebsitemethod {
              fileName
              id
            }
            uploadcompanycertificatemethod {
              id
              organizationCertificateFile {
                file
              }
            }
            city {
              id
            }
          }
        }
      }
    }
  }
`;

/**
 * __useGetOrganizationInformationAndCredentialsQuery__
 *
 * To run a query within a React component, call `useGetOrganizationInformationAndCredentialsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOrganizationInformationAndCredentialsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOrganizationInformationAndCredentialsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetOrganizationInformationAndCredentialsQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetOrganizationInformationAndCredentialsQuery,
    GetOrganizationInformationAndCredentialsQueryVariables
  > &
    ({ variables: GetOrganizationInformationAndCredentialsQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetOrganizationInformationAndCredentialsQuery,
    GetOrganizationInformationAndCredentialsQueryVariables
  >(GetOrganizationInformationAndCredentialsDocument, options);
}
export function useGetOrganizationInformationAndCredentialsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetOrganizationInformationAndCredentialsQuery,
    GetOrganizationInformationAndCredentialsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetOrganizationInformationAndCredentialsQuery,
    GetOrganizationInformationAndCredentialsQueryVariables
  >(GetOrganizationInformationAndCredentialsDocument, options);
}
export function useGetOrganizationInformationAndCredentialsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetOrganizationInformationAndCredentialsQuery,
        GetOrganizationInformationAndCredentialsQueryVariables
      >,
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GetOrganizationInformationAndCredentialsQuery,
    GetOrganizationInformationAndCredentialsQueryVariables
  >(GetOrganizationInformationAndCredentialsDocument, options);
}
export type GetOrganizationInformationAndCredentialsQueryHookResult = ReturnType<
  typeof useGetOrganizationInformationAndCredentialsQuery
>;
export type GetOrganizationInformationAndCredentialsLazyQueryHookResult = ReturnType<
  typeof useGetOrganizationInformationAndCredentialsLazyQuery
>;
export type GetOrganizationInformationAndCredentialsSuspenseQueryHookResult = ReturnType<
  typeof useGetOrganizationInformationAndCredentialsSuspenseQuery
>;
export type GetOrganizationInformationAndCredentialsQueryResult = Apollo.QueryResult<
  GetOrganizationInformationAndCredentialsQuery,
  GetOrganizationInformationAndCredentialsQueryVariables
>;
export const GetOrganizationsDocument = gql`
  query GetOrganizations(
    $industry: ID
    $name: String
    $shortName: String
    $businessType: AuthAccountOrganizationBusinessTypeChoices
    $status: AuthAccountOrganizationStatusChoices
    $sizeGte: AuthAccountOrganizationSizeChoices
    $phone: String
    $email: String
    $jobPositionId: String
    $offset: Int = 0
    $first: Int = 10
  ) {
    admin {
      organizations(
        name_Icontains: $name
        shortName_Icontains: $shortName
        industry: $industry
        businessType: $businessType
        size_Gte: $sizeGte
        status: $status
        organizationPhone: $phone
        user_Email: $email
        organizationJobPositionId: $jobPositionId
        offset: $offset
        first: $first
      ) {
        edges {
          node {
            id
            logo {
              file
            }
            name
            shortName
            industry {
              title
            }
            email
            contacts {
              value
              type
              id
            }
            size
            status
            employeeCooperationStatusCounts {
              suspended
              resigned
              fired
              finished
              awaiting
              active
            }
            jobPositionsStatusCounts {
              submitted
              drafted
              expired
              published
              suspended
            }
            user {
              id
            }
          }
        }
        totalCount
        pageInfo {
          endCursor
          hasNextPage
          hasPreviousPage
          startCursor
        }
      }
      organizationStatistics {
        blockedCount
        completedCount
        draftedCount
        rejectedCount
        submittedCount
        verifiedCount
        withJobPositionsCount
        totalCount
      }
    }
  }
`;

/**
 * __useGetOrganizationsQuery__
 *
 * To run a query within a React component, call `useGetOrganizationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOrganizationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOrganizationsQuery({
 *   variables: {
 *      industry: // value for 'industry'
 *      name: // value for 'name'
 *      shortName: // value for 'shortName'
 *      businessType: // value for 'businessType'
 *      status: // value for 'status'
 *      sizeGte: // value for 'sizeGte'
 *      phone: // value for 'phone'
 *      email: // value for 'email'
 *      jobPositionId: // value for 'jobPositionId'
 *      offset: // value for 'offset'
 *      first: // value for 'first'
 *   },
 * });
 */
export function useGetOrganizationsQuery(
  baseOptions?: Apollo.QueryHookOptions<GetOrganizationsQuery, GetOrganizationsQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetOrganizationsQuery, GetOrganizationsQueryVariables>(GetOrganizationsDocument, options);
}
export function useGetOrganizationsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetOrganizationsQuery, GetOrganizationsQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetOrganizationsQuery, GetOrganizationsQueryVariables>(GetOrganizationsDocument, options);
}
export function useGetOrganizationsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetOrganizationsQuery, GetOrganizationsQueryVariables>,
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<GetOrganizationsQuery, GetOrganizationsQueryVariables>(
    GetOrganizationsDocument,
    options,
  );
}
export type GetOrganizationsQueryHookResult = ReturnType<typeof useGetOrganizationsQuery>;
export type GetOrganizationsLazyQueryHookResult = ReturnType<typeof useGetOrganizationsLazyQuery>;
export type GetOrganizationsSuspenseQueryHookResult = ReturnType<typeof useGetOrganizationsSuspenseQuery>;
export type GetOrganizationsQueryResult = Apollo.QueryResult<GetOrganizationsQuery, GetOrganizationsQueryVariables>;
export const GetWorkExperienceByIdDocument = gql`
  query GetWorkExperienceById($id: NotEmptyID!) {
    admin {
      workExperience(id: $id) {
        grade
        skills
        allowSelfVerification
        city {
          country {
            id
            name
          }
          id
          name
          region {
            id
            name
          }
        }
        employerlettermethod {
          employerLetter {
            file
          }
          employers {
            email
            id
            name
            phoneNumber
            position
          }
          id
        }
        end
        id
        jobTitle
        organization
        paystubsmethod {
          id
          paystubs {
            file
          }
        }
        start
        status
      }
    }
  }
`;

/**
 * __useGetWorkExperienceByIdQuery__
 *
 * To run a query within a React component, call `useGetWorkExperienceByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetWorkExperienceByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetWorkExperienceByIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetWorkExperienceByIdQuery(
  baseOptions: Apollo.QueryHookOptions<GetWorkExperienceByIdQuery, GetWorkExperienceByIdQueryVariables> &
    ({ variables: GetWorkExperienceByIdQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetWorkExperienceByIdQuery, GetWorkExperienceByIdQueryVariables>(
    GetWorkExperienceByIdDocument,
    options,
  );
}
export function useGetWorkExperienceByIdLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetWorkExperienceByIdQuery, GetWorkExperienceByIdQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetWorkExperienceByIdQuery, GetWorkExperienceByIdQueryVariables>(
    GetWorkExperienceByIdDocument,
    options,
  );
}
export function useGetWorkExperienceByIdSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetWorkExperienceByIdQuery, GetWorkExperienceByIdQueryVariables>,
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<GetWorkExperienceByIdQuery, GetWorkExperienceByIdQueryVariables>(
    GetWorkExperienceByIdDocument,
    options,
  );
}
export type GetWorkExperienceByIdQueryHookResult = ReturnType<typeof useGetWorkExperienceByIdQuery>;
export type GetWorkExperienceByIdLazyQueryHookResult = ReturnType<typeof useGetWorkExperienceByIdLazyQuery>;
export type GetWorkExperienceByIdSuspenseQueryHookResult = ReturnType<typeof useGetWorkExperienceByIdSuspenseQuery>;
export type GetWorkExperienceByIdQueryResult = Apollo.QueryResult<
  GetWorkExperienceByIdQuery,
  GetWorkExperienceByIdQueryVariables
>;
export const GetCitiesDocument = gql`
  query GetCities(
    $first: Int = 10
    $after: String = ""
    $before: String = ""
    $name: String = ""
    $region: ID = ""
    $id: ID
    $country: String = ""
  ) {
    common {
      cities(
        region: $region
        first: $first
        name_Icontains: $name
        after: $after
        before: $before
        id: $id
        country_Code2: $country
      ) {
        edges {
          node {
            id
            name
          }
        }
        pageInfo {
          endCursor
          hasNextPage
          hasPreviousPage
          startCursor
        }
      }
    }
  }
`;

/**
 * __useGetCitiesQuery__
 *
 * To run a query within a React component, call `useGetCitiesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCitiesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCitiesQuery({
 *   variables: {
 *      first: // value for 'first'
 *      after: // value for 'after'
 *      before: // value for 'before'
 *      name: // value for 'name'
 *      region: // value for 'region'
 *      id: // value for 'id'
 *      country: // value for 'country'
 *   },
 * });
 */
export function useGetCitiesQuery(baseOptions?: Apollo.QueryHookOptions<GetCitiesQuery, GetCitiesQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetCitiesQuery, GetCitiesQueryVariables>(GetCitiesDocument, options);
}
export function useGetCitiesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetCitiesQuery, GetCitiesQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetCitiesQuery, GetCitiesQueryVariables>(GetCitiesDocument, options);
}
export function useGetCitiesSuspenseQuery(
  baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCitiesQuery, GetCitiesQueryVariables>,
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<GetCitiesQuery, GetCitiesQueryVariables>(GetCitiesDocument, options);
}
export type GetCitiesQueryHookResult = ReturnType<typeof useGetCitiesQuery>;
export type GetCitiesLazyQueryHookResult = ReturnType<typeof useGetCitiesLazyQuery>;
export type GetCitiesSuspenseQueryHookResult = ReturnType<typeof useGetCitiesSuspenseQuery>;
export type GetCitiesQueryResult = Apollo.QueryResult<GetCitiesQuery, GetCitiesQueryVariables>;
export const GetCountriesDocument = gql`
  query GetCountries($first: Int = 10, $after: String = "", $before: String = "", $name: String = "", $id: ID) {
    common {
      countries(first: $first, name_Icontains: $name, after: $after, before: $before, id: $id) {
        pageInfo {
          endCursor
          hasNextPage
          hasPreviousPage
          startCursor
        }
        edges {
          node {
            name
            id
          }
        }
      }
    }
  }
`;

/**
 * __useGetCountriesQuery__
 *
 * To run a query within a React component, call `useGetCountriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCountriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCountriesQuery({
 *   variables: {
 *      first: // value for 'first'
 *      after: // value for 'after'
 *      before: // value for 'before'
 *      name: // value for 'name'
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetCountriesQuery(
  baseOptions?: Apollo.QueryHookOptions<GetCountriesQuery, GetCountriesQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetCountriesQuery, GetCountriesQueryVariables>(GetCountriesDocument, options);
}
export function useGetCountriesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetCountriesQuery, GetCountriesQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetCountriesQuery, GetCountriesQueryVariables>(GetCountriesDocument, options);
}
export function useGetCountriesSuspenseQuery(
  baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCountriesQuery, GetCountriesQueryVariables>,
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<GetCountriesQuery, GetCountriesQueryVariables>(GetCountriesDocument, options);
}
export type GetCountriesQueryHookResult = ReturnType<typeof useGetCountriesQuery>;
export type GetCountriesLazyQueryHookResult = ReturnType<typeof useGetCountriesLazyQuery>;
export type GetCountriesSuspenseQueryHookResult = ReturnType<typeof useGetCountriesSuspenseQuery>;
export type GetCountriesQueryResult = Apollo.QueryResult<GetCountriesQuery, GetCountriesQueryVariables>;
export const GetIndustriesDocument = gql`
  query GetIndustries {
    common {
      industries {
        edges {
          node {
            id
            title
          }
        }
      }
    }
  }
`;

/**
 * __useGetIndustriesQuery__
 *
 * To run a query within a React component, call `useGetIndustriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetIndustriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetIndustriesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetIndustriesQuery(
  baseOptions?: Apollo.QueryHookOptions<GetIndustriesQuery, GetIndustriesQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetIndustriesQuery, GetIndustriesQueryVariables>(GetIndustriesDocument, options);
}
export function useGetIndustriesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetIndustriesQuery, GetIndustriesQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetIndustriesQuery, GetIndustriesQueryVariables>(GetIndustriesDocument, options);
}
export function useGetIndustriesSuspenseQuery(
  baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetIndustriesQuery, GetIndustriesQueryVariables>,
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<GetIndustriesQuery, GetIndustriesQueryVariables>(GetIndustriesDocument, options);
}
export type GetIndustriesQueryHookResult = ReturnType<typeof useGetIndustriesQuery>;
export type GetIndustriesLazyQueryHookResult = ReturnType<typeof useGetIndustriesLazyQuery>;
export type GetIndustriesSuspenseQueryHookResult = ReturnType<typeof useGetIndustriesSuspenseQuery>;
export type GetIndustriesQueryResult = Apollo.QueryResult<GetIndustriesQuery, GetIndustriesQueryVariables>;
export const GetJobsDocument = gql`
  query GetJobs($first: Int, $after: String, $before: String, $id: ID, $title_Icontains: String) {
    common {
      jobs(first: $first, after: $after, before: $before, id: $id, title_Icontains: $title_Icontains) {
        pageInfo {
          endCursor
          hasNextPage
          hasPreviousPage
          startCursor
        }
        edges {
          node {
            id
            title
          }
        }
      }
    }
  }
`;

/**
 * __useGetJobsQuery__
 *
 * To run a query within a React component, call `useGetJobsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetJobsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetJobsQuery({
 *   variables: {
 *      first: // value for 'first'
 *      after: // value for 'after'
 *      before: // value for 'before'
 *      id: // value for 'id'
 *      title_Icontains: // value for 'title_Icontains'
 *   },
 * });
 */
export function useGetJobsQuery(baseOptions?: Apollo.QueryHookOptions<GetJobsQuery, GetJobsQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetJobsQuery, GetJobsQueryVariables>(GetJobsDocument, options);
}
export function useGetJobsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetJobsQuery, GetJobsQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetJobsQuery, GetJobsQueryVariables>(GetJobsDocument, options);
}
export function useGetJobsSuspenseQuery(
  baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetJobsQuery, GetJobsQueryVariables>,
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<GetJobsQuery, GetJobsQueryVariables>(GetJobsDocument, options);
}
export type GetJobsQueryHookResult = ReturnType<typeof useGetJobsQuery>;
export type GetJobsLazyQueryHookResult = ReturnType<typeof useGetJobsLazyQuery>;
export type GetJobsSuspenseQueryHookResult = ReturnType<typeof useGetJobsSuspenseQuery>;
export type GetJobsQueryResult = Apollo.QueryResult<GetJobsQuery, GetJobsQueryVariables>;
export const GetSkillsDocument = gql`
  query GetSkills(
    $after: String = ""
    $before: String = ""
    $first: Int = 100
    $last: Int = 100
    $title_Icontains: String = ""
  ) {
    common {
      skills(after: $after, before: $before, first: $first, last: $last, title_Icontains: $title_Icontains) {
        edges {
          node {
            id
            title
          }
        }
        pageInfo {
          endCursor
          hasNextPage
          hasPreviousPage
          startCursor
        }
      }
    }
  }
`;

/**
 * __useGetSkillsQuery__
 *
 * To run a query within a React component, call `useGetSkillsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSkillsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSkillsQuery({
 *   variables: {
 *      after: // value for 'after'
 *      before: // value for 'before'
 *      first: // value for 'first'
 *      last: // value for 'last'
 *      title_Icontains: // value for 'title_Icontains'
 *   },
 * });
 */
export function useGetSkillsQuery(baseOptions?: Apollo.QueryHookOptions<GetSkillsQuery, GetSkillsQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetSkillsQuery, GetSkillsQueryVariables>(GetSkillsDocument, options);
}
export function useGetSkillsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetSkillsQuery, GetSkillsQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetSkillsQuery, GetSkillsQueryVariables>(GetSkillsDocument, options);
}
export function useGetSkillsSuspenseQuery(
  baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetSkillsQuery, GetSkillsQueryVariables>,
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<GetSkillsQuery, GetSkillsQueryVariables>(GetSkillsDocument, options);
}
export type GetSkillsQueryHookResult = ReturnType<typeof useGetSkillsQuery>;
export type GetSkillsLazyQueryHookResult = ReturnType<typeof useGetSkillsLazyQuery>;
export type GetSkillsSuspenseQueryHookResult = ReturnType<typeof useGetSkillsSuspenseQuery>;
export type GetSkillsQueryResult = Apollo.QueryResult<GetSkillsQuery, GetSkillsQueryVariables>;
